var xl = Object.create;
var Wr = Object.defineProperty;
var bl = Object.getOwnPropertyDescriptor;
var _l = Object.getOwnPropertyNames;
var El = Object.getPrototypeOf,
  kl = Object.prototype.hasOwnProperty;
var g = (t, e) => () => (e || t((e = {
    exports: {}
  }).exports, e), e.exports),
  rn = (t, e) => {
    for (var s in e) Wr(t, s, {
      get: e[s],
      enumerable: !0
    });
  },
  Sl = (t, e, s, r) => {
    if (e && typeof e == "object" || typeof e == "function") for (let n of _l(e)) !kl.call(t, n) && n !== s && Wr(t, n, {
      get: () => e[n],
      enumerable: !(r = bl(e, n)) || r.enumerable
    });
    return t;
  };
var be = (t, e, s) => (s = t != null ? xl(El(t)) : {}, Sl(e || !t || !t.__esModule ? Wr(s, "default", {
  value: t,
  enumerable: !0
}) : s, t));
var Oi = g((Pv, is) => {
  var _ = String,
    Ti = function () {
      return {
        isColorSupported: !1,
        reset: _,
        bold: _,
        dim: _,
        italic: _,
        underline: _,
        inverse: _,
        hidden: _,
        strikethrough: _,
        black: _,
        red: _,
        green: _,
        yellow: _,
        blue: _,
        magenta: _,
        cyan: _,
        white: _,
        gray: _,
        bgBlack: _,
        bgRed: _,
        bgGreen: _,
        bgYellow: _,
        bgBlue: _,
        bgMagenta: _,
        bgCyan: _,
        bgWhite: _,
        blackBright: _,
        redBright: _,
        greenBright: _,
        yellowBright: _,
        blueBright: _,
        magentaBright: _,
        cyanBright: _,
        whiteBright: _,
        bgBlackBright: _,
        bgRedBright: _,
        bgGreenBright: _,
        bgYellowBright: _,
        bgBlueBright: _,
        bgMagentaBright: _,
        bgCyanBright: _,
        bgWhiteBright: _
      };
    };
  is.exports = Ti();
  is.exports.createColors = Ti;
});
var os = g(() => {});
var Gt = g((qv, Ni) => {
  "use strict";

  var Ci = Oi(),
    Ai = os(),
    at = class t extends Error {
      constructor(e, s, r, n, i, o) {
        super(e), this.name = "CssSyntaxError", this.reason = e, i && (this.file = i), n && (this.source = n), o && (this.plugin = o), typeof s < "u" && typeof r < "u" && (typeof s == "number" ? (this.line = s, this.column = r) : (this.line = s.line, this.column = s.column, this.endLine = r.line, this.endColumn = r.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, t);
      }
      setMessage() {
        this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line < "u" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
      }
      showSourceCode(e) {
        if (!this.source) return "";
        let s = this.source;
        e == null && (e = Ci.isColorSupported);
        let r = f => f,
          n = f => f,
          i = f => f;
        if (e) {
          let {
            bold: f,
            gray: p,
            red: l
          } = Ci.createColors(!0);
          n = d => f(l(d)), r = d => p(d), Ai && (i = d => Ai(d));
        }
        let o = s.split(/\r?\n/),
          u = Math.max(this.line - 3, 0),
          a = Math.min(this.line + 2, o.length),
          c = String(a).length;
        return o.slice(u, a).map((f, p) => {
          let l = u + 1 + p,
            d = " " + (" " + l).slice(-c) + " | ";
          if (l === this.line) {
            if (f.length > 160) {
              let h = 20,
                m = Math.max(0, this.column - h),
                y = Math.max(this.column + h, this.endColumn + h),
                b = f.slice(m, y),
                w = r(d.replace(/\d/g, " ")) + f.slice(0, Math.min(this.column - 1, h - 1)).replace(/[^\t]/g, " ");
              return n(">") + r(d) + i(b) + `
 ` + w + n("^");
            }
            let x = r(d.replace(/\d/g, " ")) + f.slice(0, this.column - 1).replace(/[^\t]/g, " ");
            return n(">") + r(d) + i(f) + `
 ` + x + n("^");
          }
          return " " + r(d) + i(f);
        }).join(`
`);
      }
      toString() {
        let e = this.showSourceCode();
        return e && (e = `

` + e + `
`), this.name + ": " + this.message + e;
      }
    };
  Ni.exports = at;
  at.default = at;
});
var Yt = g((Lv, Ri) => {
  "use strict";

  var Pi = {
    after: `
`,
    beforeClose: `
`,
    beforeComment: `
`,
    beforeDecl: `
`,
    beforeOpen: " ",
    beforeRule: `
`,
    colon: ": ",
    commentLeft: " ",
    commentRight: " ",
    emptyBody: "",
    indent: "    ",
    semicolon: !1
  };
  function Sc(t) {
    return t[0].toUpperCase() + t.slice(1);
  }
  var ut = class {
    constructor(e) {
      this.builder = e;
    }
    atrule(e, s) {
      let r = "@" + e.name,
        n = e.params ? this.rawValue(e, "params") : "";
      if (typeof e.raws.afterName < "u" ? r += e.raws.afterName : n && (r += " "), e.nodes) this.block(e, r + n);else {
        let i = (e.raws.between || "") + (s ? ";" : "");
        this.builder(r + n + i, e);
      }
    }
    beforeAfter(e, s) {
      let r;
      e.type === "decl" ? r = this.raw(e, null, "beforeDecl") : e.type === "comment" ? r = this.raw(e, null, "beforeComment") : s === "before" ? r = this.raw(e, null, "beforeRule") : r = this.raw(e, null, "beforeClose");
      let n = e.parent,
        i = 0;
      for (; n && n.type !== "root";) i += 1, n = n.parent;
      if (r.includes(`
`)) {
        let o = this.raw(e, null, "indent");
        if (o.length) for (let u = 0; u < i; u++) r += o;
      }
      return r;
    }
    block(e, s) {
      let r = this.raw(e, "between", "beforeOpen");
      this.builder(s + r + "{", e, "start");
      let n;
      e.nodes && e.nodes.length ? (this.body(e), n = this.raw(e, "after")) : n = this.raw(e, "after", "emptyBody"), n && this.builder(n), this.builder("}", e, "end");
    }
    body(e) {
      let s = e.nodes.length - 1;
      for (; s > 0 && e.nodes[s].type === "comment";) s -= 1;
      let r = this.raw(e, "semicolon");
      for (let n = 0; n < e.nodes.length; n++) {
        let i = e.nodes[n],
          o = this.raw(i, "before");
        o && this.builder(o), this.stringify(i, s !== n || r);
      }
    }
    comment(e) {
      let s = this.raw(e, "left", "commentLeft"),
        r = this.raw(e, "right", "commentRight");
      this.builder("/*" + s + e.text + r + "*/", e);
    }
    decl(e, s) {
      let r = this.raw(e, "between", "colon"),
        n = e.prop + r + this.rawValue(e, "value");
      e.important && (n += e.raws.important || " !important"), s && (n += ";"), this.builder(n, e);
    }
    document(e) {
      this.body(e);
    }
    raw(e, s, r) {
      let n;
      if (r || (r = s), s && (n = e.raws[s], typeof n < "u")) return n;
      let i = e.parent;
      if (r === "before" && (!i || i.type === "root" && i.first === e || i && i.type === "document")) return "";
      if (!i) return Pi[r];
      let o = e.root();
      if (o.rawCache || (o.rawCache = {}), typeof o.rawCache[r] < "u") return o.rawCache[r];
      if (r === "before" || r === "after") return this.beforeAfter(e, r);
      {
        let u = "raw" + Sc(r);
        this[u] ? n = this[u](o, e) : o.walk(a => {
          if (n = a.raws[s], typeof n < "u") return !1;
        });
      }
      return typeof n > "u" && (n = Pi[r]), o.rawCache[r] = n, n;
    }
    rawBeforeClose(e) {
      let s;
      return e.walk(r => {
        if (r.nodes && r.nodes.length > 0 && typeof r.raws.after < "u") return s = r.raws.after, s.includes(`
`) && (s = s.replace(/[^\n]+$/, "")), !1;
      }), s && (s = s.replace(/\S/g, "")), s;
    }
    rawBeforeComment(e, s) {
      let r;
      return e.walkComments(n => {
        if (typeof n.raws.before < "u") return r = n.raws.before, r.includes(`
`) && (r = r.replace(/[^\n]+$/, "")), !1;
      }), typeof r > "u" ? r = this.raw(s, null, "beforeDecl") : r && (r = r.replace(/\S/g, "")), r;
    }
    rawBeforeDecl(e, s) {
      let r;
      return e.walkDecls(n => {
        if (typeof n.raws.before < "u") return r = n.raws.before, r.includes(`
`) && (r = r.replace(/[^\n]+$/, "")), !1;
      }), typeof r > "u" ? r = this.raw(s, null, "beforeRule") : r && (r = r.replace(/\S/g, "")), r;
    }
    rawBeforeOpen(e) {
      let s;
      return e.walk(r => {
        if (r.type !== "decl" && (s = r.raws.between, typeof s < "u")) return !1;
      }), s;
    }
    rawBeforeRule(e) {
      let s;
      return e.walk(r => {
        if (r.nodes && (r.parent !== e || e.first !== r) && typeof r.raws.before < "u") return s = r.raws.before, s.includes(`
`) && (s = s.replace(/[^\n]+$/, "")), !1;
      }), s && (s = s.replace(/\S/g, "")), s;
    }
    rawColon(e) {
      let s;
      return e.walkDecls(r => {
        if (typeof r.raws.between < "u") return s = r.raws.between.replace(/[^\s:]/g, ""), !1;
      }), s;
    }
    rawEmptyBody(e) {
      let s;
      return e.walk(r => {
        if (r.nodes && r.nodes.length === 0 && (s = r.raws.after, typeof s < "u")) return !1;
      }), s;
    }
    rawIndent(e) {
      if (e.raws.indent) return e.raws.indent;
      let s;
      return e.walk(r => {
        let n = r.parent;
        if (n && n !== e && n.parent && n.parent === e && typeof r.raws.before < "u") {
          let i = r.raws.before.split(`
`);
          return s = i[i.length - 1], s = s.replace(/\S/g, ""), !1;
        }
      }), s;
    }
    rawSemicolon(e) {
      let s;
      return e.walk(r => {
        if (r.nodes && r.nodes.length && r.last.type === "decl" && (s = r.raws.semicolon, typeof s < "u")) return !1;
      }), s;
    }
    rawValue(e, s) {
      let r = e[s],
        n = e.raws[s];
      return n && n.value === r ? n.raw : r;
    }
    root(e) {
      this.body(e), e.raws.after && this.builder(e.raws.after);
    }
    rule(e) {
      this.block(e, this.rawValue(e, "selector")), e.raws.ownSemicolon && this.builder(e.raws.ownSemicolon, e, "end");
    }
    stringify(e, s) {
      if (!this[e.type]) throw new Error("Unknown AST node type " + e.type + ". Maybe you need to change PostCSS stringifier.");
      this[e.type](e, s);
    }
  };
  Ri.exports = ut;
  ut.default = ut;
});
var lt = g((Dv, Ii) => {
  "use strict";

  var Tc = Yt();
  function as(t, e) {
    new Tc(e).stringify(t);
  }
  Ii.exports = as;
  as.default = as;
});
var Vt = g((Mv, us) => {
  "use strict";

  us.exports.isClean = Symbol("isClean");
  us.exports.my = Symbol("my");
});
var pt = g((Bv, qi) => {
  "use strict";

  var Oc = Gt(),
    Cc = Yt(),
    Ac = lt(),
    {
      isClean: ct,
      my: Nc
    } = Vt();
  function ls(t, e) {
    let s = new t.constructor();
    for (let r in t) {
      if (!Object.prototype.hasOwnProperty.call(t, r) || r === "proxyCache") continue;
      let n = t[r],
        i = typeof n;
      r === "parent" && i === "object" ? e && (s[r] = e) : r === "source" ? s[r] = n : Array.isArray(n) ? s[r] = n.map(o => ls(o, s)) : (i === "object" && n !== null && (n = ls(n)), s[r] = n);
    }
    return s;
  }
  function J(t, e) {
    if (e && typeof e.offset < "u") return e.offset;
    let s = 1,
      r = 1,
      n = 0;
    for (let i = 0; i < t.length; i++) {
      if (r === e.line && s === e.column) {
        n = i;
        break;
      }
      t[i] === `
` ? (s = 1, r += 1) : s += 1;
    }
    return n;
  }
  var ft = class {
    get proxyOf() {
      return this;
    }
    constructor(e = {}) {
      this.raws = {}, this[ct] = !1, this[Nc] = !0;
      for (let s in e) if (s === "nodes") {
        this.nodes = [];
        for (let r of e[s]) typeof r.clone == "function" ? this.append(r.clone()) : this.append(r);
      } else this[s] = e[s];
    }
    addToError(e) {
      if (e.postcssNode = this, e.stack && this.source && /\n\s{4}at /.test(e.stack)) {
        let s = this.source;
        e.stack = e.stack.replace(/\n\s{4}at /, `$&${s.input.from}:${s.start.line}:${s.start.column}$&`);
      }
      return e;
    }
    after(e) {
      return this.parent.insertAfter(this, e), this;
    }
    assign(e = {}) {
      for (let s in e) this[s] = e[s];
      return this;
    }
    before(e) {
      return this.parent.insertBefore(this, e), this;
    }
    cleanRaws(e) {
      delete this.raws.before, delete this.raws.after, e || delete this.raws.between;
    }
    clone(e = {}) {
      let s = ls(this);
      for (let r in e) s[r] = e[r];
      return s;
    }
    cloneAfter(e = {}) {
      let s = this.clone(e);
      return this.parent.insertAfter(this, s), s;
    }
    cloneBefore(e = {}) {
      let s = this.clone(e);
      return this.parent.insertBefore(this, s), s;
    }
    error(e, s = {}) {
      if (this.source) {
        let {
          end: r,
          start: n
        } = this.rangeBy(s);
        return this.source.input.error(e, {
          column: n.column,
          line: n.line
        }, {
          column: r.column,
          line: r.line
        }, s);
      }
      return new Oc(e);
    }
    getProxyProcessor() {
      return {
        get(e, s) {
          return s === "proxyOf" ? e : s === "root" ? () => e.root().toProxy() : e[s];
        },
        set(e, s, r) {
          return e[s] === r || (e[s] = r, (s === "prop" || s === "value" || s === "name" || s === "params" || s === "important" || s === "text") && e.markDirty()), !0;
        }
      };
    }
    markClean() {
      this[ct] = !0;
    }
    markDirty() {
      if (this[ct]) {
        this[ct] = !1;
        let e = this;
        for (; e = e.parent;) e[ct] = !1;
      }
    }
    next() {
      if (!this.parent) return;
      let e = this.parent.index(this);
      return this.parent.nodes[e + 1];
    }
    positionBy(e = {}) {
      let s = this.source.start;
      if (e.index) s = this.positionInside(e.index);else if (e.word) {
        let r = "document" in this.source.input ? this.source.input.document : this.source.input.css,
          i = r.slice(J(r, this.source.start), J(r, this.source.end)).indexOf(e.word);
        i !== -1 && (s = this.positionInside(i));
      }
      return s;
    }
    positionInside(e) {
      let s = this.source.start.column,
        r = this.source.start.line,
        n = "document" in this.source.input ? this.source.input.document : this.source.input.css,
        i = J(n, this.source.start),
        o = i + e;
      for (let u = i; u < o; u++) n[u] === `
` ? (s = 1, r += 1) : s += 1;
      return {
        column: s,
        line: r,
        offset: o
      };
    }
    prev() {
      if (!this.parent) return;
      let e = this.parent.index(this);
      return this.parent.nodes[e - 1];
    }
    rangeBy(e = {}) {
      let s = "document" in this.source.input ? this.source.input.document : this.source.input.css,
        r = {
          column: this.source.start.column,
          line: this.source.start.line,
          offset: J(s, this.source.start)
        },
        n = this.source.end ? {
          column: this.source.end.column + 1,
          line: this.source.end.line,
          offset: typeof this.source.end.offset == "number" ? this.source.end.offset : J(s, this.source.end) + 1
        } : {
          column: r.column + 1,
          line: r.line,
          offset: r.offset + 1
        };
      if (e.word) {
        let o = s.slice(J(s, this.source.start), J(s, this.source.end)).indexOf(e.word);
        o !== -1 && (r = this.positionInside(o), n = this.positionInside(o + e.word.length));
      } else e.start ? r = {
        column: e.start.column,
        line: e.start.line,
        offset: J(s, e.start)
      } : e.index && (r = this.positionInside(e.index)), e.end ? n = {
        column: e.end.column,
        line: e.end.line,
        offset: J(s, e.end)
      } : typeof e.endIndex == "number" ? n = this.positionInside(e.endIndex) : e.index && (n = this.positionInside(e.index + 1));
      return (n.line < r.line || n.line === r.line && n.column <= r.column) && (n = {
        column: r.column + 1,
        line: r.line,
        offset: r.offset + 1
      }), {
        end: n,
        start: r
      };
    }
    raw(e, s) {
      return new Cc().raw(this, e, s);
    }
    remove() {
      return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
    }
    replaceWith(...e) {
      if (this.parent) {
        let s = this,
          r = !1;
        for (let n of e) n === this ? r = !0 : r ? (this.parent.insertAfter(s, n), s = n) : this.parent.insertBefore(s, n);
        r || this.remove();
      }
      return this;
    }
    root() {
      let e = this;
      for (; e.parent && e.parent.type !== "document";) e = e.parent;
      return e;
    }
    toJSON(e, s) {
      let r = {},
        n = s == null;
      s = s || new Map();
      let i = 0;
      for (let o in this) {
        if (!Object.prototype.hasOwnProperty.call(this, o) || o === "parent" || o === "proxyCache") continue;
        let u = this[o];
        if (Array.isArray(u)) r[o] = u.map(a => typeof a == "object" && a.toJSON ? a.toJSON(null, s) : a);else if (typeof u == "object" && u.toJSON) r[o] = u.toJSON(null, s);else if (o === "source") {
          if (u == null) continue;
          let a = s.get(u.input);
          a == null && (a = i, s.set(u.input, i), i++), r[o] = {
            end: u.end,
            inputId: a,
            start: u.start
          };
        } else r[o] = u;
      }
      return n && (r.inputs = [...s.keys()].map(o => o.toJSON())), r;
    }
    toProxy() {
      return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
    }
    toString(e = Ac) {
      e.stringify && (e = e.stringify);
      let s = "";
      return e(this, r => {
        s += r;
      }), s;
    }
    warn(e, s, r = {}) {
      let n = {
        node: this
      };
      for (let i in r) n[i] = r[i];
      return e.warn(s, n);
    }
  };
  qi.exports = ft;
  ft.default = ft;
});
var qe = g((Uv, Li) => {
  "use strict";

  var Pc = pt(),
    ht = class extends Pc {
      constructor(e) {
        super(e), this.type = "comment";
      }
    };
  Li.exports = ht;
  ht.default = ht;
});
var mt = g((Fv, Di) => {
  "use strict";

  var Rc = pt(),
    dt = class extends Rc {
      get variable() {
        return this.prop.startsWith("--") || this.prop[0] === "$";
      }
      constructor(e) {
        e && typeof e.value < "u" && typeof e.value != "string" && (e = {
          ...e,
          value: String(e.value)
        }), super(e), this.type = "decl";
      }
    };
  Di.exports = dt;
  dt.default = dt;
});
var le = g(($v, Vi) => {
  "use strict";

  var Mi = qe(),
    Bi = mt(),
    Ic = pt(),
    {
      isClean: Ui,
      my: Fi
    } = Vt(),
    cs,
    $i,
    Wi,
    fs;
  function Gi(t) {
    return t.map(e => (e.nodes && (e.nodes = Gi(e.nodes)), delete e.source, e));
  }
  function Yi(t) {
    if (t[Ui] = !1, t.proxyOf.nodes) for (let e of t.proxyOf.nodes) Yi(e);
  }
  var V = class t extends Ic {
    get first() {
      if (this.proxyOf.nodes) return this.proxyOf.nodes[0];
    }
    get last() {
      if (this.proxyOf.nodes) return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
    }
    append(...e) {
      for (let s of e) {
        let r = this.normalize(s, this.last);
        for (let n of r) this.proxyOf.nodes.push(n);
      }
      return this.markDirty(), this;
    }
    cleanRaws(e) {
      if (super.cleanRaws(e), this.nodes) for (let s of this.nodes) s.cleanRaws(e);
    }
    each(e) {
      if (!this.proxyOf.nodes) return;
      let s = this.getIterator(),
        r,
        n;
      for (; this.indexes[s] < this.proxyOf.nodes.length && (r = this.indexes[s], n = e(this.proxyOf.nodes[r], r), n !== !1);) this.indexes[s] += 1;
      return delete this.indexes[s], n;
    }
    every(e) {
      return this.nodes.every(e);
    }
    getIterator() {
      this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
      let e = this.lastEach;
      return this.indexes[e] = 0, e;
    }
    getProxyProcessor() {
      return {
        get(e, s) {
          return s === "proxyOf" ? e : e[s] ? s === "each" || typeof s == "string" && s.startsWith("walk") ? (...r) => e[s](...r.map(n => typeof n == "function" ? (i, o) => n(i.toProxy(), o) : n)) : s === "every" || s === "some" ? r => e[s]((n, ...i) => r(n.toProxy(), ...i)) : s === "root" ? () => e.root().toProxy() : s === "nodes" ? e.nodes.map(r => r.toProxy()) : s === "first" || s === "last" ? e[s].toProxy() : e[s] : e[s];
        },
        set(e, s, r) {
          return e[s] === r || (e[s] = r, (s === "name" || s === "params" || s === "selector") && e.markDirty()), !0;
        }
      };
    }
    index(e) {
      return typeof e == "number" ? e : (e.proxyOf && (e = e.proxyOf), this.proxyOf.nodes.indexOf(e));
    }
    insertAfter(e, s) {
      let r = this.index(e),
        n = this.normalize(s, this.proxyOf.nodes[r]).reverse();
      r = this.index(e);
      for (let o of n) this.proxyOf.nodes.splice(r + 1, 0, o);
      let i;
      for (let o in this.indexes) i = this.indexes[o], r < i && (this.indexes[o] = i + n.length);
      return this.markDirty(), this;
    }
    insertBefore(e, s) {
      let r = this.index(e),
        n = r === 0 ? "prepend" : !1,
        i = this.normalize(s, this.proxyOf.nodes[r], n).reverse();
      r = this.index(e);
      for (let u of i) this.proxyOf.nodes.splice(r, 0, u);
      let o;
      for (let u in this.indexes) o = this.indexes[u], r <= o && (this.indexes[u] = o + i.length);
      return this.markDirty(), this;
    }
    normalize(e, s) {
      if (typeof e == "string") e = Gi($i(e).nodes);else if (typeof e > "u") e = [];else if (Array.isArray(e)) {
        e = e.slice(0);
        for (let n of e) n.parent && n.parent.removeChild(n, "ignore");
      } else if (e.type === "root" && this.type !== "document") {
        e = e.nodes.slice(0);
        for (let n of e) n.parent && n.parent.removeChild(n, "ignore");
      } else if (e.type) e = [e];else if (e.prop) {
        if (typeof e.value > "u") throw new Error("Value field is missed in node creation");
        typeof e.value != "string" && (e.value = String(e.value)), e = [new Bi(e)];
      } else if (e.selector || e.selectors) e = [new fs(e)];else if (e.name) e = [new cs(e)];else if (e.text) e = [new Mi(e)];else throw new Error("Unknown node type in node creation");
      return e.map(n => (n[Fi] || t.rebuild(n), n = n.proxyOf, n.parent && n.parent.removeChild(n), n[Ui] && Yi(n), n.raws || (n.raws = {}), typeof n.raws.before > "u" && s && typeof s.raws.before < "u" && (n.raws.before = s.raws.before.replace(/\S/g, "")), n.parent = this.proxyOf, n));
    }
    prepend(...e) {
      e = e.reverse();
      for (let s of e) {
        let r = this.normalize(s, this.first, "prepend").reverse();
        for (let n of r) this.proxyOf.nodes.unshift(n);
        for (let n in this.indexes) this.indexes[n] = this.indexes[n] + r.length;
      }
      return this.markDirty(), this;
    }
    push(e) {
      return e.parent = this, this.proxyOf.nodes.push(e), this;
    }
    removeAll() {
      for (let e of this.proxyOf.nodes) e.parent = void 0;
      return this.proxyOf.nodes = [], this.markDirty(), this;
    }
    removeChild(e) {
      e = this.index(e), this.proxyOf.nodes[e].parent = void 0, this.proxyOf.nodes.splice(e, 1);
      let s;
      for (let r in this.indexes) s = this.indexes[r], s >= e && (this.indexes[r] = s - 1);
      return this.markDirty(), this;
    }
    replaceValues(e, s, r) {
      return r || (r = s, s = {}), this.walkDecls(n => {
        s.props && !s.props.includes(n.prop) || s.fast && !n.value.includes(s.fast) || (n.value = n.value.replace(e, r));
      }), this.markDirty(), this;
    }
    some(e) {
      return this.nodes.some(e);
    }
    walk(e) {
      return this.each((s, r) => {
        let n;
        try {
          n = e(s, r);
        } catch (i) {
          throw s.addToError(i);
        }
        return n !== !1 && s.walk && (n = s.walk(e)), n;
      });
    }
    walkAtRules(e, s) {
      return s ? e instanceof RegExp ? this.walk((r, n) => {
        if (r.type === "atrule" && e.test(r.name)) return s(r, n);
      }) : this.walk((r, n) => {
        if (r.type === "atrule" && r.name === e) return s(r, n);
      }) : (s = e, this.walk((r, n) => {
        if (r.type === "atrule") return s(r, n);
      }));
    }
    walkComments(e) {
      return this.walk((s, r) => {
        if (s.type === "comment") return e(s, r);
      });
    }
    walkDecls(e, s) {
      return s ? e instanceof RegExp ? this.walk((r, n) => {
        if (r.type === "decl" && e.test(r.prop)) return s(r, n);
      }) : this.walk((r, n) => {
        if (r.type === "decl" && r.prop === e) return s(r, n);
      }) : (s = e, this.walk((r, n) => {
        if (r.type === "decl") return s(r, n);
      }));
    }
    walkRules(e, s) {
      return s ? e instanceof RegExp ? this.walk((r, n) => {
        if (r.type === "rule" && e.test(r.selector)) return s(r, n);
      }) : this.walk((r, n) => {
        if (r.type === "rule" && r.selector === e) return s(r, n);
      }) : (s = e, this.walk((r, n) => {
        if (r.type === "rule") return s(r, n);
      }));
    }
  };
  V.registerParse = t => {
    $i = t;
  };
  V.registerRule = t => {
    fs = t;
  };
  V.registerAtRule = t => {
    cs = t;
  };
  V.registerRoot = t => {
    Wi = t;
  };
  Vi.exports = V;
  V.default = V;
  V.rebuild = t => {
    t.type === "atrule" ? Object.setPrototypeOf(t, cs.prototype) : t.type === "rule" ? Object.setPrototypeOf(t, fs.prototype) : t.type === "decl" ? Object.setPrototypeOf(t, Bi.prototype) : t.type === "comment" ? Object.setPrototypeOf(t, Mi.prototype) : t.type === "root" && Object.setPrototypeOf(t, Wi.prototype), t[Fi] = !0, t.nodes && t.nodes.forEach(e => {
      V.rebuild(e);
    });
  };
});
var Hi = g((Wv, zi) => {
  var qc = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict",
    Lc = (t, e = 21) => (s = e) => {
      let r = "",
        n = s | 0;
      for (; n--;) r += t[Math.random() * t.length | 0];
      return r;
    },
    Dc = (t = 21) => {
      let e = "",
        s = t | 0;
      for (; s--;) e += qc[Math.random() * 64 | 0];
      return e;
    };
  zi.exports = {
    nanoid: Dc,
    customAlphabet: Lc
  };
});
var ji = g(() => {});
var ps = g((Vv, Ki) => {
  Ki.exports = class {};
});
var De = g((Hv, eo) => {
  "use strict";

  var {
      nanoid: Mc
    } = Hi(),
    {
      isAbsolute: ms,
      resolve: ys
    } = {},
    {
      SourceMapConsumer: Bc,
      SourceMapGenerator: Uc
    } = ji(),
    {
      fileURLToPath: Qi,
      pathToFileURL: zt
    } = {},
    Xi = Gt(),
    Fc = ps(),
    hs = os(),
    ds = Symbol("lineToIndexCache"),
    $c = !!(Bc && Uc),
    Ji = !!(ys && ms);
  function Zi(t) {
    if (t[ds]) return t[ds];
    let e = t.css.split(`
`),
      s = new Array(e.length),
      r = 0;
    for (let n = 0, i = e.length; n < i; n++) s[n] = r, r += e[n].length + 1;
    return t[ds] = s, s;
  }
  var Le = class {
    get from() {
      return this.file || this.id;
    }
    constructor(e, s = {}) {
      if (e === null || typeof e > "u" || typeof e == "object" && !e.toString) throw new Error(`PostCSS received ${e} instead of CSS string`);
      if (this.css = e.toString(), this.css[0] === "\uFEFF" || this.css[0] === "\uFFFE" ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, this.document = this.css, s.document && (this.document = s.document.toString()), s.from && (!Ji || /^\w+:\/\//.test(s.from) || ms(s.from) ? this.file = s.from : this.file = ys(s.from)), Ji && $c) {
        let r = new Fc(this.css, s);
        if (r.text) {
          this.map = r;
          let n = r.consumer().file;
          !this.file && n && (this.file = this.mapResolve(n));
        }
      }
      this.file || (this.id = "<input css " + Mc(6) + ">"), this.map && (this.map.file = this.from);
    }
    error(e, s, r, n = {}) {
      let i, o, u, a, c;
      if (s && typeof s == "object") {
        let p = s,
          l = r;
        if (typeof p.offset == "number") {
          a = p.offset;
          let d = this.fromOffset(a);
          s = d.line, r = d.col;
        } else s = p.line, r = p.column, a = this.fromLineAndColumn(s, r);
        if (typeof l.offset == "number") {
          u = l.offset;
          let d = this.fromOffset(u);
          o = d.line, i = d.col;
        } else o = l.line, i = l.column, u = this.fromLineAndColumn(l.line, l.column);
      } else if (r) a = this.fromLineAndColumn(s, r);else {
        a = s;
        let p = this.fromOffset(a);
        s = p.line, r = p.col;
      }
      let f = this.origin(s, r, o, i);
      return f ? c = new Xi(e, f.endLine === void 0 ? f.line : {
        column: f.column,
        line: f.line
      }, f.endLine === void 0 ? f.column : {
        column: f.endColumn,
        line: f.endLine
      }, f.source, f.file, n.plugin) : c = new Xi(e, o === void 0 ? s : {
        column: r,
        line: s
      }, o === void 0 ? r : {
        column: i,
        line: o
      }, this.css, this.file, n.plugin), c.input = {
        column: r,
        endColumn: i,
        endLine: o,
        endOffset: u,
        line: s,
        offset: a,
        source: this.css
      }, this.file && (zt && (c.input.url = zt(this.file).toString()), c.input.file = this.file), c;
    }
    fromLineAndColumn(e, s) {
      return Zi(this)[e - 1] + s - 1;
    }
    fromOffset(e) {
      let s = Zi(this),
        r = s[s.length - 1],
        n = 0;
      if (e >= r) n = s.length - 1;else {
        let i = s.length - 2,
          o;
        for (; n < i;) if (o = n + (i - n >> 1), e < s[o]) i = o - 1;else if (e >= s[o + 1]) n = o + 1;else {
          n = o;
          break;
        }
      }
      return {
        col: e - s[n] + 1,
        line: n + 1
      };
    }
    mapResolve(e) {
      return /^\w+:\/\//.test(e) ? e : ys(this.map.consumer().sourceRoot || this.map.root || ".", e);
    }
    origin(e, s, r, n) {
      if (!this.map) return !1;
      let i = this.map.consumer(),
        o = i.originalPositionFor({
          column: s,
          line: e
        });
      if (!o.source) return !1;
      let u;
      typeof r == "number" && (u = i.originalPositionFor({
        column: n,
        line: r
      }));
      let a;
      ms(o.source) ? a = zt(o.source) : a = new URL(o.source, this.map.consumer().sourceRoot || zt(this.map.mapFile));
      let c = {
        column: o.column,
        endColumn: u && u.column,
        endLine: u && u.line,
        line: o.line,
        url: a.toString()
      };
      if (a.protocol === "file:") if (Qi) c.file = Qi(a);else throw new Error("file: protocol is not available in this PostCSS build");
      let f = i.sourceContentFor(o.source);
      return f && (c.source = f), c;
    }
    toJSON() {
      let e = {};
      for (let s of ["hasBOM", "css", "file", "id"]) this[s] != null && (e[s] = this[s]);
      return this.map && (e.map = {
        ...this.map
      }, e.map.consumerCache && (e.map.consumerCache = void 0)), e;
    }
  };
  eo.exports = Le;
  Le.default = Le;
  hs && hs.registerInput && hs.registerInput(Le);
});
var Ht = g((jv, ro) => {
  "use strict";

  var to = le(),
    Me = class extends to {
      constructor(e) {
        super(e), this.type = "atrule";
      }
      append(...e) {
        return this.proxyOf.nodes || (this.nodes = []), super.append(...e);
      }
      prepend(...e) {
        return this.proxyOf.nodes || (this.nodes = []), super.prepend(...e);
      }
    };
  ro.exports = Me;
  Me.default = Me;
  to.registerAtRule(Me);
});
var Be = g((Kv, oo) => {
  "use strict";

  var so = le(),
    no,
    io,
    ce = class extends so {
      constructor(e) {
        super(e), this.type = "root", this.nodes || (this.nodes = []);
      }
      normalize(e, s, r) {
        let n = super.normalize(e);
        if (s) {
          if (r === "prepend") this.nodes.length > 1 ? s.raws.before = this.nodes[1].raws.before : delete s.raws.before;else if (this.first !== s) for (let i of n) i.raws.before = s.raws.before;
        }
        return n;
      }
      removeChild(e, s) {
        let r = this.index(e);
        return !s && r === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[r].raws.before), super.removeChild(e);
      }
      toResult(e = {}) {
        return new no(new io(), this, e).stringify();
      }
    };
  ce.registerLazyResult = t => {
    no = t;
  };
  ce.registerProcessor = t => {
    io = t;
  };
  oo.exports = ce;
  ce.default = ce;
  so.registerRoot(ce);
});
var gs = g((Qv, ao) => {
  "use strict";

  var yt = {
    comma(t) {
      return yt.split(t, [","], !0);
    },
    space(t) {
      let e = [" ", `
`, "	"];
      return yt.split(t, e);
    },
    split(t, e, s) {
      let r = [],
        n = "",
        i = !1,
        o = 0,
        u = !1,
        a = "",
        c = !1;
      for (let f of t) c ? c = !1 : f === "\\" ? c = !0 : u ? f === a && (u = !1) : f === '"' || f === "'" ? (u = !0, a = f) : f === "(" ? o += 1 : f === ")" ? o > 0 && (o -= 1) : o === 0 && e.includes(f) && (i = !0), i ? (n !== "" && r.push(n.trim()), n = "", i = !1) : n += f;
      return (s || n !== "") && r.push(n.trim()), r;
    }
  };
  ao.exports = yt;
  yt.default = yt;
});
var jt = g((Xv, lo) => {
  "use strict";

  var uo = le(),
    Wc = gs(),
    Ue = class extends uo {
      get selectors() {
        return Wc.comma(this.selector);
      }
      set selectors(e) {
        let s = this.selector ? this.selector.match(/,\s*/) : null,
          r = s ? s[0] : "," + this.raw("between", "beforeOpen");
        this.selector = e.join(r);
      }
      constructor(e) {
        super(e), this.type = "rule", this.nodes || (this.nodes = []);
      }
    };
  lo.exports = Ue;
  Ue.default = Ue;
  uo.registerRule(Ue);
});
var Xt = g((Jv, fo) => {
  "use strict";

  var Kt = /[\t\n\f\r "#'()/;[\\\]{}]/g,
    Qt = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g,
    Gc = /.[\r\n"'(/\\]/,
    co = /[\da-f]/i;
  fo.exports = function (e, s = {}) {
    let r = e.css.valueOf(),
      n = s.ignoreErrors,
      i,
      o,
      u,
      a,
      c,
      f,
      p,
      l,
      d,
      x,
      h = r.length,
      m = 0,
      y = [],
      b = [];
    function w() {
      return m;
    }
    function v(W) {
      throw e.error("Unclosed " + W, m);
    }
    function R() {
      return b.length === 0 && m >= h;
    }
    function F(W) {
      if (b.length) return b.pop();
      if (m >= h) return;
      let T = W ? W.ignoreUnclosed : !1;
      switch (i = r.charCodeAt(m), i) {
        case 10:
        case 32:
        case 9:
        case 13:
        case 12:
          {
            a = m;
            do a += 1, i = r.charCodeAt(a); while (i === 32 || i === 10 || i === 9 || i === 13 || i === 12);
            f = ["space", r.slice(m, a)], m = a - 1;
            break;
          }
        case 91:
        case 93:
        case 123:
        case 125:
        case 58:
        case 59:
        case 41:
          {
            let O = String.fromCharCode(i);
            f = [O, O, m];
            break;
          }
        case 40:
          {
            if (x = y.length ? y.pop()[1] : "", d = r.charCodeAt(m + 1), x === "url" && d !== 39 && d !== 34 && d !== 32 && d !== 10 && d !== 9 && d !== 12 && d !== 13) {
              a = m;
              do {
                if (p = !1, a = r.indexOf(")", a + 1), a === -1) if (n || T) {
                  a = m;
                  break;
                } else v("bracket");
                for (l = a; r.charCodeAt(l - 1) === 92;) l -= 1, p = !p;
              } while (p);
              f = ["brackets", r.slice(m, a + 1), m, a], m = a;
            } else a = r.indexOf(")", m + 1), o = r.slice(m, a + 1), a === -1 || Gc.test(o) ? f = ["(", "(", m] : (f = ["brackets", o, m, a], m = a);
            break;
          }
        case 39:
        case 34:
          {
            c = i === 39 ? "'" : '"', a = m;
            do {
              if (p = !1, a = r.indexOf(c, a + 1), a === -1) if (n || T) {
                a = m + 1;
                break;
              } else v("string");
              for (l = a; r.charCodeAt(l - 1) === 92;) l -= 1, p = !p;
            } while (p);
            f = ["string", r.slice(m, a + 1), m, a], m = a;
            break;
          }
        case 64:
          {
            Kt.lastIndex = m + 1, Kt.test(r), Kt.lastIndex === 0 ? a = r.length - 1 : a = Kt.lastIndex - 2, f = ["at-word", r.slice(m, a + 1), m, a], m = a;
            break;
          }
        case 92:
          {
            for (a = m, u = !0; r.charCodeAt(a + 1) === 92;) a += 1, u = !u;
            if (i = r.charCodeAt(a + 1), u && i !== 47 && i !== 32 && i !== 10 && i !== 9 && i !== 13 && i !== 12 && (a += 1, co.test(r.charAt(a)))) {
              for (; co.test(r.charAt(a + 1));) a += 1;
              r.charCodeAt(a + 1) === 32 && (a += 1);
            }
            f = ["word", r.slice(m, a + 1), m, a], m = a;
            break;
          }
        default:
          {
            i === 47 && r.charCodeAt(m + 1) === 42 ? (a = r.indexOf("*/", m + 2) + 1, a === 0 && (n || T ? a = r.length : v("comment")), f = ["comment", r.slice(m, a + 1), m, a], m = a) : (Qt.lastIndex = m + 1, Qt.test(r), Qt.lastIndex === 0 ? a = r.length - 1 : a = Qt.lastIndex - 2, f = ["word", r.slice(m, a + 1), m, a], y.push(f), m = a);
            break;
          }
      }
      return m++, f;
    }
    function Q(W) {
      b.push(W);
    }
    return {
      back: Q,
      endOfFile: R,
      nextToken: F,
      position: w
    };
  };
});
var Jt = g((Zv, mo) => {
  "use strict";

  var Yc = Ht(),
    Vc = qe(),
    zc = mt(),
    Hc = Be(),
    po = jt(),
    jc = Xt(),
    ho = {
      empty: !0,
      space: !0
    };
  function Kc(t) {
    for (let e = t.length - 1; e >= 0; e--) {
      let s = t[e],
        r = s[3] || s[2];
      if (r) return r;
    }
  }
  var ws = class {
    constructor(e) {
      this.input = e, this.root = new Hc(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.createTokenizer(), this.root.source = {
        input: e,
        start: {
          column: 1,
          line: 1,
          offset: 0
        }
      };
    }
    atrule(e) {
      let s = new Yc();
      s.name = e[1].slice(1), s.name === "" && this.unnamedAtrule(s, e), this.init(s, e[2]);
      let r,
        n,
        i,
        o = !1,
        u = !1,
        a = [],
        c = [];
      for (; !this.tokenizer.endOfFile();) {
        if (e = this.tokenizer.nextToken(), r = e[0], r === "(" || r === "[" ? c.push(r === "(" ? ")" : "]") : r === "{" && c.length > 0 ? c.push("}") : r === c[c.length - 1] && c.pop(), c.length === 0) {
          if (r === ";") {
            s.source.end = this.getPosition(e[2]), s.source.end.offset++, this.semicolon = !0;
            break;
          } else if (r === "{") {
            u = !0;
            break;
          } else if (r === "}") {
            if (a.length > 0) {
              for (i = a.length - 1, n = a[i]; n && n[0] === "space";) n = a[--i];
              n && (s.source.end = this.getPosition(n[3] || n[2]), s.source.end.offset++);
            }
            this.end(e);
            break;
          } else a.push(e);
        } else a.push(e);
        if (this.tokenizer.endOfFile()) {
          o = !0;
          break;
        }
      }
      s.raws.between = this.spacesAndCommentsFromEnd(a), a.length ? (s.raws.afterName = this.spacesAndCommentsFromStart(a), this.raw(s, "params", a), o && (e = a[a.length - 1], s.source.end = this.getPosition(e[3] || e[2]), s.source.end.offset++, this.spaces = s.raws.between, s.raws.between = "")) : (s.raws.afterName = "", s.params = ""), u && (s.nodes = [], this.current = s);
    }
    checkMissedSemicolon(e) {
      let s = this.colon(e);
      if (s === !1) return;
      let r = 0,
        n;
      for (let i = s - 1; i >= 0 && (n = e[i], !(n[0] !== "space" && (r += 1, r === 2))); i--);
      throw this.input.error("Missed semicolon", n[0] === "word" ? n[3] + 1 : n[2]);
    }
    colon(e) {
      let s = 0,
        r,
        n,
        i;
      for (let [o, u] of e.entries()) {
        if (n = u, i = n[0], i === "(" && (s += 1), i === ")" && (s -= 1), s === 0 && i === ":") if (!r) this.doubleColon(n);else {
          if (r[0] === "word" && r[1] === "progid") continue;
          return o;
        }
        r = n;
      }
      return !1;
    }
    comment(e) {
      let s = new Vc();
      this.init(s, e[2]), s.source.end = this.getPosition(e[3] || e[2]), s.source.end.offset++;
      let r = e[1].slice(2, -2);
      if (/^\s*$/.test(r)) s.text = "", s.raws.left = r, s.raws.right = "";else {
        let n = r.match(/^(\s*)([^]*\S)(\s*)$/);
        s.text = n[2], s.raws.left = n[1], s.raws.right = n[3];
      }
    }
    createTokenizer() {
      this.tokenizer = jc(this.input);
    }
    decl(e, s) {
      let r = new zc();
      this.init(r, e[0][2]);
      let n = e[e.length - 1];
      for (n[0] === ";" && (this.semicolon = !0, e.pop()), r.source.end = this.getPosition(n[3] || n[2] || Kc(e)), r.source.end.offset++; e[0][0] !== "word";) e.length === 1 && this.unknownWord(e), r.raws.before += e.shift()[1];
      for (r.source.start = this.getPosition(e[0][2]), r.prop = ""; e.length;) {
        let c = e[0][0];
        if (c === ":" || c === "space" || c === "comment") break;
        r.prop += e.shift()[1];
      }
      r.raws.between = "";
      let i;
      for (; e.length;) if (i = e.shift(), i[0] === ":") {
        r.raws.between += i[1];
        break;
      } else i[0] === "word" && /\w/.test(i[1]) && this.unknownWord([i]), r.raws.between += i[1];
      (r.prop[0] === "_" || r.prop[0] === "*") && (r.raws.before += r.prop[0], r.prop = r.prop.slice(1));
      let o = [],
        u;
      for (; e.length && (u = e[0][0], !(u !== "space" && u !== "comment"));) o.push(e.shift());
      this.precheckMissedSemicolon(e);
      for (let c = e.length - 1; c >= 0; c--) {
        if (i = e[c], i[1].toLowerCase() === "!important") {
          r.important = !0;
          let f = this.stringFrom(e, c);
          f = this.spacesFromEnd(e) + f, f !== " !important" && (r.raws.important = f);
          break;
        } else if (i[1].toLowerCase() === "important") {
          let f = e.slice(0),
            p = "";
          for (let l = c; l > 0; l--) {
            let d = f[l][0];
            if (p.trim().startsWith("!") && d !== "space") break;
            p = f.pop()[1] + p;
          }
          p.trim().startsWith("!") && (r.important = !0, r.raws.important = p, e = f);
        }
        if (i[0] !== "space" && i[0] !== "comment") break;
      }
      e.some(c => c[0] !== "space" && c[0] !== "comment") && (r.raws.between += o.map(c => c[1]).join(""), o = []), this.raw(r, "value", o.concat(e), s), r.value.includes(":") && !s && this.checkMissedSemicolon(e);
    }
    doubleColon(e) {
      throw this.input.error("Double colon", {
        offset: e[2]
      }, {
        offset: e[2] + e[1].length
      });
    }
    emptyRule(e) {
      let s = new po();
      this.init(s, e[2]), s.selector = "", s.raws.between = "", this.current = s;
    }
    end(e) {
      this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(e[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(e);
    }
    endFile() {
      this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
    }
    freeSemicolon(e) {
      if (this.spaces += e[1], this.current.nodes) {
        let s = this.current.nodes[this.current.nodes.length - 1];
        s && s.type === "rule" && !s.raws.ownSemicolon && (s.raws.ownSemicolon = this.spaces, this.spaces = "", s.source.end = this.getPosition(e[2]), s.source.end.offset += s.raws.ownSemicolon.length);
      }
    }
    getPosition(e) {
      let s = this.input.fromOffset(e);
      return {
        column: s.col,
        line: s.line,
        offset: e
      };
    }
    init(e, s) {
      this.current.push(e), e.source = {
        input: this.input,
        start: this.getPosition(s)
      }, e.raws.before = this.spaces, this.spaces = "", e.type !== "comment" && (this.semicolon = !1);
    }
    other(e) {
      let s = !1,
        r = null,
        n = !1,
        i = null,
        o = [],
        u = e[1].startsWith("--"),
        a = [],
        c = e;
      for (; c;) {
        if (r = c[0], a.push(c), r === "(" || r === "[") i || (i = c), o.push(r === "(" ? ")" : "]");else if (u && n && r === "{") i || (i = c), o.push("}");else if (o.length === 0) {
          if (r === ";") {
            if (n) {
              this.decl(a, u);
              return;
            } else break;
          } else if (r === "{") {
            this.rule(a);
            return;
          } else if (r === "}") {
            this.tokenizer.back(a.pop()), s = !0;
            break;
          } else r === ":" && (n = !0);
        } else r === o[o.length - 1] && (o.pop(), o.length === 0 && (i = null));
        c = this.tokenizer.nextToken();
      }
      if (this.tokenizer.endOfFile() && (s = !0), o.length > 0 && this.unclosedBracket(i), s && n) {
        if (!u) for (; a.length && (c = a[a.length - 1][0], !(c !== "space" && c !== "comment"));) this.tokenizer.back(a.pop());
        this.decl(a, u);
      } else this.unknownWord(a);
    }
    parse() {
      let e;
      for (; !this.tokenizer.endOfFile();) switch (e = this.tokenizer.nextToken(), e[0]) {
        case "space":
          this.spaces += e[1];
          break;
        case ";":
          this.freeSemicolon(e);
          break;
        case "}":
          this.end(e);
          break;
        case "comment":
          this.comment(e);
          break;
        case "at-word":
          this.atrule(e);
          break;
        case "{":
          this.emptyRule(e);
          break;
        default:
          this.other(e);
          break;
      }
      this.endFile();
    }
    precheckMissedSemicolon() {}
    raw(e, s, r, n) {
      let i,
        o,
        u = r.length,
        a = "",
        c = !0,
        f,
        p;
      for (let l = 0; l < u; l += 1) i = r[l], o = i[0], o === "space" && l === u - 1 && !n ? c = !1 : o === "comment" ? (p = r[l - 1] ? r[l - 1][0] : "empty", f = r[l + 1] ? r[l + 1][0] : "empty", !ho[p] && !ho[f] ? a.slice(-1) === "," ? c = !1 : a += i[1] : c = !1) : a += i[1];
      if (!c) {
        let l = r.reduce((d, x) => d + x[1], "");
        e.raws[s] = {
          raw: l,
          value: a
        };
      }
      e[s] = a;
    }
    rule(e) {
      e.pop();
      let s = new po();
      this.init(s, e[0][2]), s.raws.between = this.spacesAndCommentsFromEnd(e), this.raw(s, "selector", e), this.current = s;
    }
    spacesAndCommentsFromEnd(e) {
      let s,
        r = "";
      for (; e.length && (s = e[e.length - 1][0], !(s !== "space" && s !== "comment"));) r = e.pop()[1] + r;
      return r;
    }
    spacesAndCommentsFromStart(e) {
      let s,
        r = "";
      for (; e.length && (s = e[0][0], !(s !== "space" && s !== "comment"));) r += e.shift()[1];
      return r;
    }
    spacesFromEnd(e) {
      let s,
        r = "";
      for (; e.length && (s = e[e.length - 1][0], s === "space");) r = e.pop()[1] + r;
      return r;
    }
    stringFrom(e, s) {
      let r = "";
      for (let n = s; n < e.length; n++) r += e[n][1];
      return e.splice(s, e.length - s), r;
    }
    unclosedBlock() {
      let e = this.current.source.start;
      throw this.input.error("Unclosed block", e.line, e.column);
    }
    unclosedBracket(e) {
      throw this.input.error("Unclosed bracket", {
        offset: e[2]
      }, {
        offset: e[2] + 1
      });
    }
    unexpectedClose(e) {
      throw this.input.error("Unexpected }", {
        offset: e[2]
      }, {
        offset: e[2] + 1
      });
    }
    unknownWord(e) {
      throw this.input.error("Unknown word " + e[0][1], {
        offset: e[0][2]
      }, {
        offset: e[0][2] + e[0][1].length
      });
    }
    unnamedAtrule(e, s) {
      throw this.input.error("At-rule without name", {
        offset: s[2]
      }, {
        offset: s[2] + s[1].length
      });
    }
  };
  mo.exports = ws;
});
var gt = g((ex, yo) => {
  "use strict";

  var Qc = le(),
    Xc = De(),
    Jc = Jt();
  function Zt(t, e) {
    let s = new Xc(t, e),
      r = new Jc(s);
    try {
      r.parse();
    } catch (n) {
      throw n;
    }
    return r.root;
  }
  yo.exports = Zt;
  Zt.default = Zt;
  Qc.registerParse(Zt);
});
var go = g((tx, vs) => {
  var Zc = Xt(),
    ef = De();
  vs.exports = {
    isInlineComment(t) {
      if (t[0] === "word" && t[1].slice(0, 2) === "//") {
        let e = t,
          s = [],
          r,
          n;
        for (; t;) {
          if (/\r?\n/.test(t[1])) {
            if (/['"].*\r?\n/.test(t[1])) {
              s.push(t[1].substring(0, t[1].indexOf(`
`))), n = t[1].substring(t[1].indexOf(`
`));
              let o = this.input.css.valueOf().substring(this.tokenizer.position());
              n += o, r = t[3] + o.length - n.length;
            } else this.tokenizer.back(t);
            break;
          }
          s.push(t[1]), r = t[2], t = this.tokenizer.nextToken({
            ignoreUnclosed: !0
          });
        }
        let i = ["comment", s.join(""), e[2], r];
        return this.inlineComment(i), n && (this.input = new ef(n), this.tokenizer = Zc(this.input)), !0;
      } else if (t[1] === "/") {
        let e = this.tokenizer.nextToken({
          ignoreUnclosed: !0
        });
        if (e[0] === "comment" && /^\/\*/.test(e[1])) return e[0] = "word", e[1] = e[1].slice(1), t[1] = "//", this.tokenizer.back(e), vs.exports.isInlineComment.bind(this)(t);
      }
      return !1;
    }
  };
});
var vo = g((rx, wo) => {
  wo.exports = {
    interpolation(t) {
      let e = [t, this.tokenizer.nextToken()],
        s = ["word", "}"];
      if (e[0][1].length > 1 || e[1][0] !== "{") return this.tokenizer.back(e[1]), !1;
      for (t = this.tokenizer.nextToken(); t && s.includes(t[0]);) e.push(t), t = this.tokenizer.nextToken();
      let r = e.map(u => u[1]),
        [n] = e,
        i = e.pop(),
        o = ["word", r.join(""), n[2], i[2]];
      return this.tokenizer.back(t), this.tokenizer.back(o), !0;
    }
  };
});
var bo = g((sx, xo) => {
  var tf = /^#[0-9a-fA-F]{6}$|^#[0-9a-fA-F]{3}$/,
    rf = /\.[0-9]/,
    sf = t => {
      let [, e] = t,
        [s] = e;
      return (s === "." || s === "#") && tf.test(e) === !1 && rf.test(e) === !1;
    };
  xo.exports = {
    isMixinToken: sf
  };
});
var Eo = g((nx, _o) => {
  var nf = Xt(),
    of = /^url\((.+)\)/;
  _o.exports = t => {
    let {
      name: e,
      params: s = ""
    } = t;
    if (e === "import" && s.length) {
      t.import = !0;
      let r = nf({
        css: s
      });
      for (t.filename = s.replace(of, "$1"); !r.endOfFile();) {
        let [n, i] = r.nextToken();
        if (n === "word" && i === "url") return;
        if (n === "brackets") {
          t.options = i, t.filename = s.replace(i, "").trim();
          break;
        }
      }
    }
  };
});
var Oo = g((ix, To) => {
  var ko = /:$/,
    So = /^:(\s+)?/;
  To.exports = t => {
    let {
      name: e,
      params: s = ""
    } = t;
    if (t.name.slice(-1) === ":") {
      if (ko.test(e)) {
        let [r] = e.match(ko);
        t.name = e.replace(r, ""), t.raws.afterName = r + (t.raws.afterName || ""), t.variable = !0, t.value = t.params;
      }
      if (So.test(s)) {
        let [r] = s.match(So);
        t.value = s.replace(r, ""), t.raws.afterName = (t.raws.afterName || "") + r, t.variable = !0;
      }
    }
  };
});
var No = g((ax, Ao) => {
  var af = qe(),
    uf = Jt(),
    {
      isInlineComment: lf
    } = go(),
    {
      interpolation: Co
    } = vo(),
    {
      isMixinToken: cf
    } = bo(),
    ff = Eo(),
    pf = Oo(),
    hf = /(!\s*important)$/i;
  Ao.exports = class extends uf {
    constructor(...e) {
      super(...e), this.lastNode = null;
    }
    atrule(e) {
      Co.bind(this)(e) || (super.atrule(e), ff(this.lastNode), pf(this.lastNode));
    }
    decl(...e) {
      super.decl(...e), /extend\(.+\)/i.test(this.lastNode.value) && (this.lastNode.extend = !0);
    }
    each(e) {
      e[0][1] = ` ${e[0][1]}`;
      let s = e.findIndex(u => u[0] === "("),
        r = e.reverse().find(u => u[0] === ")"),
        n = e.reverse().indexOf(r),
        o = e.splice(s, n).map(u => u[1]).join("");
      for (let u of e.reverse()) this.tokenizer.back(u);
      this.atrule(this.tokenizer.nextToken()), this.lastNode.function = !0, this.lastNode.params = o;
    }
    init(e, s, r) {
      super.init(e, s, r), this.lastNode = e;
    }
    inlineComment(e) {
      let s = new af(),
        r = e[1].slice(2);
      if (this.init(s, e[2]), s.source.end = this.getPosition(e[3] || e[2]), s.inline = !0, s.raws.begin = "//", /^\s*$/.test(r)) s.text = "", s.raws.left = r, s.raws.right = "";else {
        let n = r.match(/^(\s*)([^]*[^\s])(\s*)$/);
        [, s.raws.left, s.text, s.raws.right] = n;
      }
    }
    mixin(e) {
      let [s] = e,
        r = s[1].slice(0, 1),
        n = e.findIndex(c => c[0] === "brackets"),
        i = e.findIndex(c => c[0] === "("),
        o = "";
      if ((n < 0 || n > 3) && i > 0) {
        let c = e.reduce((w, v, R) => v[0] === ")" ? R : w),
          p = e.slice(i, c + i).map(w => w[1]).join(""),
          [l] = e.slice(i),
          d = [l[2], l[3]],
          [x] = e.slice(c, c + 1),
          h = [x[2], x[3]],
          m = ["brackets", p].concat(d, h),
          y = e.slice(0, i),
          b = e.slice(c + 1);
        e = y, e.push(m), e = e.concat(b);
      }
      let u = [];
      for (let c of e) if ((c[1] === "!" || u.length) && u.push(c), c[1] === "important") break;
      if (u.length) {
        let [c] = u,
          f = e.indexOf(c),
          p = u[u.length - 1],
          l = [c[2], c[3]],
          d = [p[4], p[5]],
          h = ["word", u.map(m => m[1]).join("")].concat(l, d);
        e.splice(f, u.length, h);
      }
      let a = e.findIndex(c => hf.test(c[1]));
      a > 0 && ([, o] = e[a], e.splice(a, 1));
      for (let c of e.reverse()) this.tokenizer.back(c);
      this.atrule(this.tokenizer.nextToken()), this.lastNode.mixin = !0, this.lastNode.raws.identifier = r, o && (this.lastNode.important = !0, this.lastNode.raws.important = o);
    }
    other(e) {
      lf.bind(this)(e) || super.other(e);
    }
    rule(e) {
      let s = e[e.length - 1],
        r = e[e.length - 2];
      if (r[0] === "at-word" && s[0] === "{" && (this.tokenizer.back(s), Co.bind(this)(r))) {
        let i = this.tokenizer.nextToken();
        e = e.slice(0, e.length - 2).concat([i]);
        for (let o of e.reverse()) this.tokenizer.back(o);
        return;
      }
      super.rule(e), /:extend\(.+\)/i.test(this.lastNode.selector) && (this.lastNode.extend = !0);
    }
    unknownWord(e) {
      let [s] = e;
      if (e[0][1] === "each" && e[1][0] === "(") {
        this.each(e);
        return;
      }
      if (cf(s)) {
        this.mixin(e);
        return;
      }
      super.unknownWord(e);
    }
  };
});
var Ro = g((lx, Po) => {
  var df = Yt();
  Po.exports = class extends df {
    atrule(e, s) {
      if (!e.mixin && !e.variable && !e.function) {
        super.atrule(e, s);
        return;
      }
      let n = `${e.function ? "" : e.raws.identifier || "@"}${e.name}`,
        i = e.params ? this.rawValue(e, "params") : "",
        o = e.raws.important || "";
      if (e.variable && (i = e.value), typeof e.raws.afterName < "u" ? n += e.raws.afterName : i && (n += " "), e.nodes) this.block(e, n + i + o);else {
        let u = (e.raws.between || "") + o + (s ? ";" : "");
        this.builder(n + i + u, e);
      }
    }
    comment(e) {
      if (e.inline) {
        let s = this.raw(e, "left", "commentLeft"),
          r = this.raw(e, "right", "commentRight");
        this.builder(`//${s}${e.text}${r}`, e);
      } else super.comment(e);
    }
  };
});
var Io = g((cx, xs) => {
  var mf = De(),
    yf = No(),
    gf = Ro();
  xs.exports = {
    parse(t, e) {
      let s = new mf(t, e),
        r = new yf(s);
      return r.parse(), r.root.walk(n => {
        let i = s.css.lastIndexOf(n.source.input.css);
        if (i === 0) return;
        if (i + n.source.input.css.length !== s.css.length) throw new Error("Invalid state detected in postcss-less");
        let o = i + n.source.start.offset,
          u = s.fromOffset(i + n.source.start.offset);
        if (n.source.start = {
          offset: o,
          line: u.line,
          column: u.col
        }, n.source.end) {
          let a = i + n.source.end.offset,
            c = s.fromOffset(i + n.source.end.offset);
          n.source.end = {
            offset: a,
            line: c.line,
            column: c.col
          };
        }
      }), r.root;
    },
    stringify(t, e) {
      new gf(e).stringify(t);
    },
    nodeToString(t) {
      let e = "";
      return xs.exports.stringify(t, s => {
        e += s;
      }), e;
    }
  };
});
var er = g((fx, Do) => {
  "use strict";

  var wf = le(),
    qo,
    Lo,
    ge = class extends wf {
      constructor(e) {
        super({
          type: "document",
          ...e
        }), this.nodes || (this.nodes = []);
      }
      toResult(e = {}) {
        return new qo(new Lo(), this, e).stringify();
      }
    };
  ge.registerLazyResult = t => {
    qo = t;
  };
  ge.registerProcessor = t => {
    Lo = t;
  };
  Do.exports = ge;
  ge.default = ge;
});
var Bo = g((px, Mo) => {
  "use strict";

  var vf = Ht(),
    xf = qe(),
    bf = mt(),
    _f = De(),
    Ef = ps(),
    kf = Be(),
    Sf = jt();
  function wt(t, e) {
    if (Array.isArray(t)) return t.map(n => wt(n));
    let {
      inputs: s,
      ...r
    } = t;
    if (s) {
      e = [];
      for (let n of s) {
        let i = {
          ...n,
          __proto__: _f.prototype
        };
        i.map && (i.map = {
          ...i.map,
          __proto__: Ef.prototype
        }), e.push(i);
      }
    }
    if (r.nodes && (r.nodes = t.nodes.map(n => wt(n, e))), r.source) {
      let {
        inputId: n,
        ...i
      } = r.source;
      r.source = i, n != null && (r.source.input = e[n]);
    }
    if (r.type === "root") return new kf(r);
    if (r.type === "decl") return new bf(r);
    if (r.type === "rule") return new Sf(r);
    if (r.type === "comment") return new xf(r);
    if (r.type === "atrule") return new vf(r);
    throw new Error("Unknown node type: " + t.type);
  }
  Mo.exports = wt;
  wt.default = wt;
});
var bs = g((hx, Uo) => {
  Uo.exports = class {
    generate() {}
  };
});
var _s = g((mx, Fo) => {
  "use strict";

  var vt = class {
    constructor(e, s = {}) {
      if (this.type = "warning", this.text = e, s.node && s.node.source) {
        let r = s.node.rangeBy(s);
        this.line = r.start.line, this.column = r.start.column, this.endLine = r.end.line, this.endColumn = r.end.column;
      }
      for (let r in s) this[r] = s[r];
    }
    toString() {
      return this.node ? this.node.error(this.text, {
        index: this.index,
        plugin: this.plugin,
        word: this.word
      }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
    }
  };
  Fo.exports = vt;
  vt.default = vt;
});
var tr = g((yx, $o) => {
  "use strict";

  var Tf = _s(),
    xt = class {
      get content() {
        return this.css;
      }
      constructor(e, s, r) {
        this.processor = e, this.messages = [], this.root = s, this.opts = r, this.css = "", this.map = void 0;
      }
      toString() {
        return this.css;
      }
      warn(e, s = {}) {
        s.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (s.plugin = this.lastPlugin.postcssPlugin);
        let r = new Tf(e, s);
        return this.messages.push(r), r;
      }
      warnings() {
        return this.messages.filter(e => e.type === "warning");
      }
    };
  $o.exports = xt;
  xt.default = xt;
});
var Es = g((gx, Go) => {
  "use strict";

  var Wo = {};
  Go.exports = function (e) {
    Wo[e] || (Wo[e] = !0, typeof console < "u" && console.warn && console.warn(e));
  };
});
var Ts = g((vx, Ho) => {
  "use strict";

  var Of = le(),
    Cf = er(),
    Af = bs(),
    Nf = gt(),
    Yo = tr(),
    Pf = Be(),
    Rf = lt(),
    {
      isClean: K,
      my: If
    } = Vt(),
    wx = Es(),
    qf = {
      atrule: "AtRule",
      comment: "Comment",
      decl: "Declaration",
      document: "Document",
      root: "Root",
      rule: "Rule"
    },
    Lf = {
      AtRule: !0,
      AtRuleExit: !0,
      Comment: !0,
      CommentExit: !0,
      Declaration: !0,
      DeclarationExit: !0,
      Document: !0,
      DocumentExit: !0,
      Once: !0,
      OnceExit: !0,
      postcssPlugin: !0,
      prepare: !0,
      Root: !0,
      RootExit: !0,
      Rule: !0,
      RuleExit: !0
    },
    Df = {
      Once: !0,
      postcssPlugin: !0,
      prepare: !0
    },
    Fe = 0;
  function bt(t) {
    return typeof t == "object" && typeof t.then == "function";
  }
  function zo(t) {
    let e = !1,
      s = qf[t.type];
    return t.type === "decl" ? e = t.prop.toLowerCase() : t.type === "atrule" && (e = t.name.toLowerCase()), e && t.append ? [s, s + "-" + e, Fe, s + "Exit", s + "Exit-" + e] : e ? [s, s + "-" + e, s + "Exit", s + "Exit-" + e] : t.append ? [s, Fe, s + "Exit"] : [s, s + "Exit"];
  }
  function Vo(t) {
    let e;
    return t.type === "document" ? e = ["Document", Fe, "DocumentExit"] : t.type === "root" ? e = ["Root", Fe, "RootExit"] : e = zo(t), {
      eventIndex: 0,
      events: e,
      iterator: 0,
      node: t,
      visitorIndex: 0,
      visitors: []
    };
  }
  function ks(t) {
    return t[K] = !1, t.nodes && t.nodes.forEach(e => ks(e)), t;
  }
  var Ss = {},
    fe = class t {
      get content() {
        return this.stringify().content;
      }
      get css() {
        return this.stringify().css;
      }
      get map() {
        return this.stringify().map;
      }
      get messages() {
        return this.sync().messages;
      }
      get opts() {
        return this.result.opts;
      }
      get processor() {
        return this.result.processor;
      }
      get root() {
        return this.sync().root;
      }
      get [Symbol.toStringTag]() {
        return "LazyResult";
      }
      constructor(e, s, r) {
        this.stringified = !1, this.processed = !1;
        let n;
        if (typeof s == "object" && s !== null && (s.type === "root" || s.type === "document")) n = ks(s);else if (s instanceof t || s instanceof Yo) n = ks(s.root), s.map && (typeof r.map > "u" && (r.map = {}), r.map.inline || (r.map.inline = !1), r.map.prev = s.map);else {
          let i = Nf;
          r.syntax && (i = r.syntax.parse), r.parser && (i = r.parser), i.parse && (i = i.parse);
          try {
            n = i(s, r);
          } catch (o) {
            this.processed = !0, this.error = o;
          }
          n && !n[If] && Of.rebuild(n);
        }
        this.result = new Yo(e, n, r), this.helpers = {
          ...Ss,
          postcss: Ss,
          result: this.result
        }, this.plugins = this.processor.plugins.map(i => typeof i == "object" && i.prepare ? {
          ...i,
          ...i.prepare(this.result)
        } : i);
      }
      async() {
        return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
      }
      catch(e) {
        return this.async().catch(e);
      }
      finally(e) {
        return this.async().then(e, e);
      }
      getAsyncError() {
        throw new Error("Use process(css).then(cb) to work with async plugins");
      }
      handleError(e, s) {
        let r = this.result.lastPlugin;
        try {
          s && s.addToError(e), this.error = e, e.name === "CssSyntaxError" && !e.plugin ? (e.plugin = r.postcssPlugin, e.setMessage()) : r.postcssVersion;
        } catch (n) {
          console && console.error && console.error(n);
        }
        return e;
      }
      prepareVisitors() {
        this.listeners = {};
        let e = (s, r, n) => {
          this.listeners[r] || (this.listeners[r] = []), this.listeners[r].push([s, n]);
        };
        for (let s of this.plugins) if (typeof s == "object") for (let r in s) {
          if (!Lf[r] && /^[A-Z]/.test(r)) throw new Error(`Unknown event ${r} in ${s.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`);
          if (!Df[r]) if (typeof s[r] == "object") for (let n in s[r]) n === "*" ? e(s, r, s[r][n]) : e(s, r + "-" + n.toLowerCase(), s[r][n]);else typeof s[r] == "function" && e(s, r, s[r]);
        }
        this.hasListener = Object.keys(this.listeners).length > 0;
      }
      async runAsync() {
        this.plugin = 0;
        for (let e = 0; e < this.plugins.length; e++) {
          let s = this.plugins[e],
            r = this.runOnRoot(s);
          if (bt(r)) try {
            await r;
          } catch (n) {
            throw this.handleError(n);
          }
        }
        if (this.prepareVisitors(), this.hasListener) {
          let e = this.result.root;
          for (; !e[K];) {
            e[K] = !0;
            let s = [Vo(e)];
            for (; s.length > 0;) {
              let r = this.visitTick(s);
              if (bt(r)) try {
                await r;
              } catch (n) {
                let i = s[s.length - 1].node;
                throw this.handleError(n, i);
              }
            }
          }
          if (this.listeners.OnceExit) for (let [s, r] of this.listeners.OnceExit) {
            this.result.lastPlugin = s;
            try {
              if (e.type === "document") {
                let n = e.nodes.map(i => r(i, this.helpers));
                await Promise.all(n);
              } else await r(e, this.helpers);
            } catch (n) {
              throw this.handleError(n);
            }
          }
        }
        return this.processed = !0, this.stringify();
      }
      runOnRoot(e) {
        this.result.lastPlugin = e;
        try {
          if (typeof e == "object" && e.Once) {
            if (this.result.root.type === "document") {
              let s = this.result.root.nodes.map(r => e.Once(r, this.helpers));
              return bt(s[0]) ? Promise.all(s) : s;
            }
            return e.Once(this.result.root, this.helpers);
          } else if (typeof e == "function") return e(this.result.root, this.result);
        } catch (s) {
          throw this.handleError(s);
        }
      }
      stringify() {
        if (this.error) throw this.error;
        if (this.stringified) return this.result;
        this.stringified = !0, this.sync();
        let e = this.result.opts,
          s = Rf;
        e.syntax && (s = e.syntax.stringify), e.stringifier && (s = e.stringifier), s.stringify && (s = s.stringify);
        let n = new Af(s, this.result.root, this.result.opts).generate();
        return this.result.css = n[0], this.result.map = n[1], this.result;
      }
      sync() {
        if (this.error) throw this.error;
        if (this.processed) return this.result;
        if (this.processed = !0, this.processing) throw this.getAsyncError();
        for (let e of this.plugins) {
          let s = this.runOnRoot(e);
          if (bt(s)) throw this.getAsyncError();
        }
        if (this.prepareVisitors(), this.hasListener) {
          let e = this.result.root;
          for (; !e[K];) e[K] = !0, this.walkSync(e);
          if (this.listeners.OnceExit) if (e.type === "document") for (let s of e.nodes) this.visitSync(this.listeners.OnceExit, s);else this.visitSync(this.listeners.OnceExit, e);
        }
        return this.result;
      }
      then(e, s) {
        return this.async().then(e, s);
      }
      toString() {
        return this.css;
      }
      visitSync(e, s) {
        for (let [r, n] of e) {
          this.result.lastPlugin = r;
          let i;
          try {
            i = n(s, this.helpers);
          } catch (o) {
            throw this.handleError(o, s.proxyOf);
          }
          if (s.type !== "root" && s.type !== "document" && !s.parent) return !0;
          if (bt(i)) throw this.getAsyncError();
        }
      }
      visitTick(e) {
        let s = e[e.length - 1],
          {
            node: r,
            visitors: n
          } = s;
        if (r.type !== "root" && r.type !== "document" && !r.parent) {
          e.pop();
          return;
        }
        if (n.length > 0 && s.visitorIndex < n.length) {
          let [o, u] = n[s.visitorIndex];
          s.visitorIndex += 1, s.visitorIndex === n.length && (s.visitors = [], s.visitorIndex = 0), this.result.lastPlugin = o;
          try {
            return u(r.toProxy(), this.helpers);
          } catch (a) {
            throw this.handleError(a, r);
          }
        }
        if (s.iterator !== 0) {
          let o = s.iterator,
            u;
          for (; u = r.nodes[r.indexes[o]];) if (r.indexes[o] += 1, !u[K]) {
            u[K] = !0, e.push(Vo(u));
            return;
          }
          s.iterator = 0, delete r.indexes[o];
        }
        let i = s.events;
        for (; s.eventIndex < i.length;) {
          let o = i[s.eventIndex];
          if (s.eventIndex += 1, o === Fe) {
            r.nodes && r.nodes.length && (r[K] = !0, s.iterator = r.getIterator());
            return;
          } else if (this.listeners[o]) {
            s.visitors = this.listeners[o];
            return;
          }
        }
        e.pop();
      }
      walkSync(e) {
        e[K] = !0;
        let s = zo(e);
        for (let r of s) if (r === Fe) e.nodes && e.each(n => {
          n[K] || this.walkSync(n);
        });else {
          let n = this.listeners[r];
          if (n && this.visitSync(n, e.toProxy())) return;
        }
      }
      warnings() {
        return this.sync().warnings();
      }
    };
  fe.registerPostcss = t => {
    Ss = t;
  };
  Ho.exports = fe;
  fe.default = fe;
  Pf.registerLazyResult(fe);
  Cf.registerLazyResult(fe);
});
var Ko = g((bx, jo) => {
  "use strict";

  var Mf = bs(),
    Bf = gt(),
    Uf = tr(),
    Ff = lt(),
    xx = Es(),
    _t = class {
      get content() {
        return this.result.css;
      }
      get css() {
        return this.result.css;
      }
      get map() {
        return this.result.map;
      }
      get messages() {
        return [];
      }
      get opts() {
        return this.result.opts;
      }
      get processor() {
        return this.result.processor;
      }
      get root() {
        if (this._root) return this._root;
        let e,
          s = Bf;
        try {
          e = s(this._css, this._opts);
        } catch (r) {
          this.error = r;
        }
        if (this.error) throw this.error;
        return this._root = e, e;
      }
      get [Symbol.toStringTag]() {
        return "NoWorkResult";
      }
      constructor(e, s, r) {
        s = s.toString(), this.stringified = !1, this._processor = e, this._css = s, this._opts = r, this._map = void 0;
        let n,
          i = Ff;
        this.result = new Uf(this._processor, n, this._opts), this.result.css = s;
        let o = this;
        Object.defineProperty(this.result, "root", {
          get() {
            return o.root;
          }
        });
        let u = new Mf(i, n, this._opts, s);
        if (u.isMap()) {
          let [a, c] = u.generate();
          a && (this.result.css = a), c && (this.result.map = c);
        } else u.clearAnnotation(), this.result.css = u.css;
      }
      async() {
        return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
      }
      catch(e) {
        return this.async().catch(e);
      }
      finally(e) {
        return this.async().then(e, e);
      }
      sync() {
        if (this.error) throw this.error;
        return this.result;
      }
      then(e, s) {
        return this.async().then(e, s);
      }
      toString() {
        return this._css;
      }
      warnings() {
        return [];
      }
    };
  jo.exports = _t;
  _t.default = _t;
});
var Xo = g((_x, Qo) => {
  "use strict";

  var $f = er(),
    Wf = Ts(),
    Gf = Ko(),
    Yf = Be(),
    we = class {
      constructor(e = []) {
        this.version = "8.5.6", this.plugins = this.normalize(e);
      }
      normalize(e) {
        let s = [];
        for (let r of e) if (r.postcss === !0 ? r = r() : r.postcss && (r = r.postcss), typeof r == "object" && Array.isArray(r.plugins)) s = s.concat(r.plugins);else if (typeof r == "object" && r.postcssPlugin) s.push(r);else if (typeof r == "function") s.push(r);else if (!(typeof r == "object" && (r.parse || r.stringify))) throw new Error(r + " is not a PostCSS plugin");
        return s;
      }
      process(e, s = {}) {
        return !this.plugins.length && !s.parser && !s.stringifier && !s.syntax ? new Gf(this, e, s) : new Wf(this, e, s);
      }
      use(e) {
        return this.plugins = this.plugins.concat(this.normalize([e])), this;
      }
    };
  Qo.exports = we;
  we.default = we;
  Yf.registerProcessor(we);
  $f.registerProcessor(we);
});
var rr = g((Ex, na) => {
  "use strict";

  var Jo = Ht(),
    Zo = qe(),
    Vf = le(),
    zf = Gt(),
    ea = mt(),
    ta = er(),
    Hf = Bo(),
    jf = De(),
    Kf = Ts(),
    Qf = gs(),
    Xf = pt(),
    Jf = gt(),
    Os = Xo(),
    Zf = tr(),
    ra = Be(),
    sa = jt(),
    ep = lt(),
    tp = _s();
  function k(...t) {
    return t.length === 1 && Array.isArray(t[0]) && (t = t[0]), new Os(t);
  }
  k.plugin = function (e, s) {
    let r = !1;
    function n(...o) {
      console && console.warn && !r && (r = !0, console.warn(e + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`));
      let u = s(...o);
      return u.postcssPlugin = e, u.postcssVersion = new Os().version, u;
    }
    let i;
    return Object.defineProperty(n, "postcss", {
      get() {
        return i || (i = n()), i;
      }
    }), n.process = function (o, u, a) {
      return k([n(a)]).process(o, u);
    }, n;
  };
  k.stringify = ep;
  k.parse = Jf;
  k.fromJSON = Hf;
  k.list = Qf;
  k.comment = t => new Zo(t);
  k.atRule = t => new Jo(t);
  k.decl = t => new ea(t);
  k.rule = t => new sa(t);
  k.root = t => new ra(t);
  k.document = t => new ta(t);
  k.CssSyntaxError = zf;
  k.Declaration = ea;
  k.Container = Vf;
  k.Processor = Os;
  k.Document = ta;
  k.Comment = Zo;
  k.Warning = tp;
  k.AtRule = Jo;
  k.Result = Zf;
  k.Input = jf;
  k.Rule = sa;
  k.Root = ra;
  k.Node = Xf;
  Kf.registerPostcss(k);
  na.exports = k;
  k.default = k;
});
var oa = g((kx, ia) => {
  var {
      Container: rp
    } = rr(),
    Cs = class extends rp {
      constructor(e) {
        super(e), this.type = "decl", this.isNested = !0, this.nodes || (this.nodes = []);
      }
    };
  ia.exports = Cs;
});
var la = g((Sx, ua) => {
  "use strict";

  var sr = /[\t\n\f\r "#'()/;[\\\]{}]/g,
    nr = /[,\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g,
    sp = /.[\r\n"'(/\\]/,
    aa = /[\da-f]/i,
    ir = /[\n\f\r]/g;
  ua.exports = function (e, s = {}) {
    let r = e.css.valueOf(),
      n = s.ignoreErrors,
      i,
      o,
      u,
      a,
      c,
      f,
      p,
      l,
      d,
      x = r.length,
      h = 0,
      m = [],
      y = [],
      b;
    function w() {
      return h;
    }
    function v(T) {
      throw e.error("Unclosed " + T, h);
    }
    function R() {
      return y.length === 0 && h >= x;
    }
    function F() {
      let T = 1,
        O = !1,
        C = !1;
      for (; T > 0;) o += 1, r.length <= o && v("interpolation"), i = r.charCodeAt(o), l = r.charCodeAt(o + 1), O ? !C && i === O ? (O = !1, C = !1) : i === 92 ? C = !C : C && (C = !1) : i === 39 || i === 34 ? O = i : i === 125 ? T -= 1 : i === 35 && l === 123 && (T += 1);
    }
    function Q(T) {
      if (y.length) return y.pop();
      if (h >= x) return;
      let O = T ? T.ignoreUnclosed : !1;
      switch (i = r.charCodeAt(h), i) {
        case 10:
        case 32:
        case 9:
        case 13:
        case 12:
          {
            o = h;
            do o += 1, i = r.charCodeAt(o); while (i === 32 || i === 10 || i === 9 || i === 13 || i === 12);
            d = ["space", r.slice(h, o)], h = o - 1;
            break;
          }
        case 91:
        case 93:
        case 123:
        case 125:
        case 58:
        case 59:
        case 41:
          {
            let C = String.fromCharCode(i);
            d = [C, C, h];
            break;
          }
        case 44:
          {
            d = ["word", ",", h, h + 1];
            break;
          }
        case 40:
          {
            if (p = m.length ? m.pop()[1] : "", l = r.charCodeAt(h + 1), p === "url" && l !== 39 && l !== 34) {
              for (b = 1, f = !1, o = h + 1; o <= r.length - 1;) {
                if (l = r.charCodeAt(o), l === 92) f = !f;else if (l === 40) b += 1;else if (l === 41 && (b -= 1, b === 0)) break;
                o += 1;
              }
              a = r.slice(h, o + 1), d = ["brackets", a, h, o], h = o;
            } else o = r.indexOf(")", h + 1), a = r.slice(h, o + 1), o === -1 || sp.test(a) ? d = ["(", "(", h] : (d = ["brackets", a, h, o], h = o);
            break;
          }
        case 39:
        case 34:
          {
            for (u = i, o = h, f = !1; o < x && (o++, o === x && v("string"), i = r.charCodeAt(o), l = r.charCodeAt(o + 1), !(!f && i === u));) i === 92 ? f = !f : f ? f = !1 : i === 35 && l === 123 && F();
            d = ["string", r.slice(h, o + 1), h, o], h = o;
            break;
          }
        case 64:
          {
            sr.lastIndex = h + 1, sr.test(r), sr.lastIndex === 0 ? o = r.length - 1 : o = sr.lastIndex - 2, d = ["at-word", r.slice(h, o + 1), h, o], h = o;
            break;
          }
        case 92:
          {
            for (o = h, c = !0; r.charCodeAt(o + 1) === 92;) o += 1, c = !c;
            if (i = r.charCodeAt(o + 1), c && i !== 47 && i !== 32 && i !== 10 && i !== 9 && i !== 13 && i !== 12 && (o += 1, aa.test(r.charAt(o)))) {
              for (; aa.test(r.charAt(o + 1));) o += 1;
              r.charCodeAt(o + 1) === 32 && (o += 1);
            }
            d = ["word", r.slice(h, o + 1), h, o], h = o;
            break;
          }
        default:
          l = r.charCodeAt(h + 1), i === 35 && l === 123 ? (o = h, F(), a = r.slice(h, o + 1), d = ["word", a, h, o], h = o) : i === 47 && l === 42 ? (o = r.indexOf("*/", h + 2) + 1, o === 0 && (n || O ? o = r.length : v("comment")), d = ["comment", r.slice(h, o + 1), h, o], h = o) : i === 47 && l === 47 ? (ir.lastIndex = h + 1, ir.test(r), ir.lastIndex === 0 ? o = r.length - 1 : o = ir.lastIndex - 2, a = r.slice(h, o + 1), d = ["comment", a, h, o, "inline"], h = o) : (nr.lastIndex = h + 1, nr.test(r), nr.lastIndex === 0 ? o = r.length - 1 : o = nr.lastIndex - 2, d = ["word", r.slice(h, o + 1), h, o], m.push(d), h = o);
          break;
      }
      return h++, d;
    }
    function W(T) {
      y.push(T);
    }
    return {
      back: W,
      endOfFile: R,
      nextToken: Q,
      position: w
    };
  };
});
var fa = g((Tx, ca) => {
  var {
      Comment: np
    } = rr(),
    ip = Jt(),
    op = oa(),
    ap = la(),
    As = class extends ip {
      atrule(e) {
        let s = e[1],
          r = e;
        for (; !this.tokenizer.endOfFile();) {
          let n = this.tokenizer.nextToken();
          if (n[0] === "word" && n[2] === r[3] + 1) s += n[1], r = n;else {
            this.tokenizer.back(n);
            break;
          }
        }
        super.atrule(["at-word", s, e[2], r[3]]);
      }
      comment(e) {
        if (e[4] === "inline") {
          let s = new np();
          this.init(s, e[2]), s.raws.inline = !0;
          let r = this.input.fromOffset(e[3]);
          s.source.end = {
            column: r.col,
            line: r.line,
            offset: e[3] + 1
          };
          let n = e[1].slice(2);
          if (/^\s*$/.test(n)) s.text = "", s.raws.left = n, s.raws.right = "";else {
            let i = n.match(/^(\s*)([^]*\S)(\s*)$/),
              o = i[2].replace(/(\*\/|\/\*)/g, "*//*");
            s.text = o, s.raws.left = i[1], s.raws.right = i[3], s.raws.text = i[2];
          }
        } else super.comment(e);
      }
      createTokenizer() {
        this.tokenizer = ap(this.input);
      }
      raw(e, s, r, n) {
        if (super.raw(e, s, r, n), e.raws[s]) {
          let i = e.raws[s].raw;
          e.raws[s].raw = r.reduce((o, u) => {
            if (u[0] === "comment" && u[4] === "inline") {
              let a = u[1].slice(2).replace(/(\*\/|\/\*)/g, "*//*");
              return o + "/*" + a + "*/";
            } else return o + u[1];
          }, ""), i !== e.raws[s].raw && (e.raws[s].scss = i);
        }
      }
      rule(e) {
        let s = !1,
          r = 0,
          n = "";
        for (let i of e) if (s) i[0] !== "comment" && i[0] !== "{" && (n += i[1]);else {
          if (i[0] === "space" && i[1].includes(`
`)) break;
          i[0] === "(" ? r += 1 : i[0] === ")" ? r -= 1 : r === 0 && i[0] === ":" && (s = !0);
        }
        if (!s || n.trim() === "" || /^[#:A-Za-z-]/.test(n)) super.rule(e);else {
          e.pop();
          let i = new op();
          this.init(i, e[0][2]);
          let o;
          for (let a = e.length - 1; a >= 0; a--) if (e[a][0] !== "space") {
            o = e[a];
            break;
          }
          if (o[3]) {
            let a = this.input.fromOffset(o[3]);
            i.source.end = {
              column: a.col,
              line: a.line,
              offset: o[3] + 1
            };
          } else {
            let a = this.input.fromOffset(o[2]);
            i.source.end = {
              column: a.col,
              line: a.line,
              offset: o[2] + 1
            };
          }
          for (; e[0][0] !== "word";) i.raws.before += e.shift()[1];
          if (e[0][2]) {
            let a = this.input.fromOffset(e[0][2]);
            i.source.start = {
              column: a.col,
              line: a.line,
              offset: e[0][2]
            };
          }
          for (i.prop = ""; e.length;) {
            let a = e[0][0];
            if (a === ":" || a === "space" || a === "comment") break;
            i.prop += e.shift()[1];
          }
          i.raws.between = "";
          let u;
          for (; e.length;) if (u = e.shift(), u[0] === ":") {
            i.raws.between += u[1];
            break;
          } else i.raws.between += u[1];
          (i.prop[0] === "_" || i.prop[0] === "*") && (i.raws.before += i.prop[0], i.prop = i.prop.slice(1)), i.raws.between += this.spacesAndCommentsFromStart(e), this.precheckMissedSemicolon(e);
          for (let a = e.length - 1; a > 0; a--) {
            if (u = e[a], u[1] === "!important") {
              i.important = !0;
              let c = this.stringFrom(e, a);
              c = this.spacesFromEnd(e) + c, c !== " !important" && (i.raws.important = c);
              break;
            } else if (u[1] === "important") {
              let c = e.slice(0),
                f = "";
              for (let p = a; p > 0; p--) {
                let l = c[p][0];
                if (f.trim().indexOf("!") === 0 && l !== "space") break;
                f = c.pop()[1] + f;
              }
              f.trim().indexOf("!") === 0 && (i.important = !0, i.raws.important = f, e = c);
            }
            if (u[0] !== "space" && u[0] !== "comment") break;
          }
          this.raw(i, "value", e), i.value.includes(":") && this.checkMissedSemicolon(e), this.current = i;
        }
      }
    };
  ca.exports = As;
});
var ha = g((Ox, pa) => {
  var {
      Input: up
    } = rr(),
    lp = fa();
  pa.exports = function (e, s) {
    let r = new up(e, s),
      n = new lp(r);
    return n.parse(), n.root;
  };
});
var Ps = g(Ns => {
  "use strict";

  Object.defineProperty(Ns, "__esModule", {
    value: !0
  });
  function fp(t) {
    this.after = t.after, this.before = t.before, this.type = t.type, this.value = t.value, this.sourceIndex = t.sourceIndex;
  }
  Ns.default = fp;
});
var Is = g(Rs => {
  "use strict";

  Object.defineProperty(Rs, "__esModule", {
    value: !0
  });
  var pp = Ps(),
    ma = hp(pp);
  function hp(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  function Et(t) {
    var e = this;
    this.constructor(t), this.nodes = t.nodes, this.after === void 0 && (this.after = this.nodes.length > 0 ? this.nodes[this.nodes.length - 1].after : ""), this.before === void 0 && (this.before = this.nodes.length > 0 ? this.nodes[0].before : ""), this.sourceIndex === void 0 && (this.sourceIndex = this.before.length), this.nodes.forEach(function (s) {
      s.parent = e;
    });
  }
  Et.prototype = Object.create(ma.default.prototype);
  Et.constructor = ma.default;
  Et.prototype.walk = function (e, s) {
    for (var r = typeof e == "string" || e instanceof RegExp, n = r ? s : e, i = typeof e == "string" ? new RegExp(e) : e, o = 0; o < this.nodes.length; o++) {
      var u = this.nodes[o],
        a = r ? i.test(u.type) : !0;
      if (a && n && n(u, o, this.nodes) === !1 || u.nodes && u.walk(e, s) === !1) return !1;
    }
    return !0;
  };
  Et.prototype.each = function () {
    for (var e = arguments.length <= 0 || arguments[0] === void 0 ? function () {} : arguments[0], s = 0; s < this.nodes.length; s++) {
      var r = this.nodes[s];
      if (e(r, s, this.nodes) === !1) return !1;
    }
    return !0;
  };
  Rs.default = Et;
});
var va = g(kt => {
  "use strict";

  Object.defineProperty(kt, "__esModule", {
    value: !0
  });
  kt.parseMediaFeature = wa;
  kt.parseMediaQuery = Ls;
  kt.parseMediaList = yp;
  var dp = Ps(),
    ya = ga(dp),
    mp = Is(),
    qs = ga(mp);
  function ga(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  function wa(t) {
    var e = arguments.length <= 1 || arguments[1] === void 0 ? 0 : arguments[1],
      s = [{
        mode: "normal",
        character: null
      }],
      r = [],
      n = 0,
      i = "",
      o = null,
      u = null,
      a = e,
      c = t;
    t[0] === "(" && t[t.length - 1] === ")" && (c = t.substring(1, t.length - 1), a++);
    for (var f = 0; f < c.length; f++) {
      var p = c[f];
      if ((p === "'" || p === '"') && (s[n].isCalculationEnabled === !0 ? (s.push({
        mode: "string",
        isCalculationEnabled: !1,
        character: p
      }), n++) : s[n].mode === "string" && s[n].character === p && c[f - 1] !== "\\" && (s.pop(), n--)), p === "{" ? (s.push({
        mode: "interpolation",
        isCalculationEnabled: !0
      }), n++) : p === "}" && (s.pop(), n--), s[n].mode === "normal" && p === ":") {
        var l = c.substring(f + 1);
        u = {
          type: "value",
          before: /^(\s*)/.exec(l)[1],
          after: /(\s*)$/.exec(l)[1],
          value: l.trim()
        }, u.sourceIndex = u.before.length + f + 1 + a, o = {
          type: "colon",
          sourceIndex: f + a,
          after: u.before,
          value: ":"
        };
        break;
      }
      i += p;
    }
    return i = {
      type: "media-feature",
      before: /^(\s*)/.exec(i)[1],
      after: /(\s*)$/.exec(i)[1],
      value: i.trim()
    }, i.sourceIndex = i.before.length + a, r.push(i), o !== null && (o.before = i.after, r.push(o)), u !== null && r.push(u), r;
  }
  function Ls(t) {
    var e = arguments.length <= 1 || arguments[1] === void 0 ? 0 : arguments[1],
      s = [],
      r = 0,
      n = !1,
      i = void 0;
    function o() {
      return {
        before: "",
        after: "",
        value: ""
      };
    }
    i = o();
    for (var u = 0; u < t.length; u++) {
      var a = t[u];
      n ? (i.value += a, (a === "{" || a === "(") && r++, (a === ")" || a === "}") && r--) : a.search(/\s/) !== -1 ? i.before += a : (a === "(" && (i.type = "media-feature-expression", r++), i.value = a, i.sourceIndex = e + u, n = !0), n && r === 0 && (a === ")" || u === t.length - 1 || t[u + 1].search(/\s/) !== -1) && (["not", "only", "and"].indexOf(i.value) !== -1 && (i.type = "keyword"), i.type === "media-feature-expression" && (i.nodes = wa(i.value, i.sourceIndex)), s.push(Array.isArray(i.nodes) ? new qs.default(i) : new ya.default(i)), i = o(), n = !1);
    }
    for (var c = 0; c < s.length; c++) if (i = s[c], c > 0 && (s[c - 1].after = i.before), i.type === void 0) {
      if (c > 0) {
        if (s[c - 1].type === "media-feature-expression") {
          i.type = "keyword";
          continue;
        }
        if (s[c - 1].value === "not" || s[c - 1].value === "only") {
          i.type = "media-type";
          continue;
        }
        if (s[c - 1].value === "and") {
          i.type = "media-feature-expression";
          continue;
        }
        s[c - 1].type === "media-type" && (s[c + 1] ? i.type = s[c + 1].type === "media-feature-expression" ? "keyword" : "media-feature-expression" : i.type = "media-feature-expression");
      }
      if (c === 0) {
        if (!s[c + 1]) {
          i.type = "media-type";
          continue;
        }
        if (s[c + 1] && (s[c + 1].type === "media-feature-expression" || s[c + 1].type === "keyword")) {
          i.type = "media-type";
          continue;
        }
        if (s[c + 2]) {
          if (s[c + 2].type === "media-feature-expression") {
            i.type = "media-type", s[c + 1].type = "keyword";
            continue;
          }
          if (s[c + 2].type === "keyword") {
            i.type = "keyword", s[c + 1].type = "media-type";
            continue;
          }
        }
        if (s[c + 3] && s[c + 3].type === "media-feature-expression") {
          i.type = "keyword", s[c + 1].type = "media-type", s[c + 2].type = "keyword";
          continue;
        }
      }
    }
    return s;
  }
  function yp(t) {
    var e = [],
      s = 0,
      r = 0,
      n = /^(\s*)url\s*\(/.exec(t);
    if (n !== null) {
      for (var i = n[0].length, o = 1; o > 0;) {
        var u = t[i];
        u === "(" && o++, u === ")" && o--, i++;
      }
      e.unshift(new ya.default({
        type: "url",
        value: t.substring(0, i).trim(),
        sourceIndex: n[1].length,
        before: n[1],
        after: /^(\s*)/.exec(t.substring(i))[1]
      })), s = i;
    }
    for (var a = s; a < t.length; a++) {
      var c = t[a];
      if (c === "(" && r++, c === ")" && r--, r === 0 && c === ",") {
        var f = t.substring(s, a),
          p = /^(\s*)/.exec(f)[1];
        e.push(new qs.default({
          type: "media-query",
          value: f.trim(),
          sourceIndex: s + p.length,
          nodes: Ls(f, s),
          before: p,
          after: /(\s*)$/.exec(f)[1]
        })), s = a + 1;
      }
    }
    var l = t.substring(s),
      d = /^(\s*)/.exec(l)[1];
    return e.push(new qs.default({
      type: "media-query",
      value: l.trim(),
      sourceIndex: s + d.length,
      nodes: Ls(l, s),
      before: d,
      after: /(\s*)$/.exec(l)[1]
    })), e;
  }
});
var xa = g(Ds => {
  "use strict";

  Object.defineProperty(Ds, "__esModule", {
    value: !0
  });
  Ds.default = bp;
  var gp = Is(),
    wp = xp(gp),
    vp = va();
  function xp(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  function bp(t) {
    return new wp.default({
      nodes: (0, vp.parseMediaList)(t),
      type: "media-query-list",
      value: t.trim()
    });
  }
});
var Bs = g((Dx, Ea) => {
  Ea.exports = function (e, s) {
    if (s = typeof s == "number" ? s : 1 / 0, !s) return Array.isArray(e) ? e.map(function (n) {
      return n;
    }) : e;
    return r(e, 1);
    function r(n, i) {
      return n.reduce(function (o, u) {
        return Array.isArray(u) && i < s ? o.concat(r(u, i + 1)) : o.concat(u);
      }, []);
    }
  };
});
var Us = g((Mx, ka) => {
  ka.exports = function (t, e) {
    for (var s = -1, r = []; (s = t.indexOf(e, s + 1)) !== -1;) r.push(s);
    return r;
  };
});
var Fs = g((Bx, Sa) => {
  "use strict";

  function kp(t, e) {
    for (var s = 1, r = t.length, n = t[0], i = t[0], o = 1; o < r; ++o) if (i = n, n = t[o], e(n, i)) {
      if (o === s) {
        s++;
        continue;
      }
      t[s++] = n;
    }
    return t.length = s, t;
  }
  function Sp(t) {
    for (var e = 1, s = t.length, r = t[0], n = t[0], i = 1; i < s; ++i, n = r) if (n = r, r = t[i], r !== n) {
      if (i === e) {
        e++;
        continue;
      }
      t[e++] = r;
    }
    return t.length = e, t;
  }
  function Tp(t, e, s) {
    return t.length === 0 ? t : e ? (s || t.sort(e), kp(t, e)) : (s || t.sort(), Sp(t));
  }
  Sa.exports = Tp;
});
var ve = g((or, Oa) => {
  "use strict";

  or.__esModule = !0;
  var Ta = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (t) {
    return typeof t;
  } : function (t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  };
  function Op(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  }
  var Cp = function t(e, s) {
      if ((typeof e > "u" ? "undefined" : Ta(e)) !== "object") return e;
      var r = new e.constructor();
      for (var n in e) if (e.hasOwnProperty(n)) {
        var i = e[n],
          o = typeof i > "u" ? "undefined" : Ta(i);
        n === "parent" && o === "object" ? s && (r[n] = s) : i instanceof Array ? r[n] = i.map(function (u) {
          return t(u, r);
        }) : r[n] = t(i, r);
      }
      return r;
    },
    Ap = function () {
      function t() {
        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        Op(this, t);
        for (var s in e) this[s] = e[s];
        var r = e.spaces;
        r = r === void 0 ? {} : r;
        var n = r.before,
          i = n === void 0 ? "" : n,
          o = r.after,
          u = o === void 0 ? "" : o;
        this.spaces = {
          before: i,
          after: u
        };
      }
      return t.prototype.remove = function () {
        return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
      }, t.prototype.replaceWith = function () {
        if (this.parent) {
          for (var s in arguments) this.parent.insertBefore(this, arguments[s]);
          this.remove();
        }
        return this;
      }, t.prototype.next = function () {
        return this.parent.at(this.parent.index(this) + 1);
      }, t.prototype.prev = function () {
        return this.parent.at(this.parent.index(this) - 1);
      }, t.prototype.clone = function () {
        var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
          r = Cp(this);
        for (var n in s) r[n] = s[n];
        return r;
      }, t.prototype.toString = function () {
        return [this.spaces.before, String(this.value), this.spaces.after].join("");
      }, t;
    }();
  or.default = Ap;
  Oa.exports = or.default;
});
var M = g(B => {
  "use strict";

  B.__esModule = !0;
  var Ux = B.TAG = "tag",
    Fx = B.STRING = "string",
    $x = B.SELECTOR = "selector",
    Wx = B.ROOT = "root",
    Gx = B.PSEUDO = "pseudo",
    Yx = B.NESTING = "nesting",
    Vx = B.ID = "id",
    zx = B.COMMENT = "comment",
    Hx = B.COMBINATOR = "combinator",
    jx = B.CLASS = "class",
    Kx = B.ATTRIBUTE = "attribute",
    Qx = B.UNIVERSAL = "universal";
});
var ur = g((ar, Ca) => {
  "use strict";

  ar.__esModule = !0;
  var Np = function () {
      function t(e, s) {
        for (var r = 0; r < s.length; r++) {
          var n = s[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }
      return function (e, s, r) {
        return s && t(e.prototype, s), r && t(e, r), e;
      };
    }(),
    Pp = ve(),
    Rp = Lp(Pp),
    Ip = M(),
    ee = qp(Ip);
  function qp(t) {
    if (t && t.__esModule) return t;
    var e = {};
    if (t != null) for (var s in t) Object.prototype.hasOwnProperty.call(t, s) && (e[s] = t[s]);
    return e.default = t, e;
  }
  function Lp(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  function Dp(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  }
  function Mp(t, e) {
    if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e && (typeof e == "object" || typeof e == "function") ? e : t;
  }
  function Bp(t, e) {
    if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
  }
  var Up = function (t) {
    Bp(e, t);
    function e(s) {
      Dp(this, e);
      var r = Mp(this, t.call(this, s));
      return r.nodes || (r.nodes = []), r;
    }
    return e.prototype.append = function (r) {
      return r.parent = this, this.nodes.push(r), this;
    }, e.prototype.prepend = function (r) {
      return r.parent = this, this.nodes.unshift(r), this;
    }, e.prototype.at = function (r) {
      return this.nodes[r];
    }, e.prototype.index = function (r) {
      return typeof r == "number" ? r : this.nodes.indexOf(r);
    }, e.prototype.removeChild = function (r) {
      r = this.index(r), this.at(r).parent = void 0, this.nodes.splice(r, 1);
      var n = void 0;
      for (var i in this.indexes) n = this.indexes[i], n >= r && (this.indexes[i] = n - 1);
      return this;
    }, e.prototype.removeAll = function () {
      for (var i = this.nodes, r = Array.isArray(i), n = 0, i = r ? i : i[Symbol.iterator]();;) {
        var o;
        if (r) {
          if (n >= i.length) break;
          o = i[n++];
        } else {
          if (n = i.next(), n.done) break;
          o = n.value;
        }
        var u = o;
        u.parent = void 0;
      }
      return this.nodes = [], this;
    }, e.prototype.empty = function () {
      return this.removeAll();
    }, e.prototype.insertAfter = function (r, n) {
      var i = this.index(r);
      this.nodes.splice(i + 1, 0, n);
      var o = void 0;
      for (var u in this.indexes) o = this.indexes[u], i <= o && (this.indexes[u] = o + this.nodes.length);
      return this;
    }, e.prototype.insertBefore = function (r, n) {
      var i = this.index(r);
      this.nodes.splice(i, 0, n);
      var o = void 0;
      for (var u in this.indexes) o = this.indexes[u], i <= o && (this.indexes[u] = o + this.nodes.length);
      return this;
    }, e.prototype.each = function (r) {
      this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach++;
      var n = this.lastEach;
      if (this.indexes[n] = 0, !!this.length) {
        for (var i = void 0, o = void 0; this.indexes[n] < this.length && (i = this.indexes[n], o = r(this.at(i), i), o !== !1);) this.indexes[n] += 1;
        if (delete this.indexes[n], o === !1) return !1;
      }
    }, e.prototype.walk = function (r) {
      return this.each(function (n, i) {
        var o = r(n, i);
        if (o !== !1 && n.length && (o = n.walk(r)), o === !1) return !1;
      });
    }, e.prototype.walkAttributes = function (r) {
      var n = this;
      return this.walk(function (i) {
        if (i.type === ee.ATTRIBUTE) return r.call(n, i);
      });
    }, e.prototype.walkClasses = function (r) {
      var n = this;
      return this.walk(function (i) {
        if (i.type === ee.CLASS) return r.call(n, i);
      });
    }, e.prototype.walkCombinators = function (r) {
      var n = this;
      return this.walk(function (i) {
        if (i.type === ee.COMBINATOR) return r.call(n, i);
      });
    }, e.prototype.walkComments = function (r) {
      var n = this;
      return this.walk(function (i) {
        if (i.type === ee.COMMENT) return r.call(n, i);
      });
    }, e.prototype.walkIds = function (r) {
      var n = this;
      return this.walk(function (i) {
        if (i.type === ee.ID) return r.call(n, i);
      });
    }, e.prototype.walkNesting = function (r) {
      var n = this;
      return this.walk(function (i) {
        if (i.type === ee.NESTING) return r.call(n, i);
      });
    }, e.prototype.walkPseudos = function (r) {
      var n = this;
      return this.walk(function (i) {
        if (i.type === ee.PSEUDO) return r.call(n, i);
      });
    }, e.prototype.walkTags = function (r) {
      var n = this;
      return this.walk(function (i) {
        if (i.type === ee.TAG) return r.call(n, i);
      });
    }, e.prototype.walkUniversals = function (r) {
      var n = this;
      return this.walk(function (i) {
        if (i.type === ee.UNIVERSAL) return r.call(n, i);
      });
    }, e.prototype.split = function (r) {
      var n = this,
        i = [];
      return this.reduce(function (o, u, a) {
        var c = r.call(n, u);
        return i.push(u), c ? (o.push(i), i = []) : a === n.length - 1 && o.push(i), o;
      }, []);
    }, e.prototype.map = function (r) {
      return this.nodes.map(r);
    }, e.prototype.reduce = function (r, n) {
      return this.nodes.reduce(r, n);
    }, e.prototype.every = function (r) {
      return this.nodes.every(r);
    }, e.prototype.some = function (r) {
      return this.nodes.some(r);
    }, e.prototype.filter = function (r) {
      return this.nodes.filter(r);
    }, e.prototype.sort = function (r) {
      return this.nodes.sort(r);
    }, e.prototype.toString = function () {
      return this.map(String).join("");
    }, Np(e, [{
      key: "first",
      get: function () {
        return this.at(0);
      }
    }, {
      key: "last",
      get: function () {
        return this.at(this.length - 1);
      }
    }, {
      key: "length",
      get: function () {
        return this.nodes.length;
      }
    }]), e;
  }(Rp.default);
  ar.default = Up;
  Ca.exports = ar.default;
});
var Na = g((lr, Aa) => {
  "use strict";

  lr.__esModule = !0;
  var Fp = ur(),
    $p = Gp(Fp),
    Wp = M();
  function Gp(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  function Yp(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  }
  function Vp(t, e) {
    if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e && (typeof e == "object" || typeof e == "function") ? e : t;
  }
  function zp(t, e) {
    if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
  }
  var Hp = function (t) {
    zp(e, t);
    function e(s) {
      Yp(this, e);
      var r = Vp(this, t.call(this, s));
      return r.type = Wp.ROOT, r;
    }
    return e.prototype.toString = function () {
      var r = this.reduce(function (n, i) {
        var o = String(i);
        return o ? n + o + "," : "";
      }, "").slice(0, -1);
      return this.trailingComma ? r + "," : r;
    }, e;
  }($p.default);
  lr.default = Hp;
  Aa.exports = lr.default;
});
var Ra = g((cr, Pa) => {
  "use strict";

  cr.__esModule = !0;
  var jp = ur(),
    Kp = Xp(jp),
    Qp = M();
  function Xp(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  function Jp(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  }
  function Zp(t, e) {
    if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e && (typeof e == "object" || typeof e == "function") ? e : t;
  }
  function eh(t, e) {
    if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
  }
  var th = function (t) {
    eh(e, t);
    function e(s) {
      Jp(this, e);
      var r = Zp(this, t.call(this, s));
      return r.type = Qp.SELECTOR, r;
    }
    return e;
  }(Kp.default);
  cr.default = th;
  Pa.exports = cr.default;
});
var $e = g((fr, Ia) => {
  "use strict";

  fr.__esModule = !0;
  var rh = function () {
      function t(e, s) {
        for (var r = 0; r < s.length; r++) {
          var n = s[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }
      return function (e, s, r) {
        return s && t(e.prototype, s), r && t(e, r), e;
      };
    }(),
    sh = ve(),
    nh = ih(sh);
  function ih(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  function oh(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  }
  function ah(t, e) {
    if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e && (typeof e == "object" || typeof e == "function") ? e : t;
  }
  function uh(t, e) {
    if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
  }
  var lh = function (t) {
    uh(e, t);
    function e() {
      return oh(this, e), ah(this, t.apply(this, arguments));
    }
    return e.prototype.toString = function () {
      return [this.spaces.before, this.ns, String(this.value), this.spaces.after].join("");
    }, rh(e, [{
      key: "ns",
      get: function () {
        var r = this.namespace;
        return r ? (typeof r == "string" ? r : "") + "|" : "";
      }
    }]), e;
  }(nh.default);
  fr.default = lh;
  Ia.exports = fr.default;
});
var La = g((pr, qa) => {
  "use strict";

  pr.__esModule = !0;
  var ch = $e(),
    fh = hh(ch),
    ph = M();
  function hh(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  function dh(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  }
  function mh(t, e) {
    if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e && (typeof e == "object" || typeof e == "function") ? e : t;
  }
  function yh(t, e) {
    if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
  }
  var gh = function (t) {
    yh(e, t);
    function e(s) {
      dh(this, e);
      var r = mh(this, t.call(this, s));
      return r.type = ph.CLASS, r;
    }
    return e.prototype.toString = function () {
      return [this.spaces.before, this.ns, "." + this.value, this.spaces.after].join("");
    }, e;
  }(fh.default);
  pr.default = gh;
  qa.exports = pr.default;
});
var Ma = g((hr, Da) => {
  "use strict";

  hr.__esModule = !0;
  var wh = ve(),
    vh = bh(wh),
    xh = M();
  function bh(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  function _h(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  }
  function Eh(t, e) {
    if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e && (typeof e == "object" || typeof e == "function") ? e : t;
  }
  function kh(t, e) {
    if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
  }
  var Sh = function (t) {
    kh(e, t);
    function e(s) {
      _h(this, e);
      var r = Eh(this, t.call(this, s));
      return r.type = xh.COMMENT, r;
    }
    return e;
  }(vh.default);
  hr.default = Sh;
  Da.exports = hr.default;
});
var Ua = g((dr, Ba) => {
  "use strict";

  dr.__esModule = !0;
  var Th = $e(),
    Oh = Ah(Th),
    Ch = M();
  function Ah(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  function Nh(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  }
  function Ph(t, e) {
    if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e && (typeof e == "object" || typeof e == "function") ? e : t;
  }
  function Rh(t, e) {
    if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
  }
  var Ih = function (t) {
    Rh(e, t);
    function e(s) {
      Nh(this, e);
      var r = Ph(this, t.call(this, s));
      return r.type = Ch.ID, r;
    }
    return e.prototype.toString = function () {
      return [this.spaces.before, this.ns, "#" + this.value, this.spaces.after].join("");
    }, e;
  }(Oh.default);
  dr.default = Ih;
  Ba.exports = dr.default;
});
var $a = g((mr, Fa) => {
  "use strict";

  mr.__esModule = !0;
  var qh = $e(),
    Lh = Mh(qh),
    Dh = M();
  function Mh(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  function Bh(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  }
  function Uh(t, e) {
    if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e && (typeof e == "object" || typeof e == "function") ? e : t;
  }
  function Fh(t, e) {
    if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
  }
  var $h = function (t) {
    Fh(e, t);
    function e(s) {
      Bh(this, e);
      var r = Uh(this, t.call(this, s));
      return r.type = Dh.TAG, r;
    }
    return e;
  }(Lh.default);
  mr.default = $h;
  Fa.exports = mr.default;
});
var Ga = g((yr, Wa) => {
  "use strict";

  yr.__esModule = !0;
  var Wh = ve(),
    Gh = Vh(Wh),
    Yh = M();
  function Vh(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  function zh(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  }
  function Hh(t, e) {
    if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e && (typeof e == "object" || typeof e == "function") ? e : t;
  }
  function jh(t, e) {
    if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
  }
  var Kh = function (t) {
    jh(e, t);
    function e(s) {
      zh(this, e);
      var r = Hh(this, t.call(this, s));
      return r.type = Yh.STRING, r;
    }
    return e;
  }(Gh.default);
  yr.default = Kh;
  Wa.exports = yr.default;
});
var Va = g((gr, Ya) => {
  "use strict";

  gr.__esModule = !0;
  var Qh = ur(),
    Xh = Zh(Qh),
    Jh = M();
  function Zh(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  function ed(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  }
  function td(t, e) {
    if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e && (typeof e == "object" || typeof e == "function") ? e : t;
  }
  function rd(t, e) {
    if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
  }
  var sd = function (t) {
    rd(e, t);
    function e(s) {
      ed(this, e);
      var r = td(this, t.call(this, s));
      return r.type = Jh.PSEUDO, r;
    }
    return e.prototype.toString = function () {
      var r = this.length ? "(" + this.map(String).join(",") + ")" : "";
      return [this.spaces.before, String(this.value), r, this.spaces.after].join("");
    }, e;
  }(Xh.default);
  gr.default = sd;
  Ya.exports = gr.default;
});
var Ha = g((wr, za) => {
  "use strict";

  wr.__esModule = !0;
  var nd = $e(),
    id = ad(nd),
    od = M();
  function ad(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  function ud(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  }
  function ld(t, e) {
    if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e && (typeof e == "object" || typeof e == "function") ? e : t;
  }
  function cd(t, e) {
    if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
  }
  var fd = function (t) {
    cd(e, t);
    function e(s) {
      ud(this, e);
      var r = ld(this, t.call(this, s));
      return r.type = od.ATTRIBUTE, r.raws = {}, r;
    }
    return e.prototype.toString = function () {
      var r = [this.spaces.before, "[", this.ns, this.attribute];
      return this.operator && r.push(this.operator), this.value && r.push(this.value), this.raws.insensitive ? r.push(this.raws.insensitive) : this.insensitive && r.push(" i"), r.push("]"), r.concat(this.spaces.after).join("");
    }, e;
  }(id.default);
  wr.default = fd;
  za.exports = wr.default;
});
var Ka = g((vr, ja) => {
  "use strict";

  vr.__esModule = !0;
  var pd = $e(),
    hd = md(pd),
    dd = M();
  function md(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  function yd(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  }
  function gd(t, e) {
    if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e && (typeof e == "object" || typeof e == "function") ? e : t;
  }
  function wd(t, e) {
    if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
  }
  var vd = function (t) {
    wd(e, t);
    function e(s) {
      yd(this, e);
      var r = gd(this, t.call(this, s));
      return r.type = dd.UNIVERSAL, r.value = "*", r;
    }
    return e;
  }(hd.default);
  vr.default = vd;
  ja.exports = vr.default;
});
var Xa = g((xr, Qa) => {
  "use strict";

  xr.__esModule = !0;
  var xd = ve(),
    bd = Ed(xd),
    _d = M();
  function Ed(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  function kd(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  }
  function Sd(t, e) {
    if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e && (typeof e == "object" || typeof e == "function") ? e : t;
  }
  function Td(t, e) {
    if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
  }
  var Od = function (t) {
    Td(e, t);
    function e(s) {
      kd(this, e);
      var r = Sd(this, t.call(this, s));
      return r.type = _d.COMBINATOR, r;
    }
    return e;
  }(bd.default);
  xr.default = Od;
  Qa.exports = xr.default;
});
var Za = g((br, Ja) => {
  "use strict";

  br.__esModule = !0;
  var Cd = ve(),
    Ad = Pd(Cd),
    Nd = M();
  function Pd(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  function Rd(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  }
  function Id(t, e) {
    if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e && (typeof e == "object" || typeof e == "function") ? e : t;
  }
  function qd(t, e) {
    if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
  }
  var Ld = function (t) {
    qd(e, t);
    function e(s) {
      Rd(this, e);
      var r = Id(this, t.call(this, s));
      return r.type = Nd.NESTING, r.value = "&", r;
    }
    return e;
  }(Ad.default);
  br.default = Ld;
  Ja.exports = br.default;
});
var tu = g((_r, eu) => {
  "use strict";

  _r.__esModule = !0;
  _r.default = Dd;
  function Dd(t) {
    return t.sort(function (e, s) {
      return e - s;
    });
  }
  eu.exports = _r.default;
});
var cu = g((Sr, lu) => {
  "use strict";

  Sr.__esModule = !0;
  Sr.default = Hd;
  var ru = 39,
    Md = 34,
    $s = 92,
    su = 47,
    St = 10,
    Ws = 32,
    Gs = 12,
    Ys = 9,
    Vs = 13,
    nu = 43,
    iu = 62,
    ou = 126,
    au = 124,
    Bd = 44,
    Ud = 40,
    Fd = 41,
    $d = 91,
    Wd = 93,
    Gd = 59,
    uu = 42,
    Yd = 58,
    Vd = 38,
    zd = 64,
    Er = /[ \n\t\r\{\(\)'"\\;/]/g,
    kr = /[ \n\t\r\(\)\*:;@!&'"\+\|~>,\[\]\\]|\/(?=\*)/g;
  function Hd(t) {
    for (var e = [], s = t.css.valueOf(), r = void 0, n = void 0, i = void 0, o = void 0, u = void 0, a = void 0, c = void 0, f = void 0, p = void 0, l = void 0, d = void 0, x = s.length, h = -1, m = 1, y = 0, b = function (v, R) {
        if (t.safe) s += R, n = s.length - 1;else throw t.error("Unclosed " + v, m, y - h, y);
      }; y < x;) {
      switch (r = s.charCodeAt(y), r === St && (h = y, m += 1), r) {
        case St:
        case Ws:
        case Ys:
        case Vs:
        case Gs:
          n = y;
          do n += 1, r = s.charCodeAt(n), r === St && (h = n, m += 1); while (r === Ws || r === St || r === Ys || r === Vs || r === Gs);
          e.push(["space", s.slice(y, n), m, y - h, y]), y = n - 1;
          break;
        case nu:
        case iu:
        case ou:
        case au:
          n = y;
          do n += 1, r = s.charCodeAt(n); while (r === nu || r === iu || r === ou || r === au);
          e.push(["combinator", s.slice(y, n), m, y - h, y]), y = n - 1;
          break;
        case uu:
          e.push(["*", "*", m, y - h, y]);
          break;
        case Vd:
          e.push(["&", "&", m, y - h, y]);
          break;
        case Bd:
          e.push([",", ",", m, y - h, y]);
          break;
        case $d:
          e.push(["[", "[", m, y - h, y]);
          break;
        case Wd:
          e.push(["]", "]", m, y - h, y]);
          break;
        case Yd:
          e.push([":", ":", m, y - h, y]);
          break;
        case Gd:
          e.push([";", ";", m, y - h, y]);
          break;
        case Ud:
          e.push(["(", "(", m, y - h, y]);
          break;
        case Fd:
          e.push([")", ")", m, y - h, y]);
          break;
        case ru:
        case Md:
          i = r === ru ? "'" : '"', n = y;
          do for (l = !1, n = s.indexOf(i, n + 1), n === -1 && b("quote", i), d = n; s.charCodeAt(d - 1) === $s;) d -= 1, l = !l; while (l);
          e.push(["string", s.slice(y, n + 1), m, y - h, m, n - h, y]), y = n;
          break;
        case zd:
          Er.lastIndex = y + 1, Er.test(s), Er.lastIndex === 0 ? n = s.length - 1 : n = Er.lastIndex - 2, e.push(["at-word", s.slice(y, n + 1), m, y - h, m, n - h, y]), y = n;
          break;
        case $s:
          for (n = y, c = !0; s.charCodeAt(n + 1) === $s;) n += 1, c = !c;
          r = s.charCodeAt(n + 1), c && r !== su && r !== Ws && r !== St && r !== Ys && r !== Vs && r !== Gs && (n += 1), e.push(["word", s.slice(y, n + 1), m, y - h, m, n - h, y]), y = n;
          break;
        default:
          r === su && s.charCodeAt(y + 1) === uu ? (n = s.indexOf("*/", y + 2) + 1, n === 0 && b("comment", "*/"), a = s.slice(y, n + 1), o = a.split(`
`), u = o.length - 1, u > 0 ? (f = m + u, p = n - o[u].length) : (f = m, p = h), e.push(["comment", a, m, y - h, f, n - p, y]), h = p, m = f, y = n) : (kr.lastIndex = y + 1, kr.test(s), kr.lastIndex === 0 ? n = s.length - 1 : n = kr.lastIndex - 2, e.push(["word", s.slice(y, n + 1), m, y - h, m, n - h, y]), y = n);
          break;
      }
      y++;
    }
    return e;
  }
  lu.exports = Sr.default;
});
var hu = g((Tr, pu) => {
  "use strict";

  Tr.__esModule = !0;
  var jd = function () {
      function t(e, s) {
        for (var r = 0; r < s.length; r++) {
          var n = s[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }
      return function (e, s, r) {
        return s && t(e.prototype, s), r && t(e, r), e;
      };
    }(),
    Kd = Bs(),
    Qd = I(Kd),
    Xd = Us(),
    zs = I(Xd),
    Jd = Fs(),
    Zd = I(Jd),
    em = Na(),
    tm = I(em),
    rm = Ra(),
    Hs = I(rm),
    sm = La(),
    nm = I(sm),
    im = Ma(),
    om = I(im),
    am = Ua(),
    um = I(am),
    lm = $a(),
    cm = I(lm),
    fm = Ga(),
    pm = I(fm),
    hm = Va(),
    dm = I(hm),
    mm = Ha(),
    ym = I(mm),
    gm = Ka(),
    wm = I(gm),
    vm = Xa(),
    xm = I(vm),
    bm = Za(),
    _m = I(bm),
    Em = tu(),
    km = I(Em),
    Sm = cu(),
    fu = I(Sm),
    Tm = M(),
    Om = Cm(Tm);
  function Cm(t) {
    if (t && t.__esModule) return t;
    var e = {};
    if (t != null) for (var s in t) Object.prototype.hasOwnProperty.call(t, s) && (e[s] = t[s]);
    return e.default = t, e;
  }
  function I(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  function Am(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  }
  var Nm = function () {
    function t(e) {
      Am(this, t), this.input = e, this.lossy = e.options.lossless === !1, this.position = 0, this.root = new tm.default();
      var s = new Hs.default();
      return this.root.append(s), this.current = s, this.lossy ? this.tokens = (0, fu.default)({
        safe: e.safe,
        css: e.css.trim()
      }) : this.tokens = (0, fu.default)(e), this.loop();
    }
    return t.prototype.attribute = function () {
      var s = "",
        r = void 0,
        n = this.currToken;
      for (this.position++; this.position < this.tokens.length && this.currToken[0] !== "]";) s += this.tokens[this.position][1], this.position++;
      this.position === this.tokens.length && !~s.indexOf("]") && this.error("Expected a closing square bracket.");
      var i = s.split(/((?:[*~^$|]?=))([^]*)/),
        o = i[0].split(/(\|)/g),
        u = {
          operator: i[1],
          value: i[2],
          source: {
            start: {
              line: n[2],
              column: n[3]
            },
            end: {
              line: this.currToken[2],
              column: this.currToken[3]
            }
          },
          sourceIndex: n[4]
        };
      if (o.length > 1 ? (o[0] === "" && (o[0] = !0), u.attribute = this.parseValue(o[2]), u.namespace = this.parseNamespace(o[0])) : u.attribute = this.parseValue(i[0]), r = new ym.default(u), i[2]) {
        var a = i[2].split(/(\s+i\s*?)$/),
          c = a[0].trim();
        r.value = this.lossy ? c : a[0], a[1] && (r.insensitive = !0, this.lossy || (r.raws.insensitive = a[1])), r.quoted = c[0] === "'" || c[0] === '"', r.raws.unquoted = r.quoted ? c.slice(1, -1) : c;
      }
      this.newNode(r), this.position++;
    }, t.prototype.combinator = function () {
      if (this.currToken[1] === "|") return this.namespace();
      for (var s = new xm.default({
        value: "",
        source: {
          start: {
            line: this.currToken[2],
            column: this.currToken[3]
          },
          end: {
            line: this.currToken[2],
            column: this.currToken[3]
          }
        },
        sourceIndex: this.currToken[4]
      }); this.position < this.tokens.length && this.currToken && (this.currToken[0] === "space" || this.currToken[0] === "combinator");) this.nextToken && this.nextToken[0] === "combinator" ? (s.spaces.before = this.parseSpace(this.currToken[1]), s.source.start.line = this.nextToken[2], s.source.start.column = this.nextToken[3], s.source.end.column = this.nextToken[3], s.source.end.line = this.nextToken[2], s.sourceIndex = this.nextToken[4]) : this.prevToken && this.prevToken[0] === "combinator" ? s.spaces.after = this.parseSpace(this.currToken[1]) : this.currToken[0] === "combinator" ? s.value = this.currToken[1] : this.currToken[0] === "space" && (s.value = this.parseSpace(this.currToken[1], " ")), this.position++;
      return this.newNode(s);
    }, t.prototype.comma = function () {
      if (this.position === this.tokens.length - 1) {
        this.root.trailingComma = !0, this.position++;
        return;
      }
      var s = new Hs.default();
      this.current.parent.append(s), this.current = s, this.position++;
    }, t.prototype.comment = function () {
      var s = new om.default({
        value: this.currToken[1],
        source: {
          start: {
            line: this.currToken[2],
            column: this.currToken[3]
          },
          end: {
            line: this.currToken[4],
            column: this.currToken[5]
          }
        },
        sourceIndex: this.currToken[6]
      });
      this.newNode(s), this.position++;
    }, t.prototype.error = function (s) {
      throw new this.input.error(s);
    }, t.prototype.missingBackslash = function () {
      return this.error("Expected a backslash preceding the semicolon.");
    }, t.prototype.missingParenthesis = function () {
      return this.error("Expected opening parenthesis.");
    }, t.prototype.missingSquareBracket = function () {
      return this.error("Expected opening square bracket.");
    }, t.prototype.namespace = function () {
      var s = this.prevToken && this.prevToken[1] || !0;
      if (this.nextToken[0] === "word") return this.position++, this.word(s);
      if (this.nextToken[0] === "*") return this.position++, this.universal(s);
    }, t.prototype.nesting = function () {
      this.newNode(new _m.default({
        value: this.currToken[1],
        source: {
          start: {
            line: this.currToken[2],
            column: this.currToken[3]
          },
          end: {
            line: this.currToken[2],
            column: this.currToken[3]
          }
        },
        sourceIndex: this.currToken[4]
      })), this.position++;
    }, t.prototype.parentheses = function () {
      var s = this.current.last;
      if (s && s.type === Om.PSEUDO) {
        var r = new Hs.default(),
          n = this.current;
        s.append(r), this.current = r;
        var i = 1;
        for (this.position++; this.position < this.tokens.length && i;) this.currToken[0] === "(" && i++, this.currToken[0] === ")" && i--, i ? this.parse() : (r.parent.source.end.line = this.currToken[2], r.parent.source.end.column = this.currToken[3], this.position++);
        i && this.error("Expected closing parenthesis."), this.current = n;
      } else {
        var o = 1;
        for (this.position++, s.value += "("; this.position < this.tokens.length && o;) this.currToken[0] === "(" && o++, this.currToken[0] === ")" && o--, s.value += this.parseParenthesisToken(this.currToken), this.position++;
        o && this.error("Expected closing parenthesis.");
      }
    }, t.prototype.pseudo = function () {
      for (var s = this, r = "", n = this.currToken; this.currToken && this.currToken[0] === ":";) r += this.currToken[1], this.position++;
      if (!this.currToken) return this.error("Expected pseudo-class or pseudo-element");
      if (this.currToken[0] === "word") {
        var i = void 0;
        this.splitWord(!1, function (o, u) {
          r += o, i = new dm.default({
            value: r,
            source: {
              start: {
                line: n[2],
                column: n[3]
              },
              end: {
                line: s.currToken[4],
                column: s.currToken[5]
              }
            },
            sourceIndex: n[4]
          }), s.newNode(i), u > 1 && s.nextToken && s.nextToken[0] === "(" && s.error("Misplaced parenthesis.");
        });
      } else this.error('Unexpected "' + this.currToken[0] + '" found.');
    }, t.prototype.space = function () {
      var s = this.currToken;
      this.position === 0 || this.prevToken[0] === "," || this.prevToken[0] === "(" ? (this.spaces = this.parseSpace(s[1]), this.position++) : this.position === this.tokens.length - 1 || this.nextToken[0] === "," || this.nextToken[0] === ")" ? (this.current.last.spaces.after = this.parseSpace(s[1]), this.position++) : this.combinator();
    }, t.prototype.string = function () {
      var s = this.currToken;
      this.newNode(new pm.default({
        value: this.currToken[1],
        source: {
          start: {
            line: s[2],
            column: s[3]
          },
          end: {
            line: s[4],
            column: s[5]
          }
        },
        sourceIndex: s[6]
      })), this.position++;
    }, t.prototype.universal = function (s) {
      var r = this.nextToken;
      if (r && r[1] === "|") return this.position++, this.namespace();
      this.newNode(new wm.default({
        value: this.currToken[1],
        source: {
          start: {
            line: this.currToken[2],
            column: this.currToken[3]
          },
          end: {
            line: this.currToken[2],
            column: this.currToken[3]
          }
        },
        sourceIndex: this.currToken[4]
      }), s), this.position++;
    }, t.prototype.splitWord = function (s, r) {
      for (var n = this, i = this.nextToken, o = this.currToken[1]; i && i[0] === "word";) {
        this.position++;
        var u = this.currToken[1];
        if (o += u, u.lastIndexOf("\\") === u.length - 1) {
          var a = this.nextToken;
          a && a[0] === "space" && (o += this.parseSpace(a[1], " "), this.position++);
        }
        i = this.nextToken;
      }
      var c = (0, zs.default)(o, "."),
        f = (0, zs.default)(o, "#"),
        p = (0, zs.default)(o, "#{");
      p.length && (f = f.filter(function (d) {
        return !~p.indexOf(d);
      }));
      var l = (0, km.default)((0, Zd.default)((0, Qd.default)([[0], c, f])));
      l.forEach(function (d, x) {
        var h = l[x + 1] || o.length,
          m = o.slice(d, h);
        if (x === 0 && r) return r.call(n, m, l.length);
        var y = void 0;
        ~c.indexOf(d) ? y = new nm.default({
          value: m.slice(1),
          source: {
            start: {
              line: n.currToken[2],
              column: n.currToken[3] + d
            },
            end: {
              line: n.currToken[4],
              column: n.currToken[3] + (h - 1)
            }
          },
          sourceIndex: n.currToken[6] + l[x]
        }) : ~f.indexOf(d) ? y = new um.default({
          value: m.slice(1),
          source: {
            start: {
              line: n.currToken[2],
              column: n.currToken[3] + d
            },
            end: {
              line: n.currToken[4],
              column: n.currToken[3] + (h - 1)
            }
          },
          sourceIndex: n.currToken[6] + l[x]
        }) : y = new cm.default({
          value: m,
          source: {
            start: {
              line: n.currToken[2],
              column: n.currToken[3] + d
            },
            end: {
              line: n.currToken[4],
              column: n.currToken[3] + (h - 1)
            }
          },
          sourceIndex: n.currToken[6] + l[x]
        }), n.newNode(y, s);
      }), this.position++;
    }, t.prototype.word = function (s) {
      var r = this.nextToken;
      return r && r[1] === "|" ? (this.position++, this.namespace()) : this.splitWord(s);
    }, t.prototype.loop = function () {
      for (; this.position < this.tokens.length;) this.parse(!0);
      return this.root;
    }, t.prototype.parse = function (s) {
      switch (this.currToken[0]) {
        case "space":
          this.space();
          break;
        case "comment":
          this.comment();
          break;
        case "(":
          this.parentheses();
          break;
        case ")":
          s && this.missingParenthesis();
          break;
        case "[":
          this.attribute();
          break;
        case "]":
          this.missingSquareBracket();
          break;
        case "at-word":
        case "word":
          this.word();
          break;
        case ":":
          this.pseudo();
          break;
        case ";":
          this.missingBackslash();
          break;
        case ",":
          this.comma();
          break;
        case "*":
          this.universal();
          break;
        case "&":
          this.nesting();
          break;
        case "combinator":
          this.combinator();
          break;
        case "string":
          this.string();
          break;
      }
    }, t.prototype.parseNamespace = function (s) {
      if (this.lossy && typeof s == "string") {
        var r = s.trim();
        return r.length ? r : !0;
      }
      return s;
    }, t.prototype.parseSpace = function (s, r) {
      return this.lossy ? r || "" : s;
    }, t.prototype.parseValue = function (s) {
      return this.lossy && s && typeof s == "string" ? s.trim() : s;
    }, t.prototype.parseParenthesisToken = function (s) {
      return this.lossy ? s[0] === "space" ? this.parseSpace(s[1], " ") : this.parseValue(s[1]) : s[1];
    }, t.prototype.newNode = function (s, r) {
      return r && (s.namespace = this.parseNamespace(r)), this.spaces && (s.spaces.before = this.spaces, this.spaces = ""), this.current.append(s);
    }, jd(t, [{
      key: "currToken",
      get: function () {
        return this.tokens[this.position];
      }
    }, {
      key: "nextToken",
      get: function () {
        return this.tokens[this.position + 1];
      }
    }, {
      key: "prevToken",
      get: function () {
        return this.tokens[this.position - 1];
      }
    }]), t;
  }();
  Tr.default = Nm;
  pu.exports = Tr.default;
});
var mu = g((Or, du) => {
  "use strict";

  Or.__esModule = !0;
  var Pm = function () {
      function t(e, s) {
        for (var r = 0; r < s.length; r++) {
          var n = s[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }
      return function (e, s, r) {
        return s && t(e.prototype, s), r && t(e, r), e;
      };
    }(),
    Rm = hu(),
    Im = qm(Rm);
  function qm(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  function Lm(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  }
  var Dm = function () {
    function t(e) {
      return Lm(this, t), this.func = e || function () {}, this;
    }
    return t.prototype.process = function (s) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
        n = new Im.default({
          css: s,
          error: function (o) {
            throw new Error(o);
          },
          options: r
        });
      return this.res = n, this.func(n), this;
    }, Pm(t, [{
      key: "result",
      get: function () {
        return String(this.res);
      }
    }]), t;
  }();
  Or.default = Dm;
  du.exports = Or.default;
});
var z = g((tb, gu) => {
  "use strict";

  var js = function (t, e) {
    let s = new t.constructor();
    for (let r in t) {
      if (!t.hasOwnProperty(r)) continue;
      let n = t[r],
        i = typeof n;
      r === "parent" && i === "object" ? e && (s[r] = e) : r === "source" ? s[r] = n : n instanceof Array ? s[r] = n.map(o => js(o, s)) : r !== "before" && r !== "after" && r !== "between" && r !== "semicolon" && (i === "object" && n !== null && (n = js(n)), s[r] = n);
    }
    return s;
  };
  gu.exports = class {
    constructor(e) {
      e = e || {}, this.raws = {
        before: "",
        after: ""
      };
      for (let s in e) this[s] = e[s];
    }
    remove() {
      return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
    }
    toString() {
      return [this.raws.before, String(this.value), this.raws.after].join("");
    }
    clone(e) {
      e = e || {};
      let s = js(this);
      for (let r in e) s[r] = e[r];
      return s;
    }
    cloneBefore(e) {
      e = e || {};
      let s = this.clone(e);
      return this.parent.insertBefore(this, s), s;
    }
    cloneAfter(e) {
      e = e || {};
      let s = this.clone(e);
      return this.parent.insertAfter(this, s), s;
    }
    replaceWith() {
      let e = Array.prototype.slice.call(arguments);
      if (this.parent) {
        for (let s of e) this.parent.insertBefore(this, s);
        this.remove();
      }
      return this;
    }
    moveTo(e) {
      return this.cleanRaws(this.root() === e.root()), this.remove(), e.append(this), this;
    }
    moveBefore(e) {
      return this.cleanRaws(this.root() === e.root()), this.remove(), e.parent.insertBefore(e, this), this;
    }
    moveAfter(e) {
      return this.cleanRaws(this.root() === e.root()), this.remove(), e.parent.insertAfter(e, this), this;
    }
    next() {
      let e = this.parent.index(this);
      return this.parent.nodes[e + 1];
    }
    prev() {
      let e = this.parent.index(this);
      return this.parent.nodes[e - 1];
    }
    toJSON() {
      let e = {};
      for (let s in this) {
        if (!this.hasOwnProperty(s) || s === "parent") continue;
        let r = this[s];
        r instanceof Array ? e[s] = r.map(n => typeof n == "object" && n.toJSON ? n.toJSON() : n) : typeof r == "object" && r.toJSON ? e[s] = r.toJSON() : e[s] = r;
      }
      return e;
    }
    root() {
      let e = this;
      for (; e.parent;) e = e.parent;
      return e;
    }
    cleanRaws(e) {
      delete this.raws.before, delete this.raws.after, e || delete this.raws.between;
    }
    positionInside(e) {
      let s = this.toString(),
        r = this.source.start.column,
        n = this.source.start.line;
      for (let i = 0; i < e; i++) s[i] === `
` ? (r = 1, n += 1) : r += 1;
      return {
        line: n,
        column: r
      };
    }
    positionBy(e) {
      let s = this.source.start;
      if (Object(e).index) s = this.positionInside(e.index);else if (Object(e).word) {
        let r = this.toString().indexOf(e.word);
        r !== -1 && (s = this.positionInside(r));
      }
      return s;
    }
  };
});
var U = g((rb, wu) => {
  "use strict";

  var Bm = z(),
    We = class extends Bm {
      constructor(e) {
        super(e), this.nodes || (this.nodes = []);
      }
      push(e) {
        return e.parent = this, this.nodes.push(e), this;
      }
      each(e) {
        this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
        let s = this.lastEach,
          r,
          n;
        if (this.indexes[s] = 0, !!this.nodes) {
          for (; this.indexes[s] < this.nodes.length && (r = this.indexes[s], n = e(this.nodes[r], r), n !== !1);) this.indexes[s] += 1;
          return delete this.indexes[s], n;
        }
      }
      walk(e) {
        return this.each((s, r) => {
          let n = e(s, r);
          return n !== !1 && s.walk && (n = s.walk(e)), n;
        });
      }
      walkType(e, s) {
        if (!e || !s) throw new Error("Parameters {type} and {callback} are required.");
        let r = typeof e == "function";
        return this.walk((n, i) => {
          if (r && n instanceof e || !r && n.type === e) return s.call(this, n, i);
        });
      }
      append(e) {
        return e.parent = this, this.nodes.push(e), this;
      }
      prepend(e) {
        return e.parent = this, this.nodes.unshift(e), this;
      }
      cleanRaws(e) {
        if (super.cleanRaws(e), this.nodes) for (let s of this.nodes) s.cleanRaws(e);
      }
      insertAfter(e, s) {
        let r = this.index(e),
          n;
        this.nodes.splice(r + 1, 0, s);
        for (let i in this.indexes) n = this.indexes[i], r <= n && (this.indexes[i] = n + this.nodes.length);
        return this;
      }
      insertBefore(e, s) {
        let r = this.index(e),
          n;
        this.nodes.splice(r, 0, s);
        for (let i in this.indexes) n = this.indexes[i], r <= n && (this.indexes[i] = n + this.nodes.length);
        return this;
      }
      removeChild(e) {
        e = this.index(e), this.nodes[e].parent = void 0, this.nodes.splice(e, 1);
        let s;
        for (let r in this.indexes) s = this.indexes[r], s >= e && (this.indexes[r] = s - 1);
        return this;
      }
      removeAll() {
        for (let e of this.nodes) e.parent = void 0;
        return this.nodes = [], this;
      }
      every(e) {
        return this.nodes.every(e);
      }
      some(e) {
        return this.nodes.some(e);
      }
      index(e) {
        return typeof e == "number" ? e : this.nodes.indexOf(e);
      }
      get first() {
        if (this.nodes) return this.nodes[0];
      }
      get last() {
        if (this.nodes) return this.nodes[this.nodes.length - 1];
      }
      toString() {
        let e = this.nodes.map(String).join("");
        return this.value && (e = this.value + e), this.raws.before && (e = this.raws.before + e), this.raws.after && (e += this.raws.after), e;
      }
    };
  We.registerWalker = t => {
    let e = "walk" + t.name;
    e.lastIndexOf("s") !== e.length - 1 && (e += "s"), !We.prototype[e] && (We.prototype[e] = function (s) {
      return this.walkType(t, s);
    });
  };
  wu.exports = We;
});
var xu = g((nb, vu) => {
  "use strict";

  var Um = U();
  vu.exports = class extends Um {
    constructor(e) {
      super(e), this.type = "root";
    }
  };
});
var _u = g((ob, bu) => {
  "use strict";

  var Fm = U();
  bu.exports = class extends Fm {
    constructor(e) {
      super(e), this.type = "value", this.unbalanced = 0;
    }
  };
});
var Su = g((ab, ku) => {
  "use strict";

  var Eu = U(),
    Cr = class extends Eu {
      constructor(e) {
        super(e), this.type = "atword";
      }
      toString() {
        let e = this.quoted ? this.raws.quote : "";
        return [this.raws.before, "@", String.prototype.toString.call(this.value), this.raws.after].join("");
      }
    };
  Eu.registerWalker(Cr);
  ku.exports = Cr;
});
var Ou = g((ub, Tu) => {
  "use strict";

  var $m = U(),
    Wm = z(),
    Ar = class extends Wm {
      constructor(e) {
        super(e), this.type = "colon";
      }
    };
  $m.registerWalker(Ar);
  Tu.exports = Ar;
});
var Au = g((lb, Cu) => {
  "use strict";

  var Gm = U(),
    Ym = z(),
    Nr = class extends Ym {
      constructor(e) {
        super(e), this.type = "comma";
      }
    };
  Gm.registerWalker(Nr);
  Cu.exports = Nr;
});
var Pu = g((cb, Nu) => {
  "use strict";

  var Vm = U(),
    zm = z(),
    Pr = class extends zm {
      constructor(e) {
        super(e), this.type = "comment", this.inline = Object(e).inline || !1;
      }
      toString() {
        return [this.raws.before, this.inline ? "//" : "/*", String(this.value), this.inline ? "" : "*/", this.raws.after].join("");
      }
    };
  Vm.registerWalker(Pr);
  Nu.exports = Pr;
});
var qu = g((fb, Iu) => {
  "use strict";

  var Ru = U(),
    Rr = class extends Ru {
      constructor(e) {
        super(e), this.type = "func", this.unbalanced = -1;
      }
    };
  Ru.registerWalker(Rr);
  Iu.exports = Rr;
});
var Du = g((pb, Lu) => {
  "use strict";

  var Hm = U(),
    jm = z(),
    Ir = class extends jm {
      constructor(e) {
        super(e), this.type = "number", this.unit = Object(e).unit || "";
      }
      toString() {
        return [this.raws.before, String(this.value), this.unit, this.raws.after].join("");
      }
    };
  Hm.registerWalker(Ir);
  Lu.exports = Ir;
});
var Bu = g((hb, Mu) => {
  "use strict";

  var Km = U(),
    Qm = z(),
    qr = class extends Qm {
      constructor(e) {
        super(e), this.type = "operator";
      }
    };
  Km.registerWalker(qr);
  Mu.exports = qr;
});
var Fu = g((db, Uu) => {
  "use strict";

  var Xm = U(),
    Jm = z(),
    Lr = class extends Jm {
      constructor(e) {
        super(e), this.type = "paren", this.parenType = "";
      }
    };
  Xm.registerWalker(Lr);
  Uu.exports = Lr;
});
var Wu = g((mb, $u) => {
  "use strict";

  var Zm = U(),
    ey = z(),
    Dr = class extends ey {
      constructor(e) {
        super(e), this.type = "string";
      }
      toString() {
        let e = this.quoted ? this.raws.quote : "";
        return [this.raws.before, e, this.value + "", e, this.raws.after].join("");
      }
    };
  Zm.registerWalker(Dr);
  $u.exports = Dr;
});
var Yu = g((yb, Gu) => {
  "use strict";

  var ty = U(),
    ry = z(),
    Mr = class extends ry {
      constructor(e) {
        super(e), this.type = "word";
      }
    };
  ty.registerWalker(Mr);
  Gu.exports = Mr;
});
var zu = g((gb, Vu) => {
  "use strict";

  var sy = U(),
    ny = z(),
    Br = class extends ny {
      constructor(e) {
        super(e), this.type = "unicode-range";
      }
    };
  sy.registerWalker(Br);
  Vu.exports = Br;
});
var ju = g((wb, Hu) => {
  "use strict";

  var Ks = class extends Error {
    constructor(e) {
      super(e), this.name = this.constructor.name, this.message = e || "An error ocurred while tokzenizing.", typeof Error.captureStackTrace == "function" ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error(e).stack;
    }
  };
  Hu.exports = Ks;
});
var Xu = g((vb, Qu) => {
  "use strict";

  var Ur = /[ \n\t\r\{\(\)'"\\;,/]/g,
    iy = /[ \n\t\r\(\)\{\}\*:;@!&'"\+\|~>,\[\]\\]|\/(?=\*)/g,
    Ge = /[ \n\t\r\(\)\{\}\*:;@!&'"\-\+\|~>,\[\]\\]|\//g,
    oy = /^[a-z0-9]/i,
    ay = /^[a-f0-9?\-]/i,
    Ku = ju();
  Qu.exports = function (e, s) {
    s = s || {};
    let r = [],
      n = e.valueOf(),
      i = n.length,
      o = -1,
      u = 1,
      a = 0,
      c = 0,
      f = null,
      p,
      l,
      d,
      x,
      h,
      m,
      y,
      b,
      w,
      v,
      R,
      F;
    function Q(T) {
      let O = `Unclosed ${T} at line: ${u}, column: ${a - o}, token: ${a}`;
      throw new Ku(O);
    }
    function W() {
      let T = `Syntax error at line: ${u}, column: ${a - o}, token: ${a}`;
      throw new Ku(T);
    }
    for (; a < i;) {
      switch (p = n.charCodeAt(a), p === 10 && (o = a, u += 1), p) {
        case 10:
        case 32:
        case 9:
        case 13:
        case 12:
          l = a;
          do l += 1, p = n.charCodeAt(l), p === 10 && (o = l, u += 1); while (p === 32 || p === 10 || p === 9 || p === 13 || p === 12);
          r.push(["space", n.slice(a, l), u, a - o, u, l - o, a]), a = l - 1;
          break;
        case 58:
          l = a + 1, r.push(["colon", n.slice(a, l), u, a - o, u, l - o, a]), a = l - 1;
          break;
        case 44:
          l = a + 1, r.push(["comma", n.slice(a, l), u, a - o, u, l - o, a]), a = l - 1;
          break;
        case 123:
          r.push(["{", "{", u, a - o, u, l - o, a]);
          break;
        case 125:
          r.push(["}", "}", u, a - o, u, l - o, a]);
          break;
        case 40:
          c++, f = !f && c === 1 && r.length > 0 && r[r.length - 1][0] === "word" && r[r.length - 1][1] === "url", r.push(["(", "(", u, a - o, u, l - o, a]);
          break;
        case 41:
          c--, f = f && c > 0, r.push([")", ")", u, a - o, u, l - o, a]);
          break;
        case 39:
        case 34:
          d = p === 39 ? "'" : '"', l = a;
          do for (v = !1, l = n.indexOf(d, l + 1), l === -1 && Q("quote", d), R = l; n.charCodeAt(R - 1) === 92;) R -= 1, v = !v; while (v);
          r.push(["string", n.slice(a, l + 1), u, a - o, u, l - o, a]), a = l;
          break;
        case 64:
          Ur.lastIndex = a + 1, Ur.test(n), Ur.lastIndex === 0 ? l = n.length - 1 : l = Ur.lastIndex - 2, r.push(["atword", n.slice(a, l + 1), u, a - o, u, l - o, a]), a = l;
          break;
        case 92:
          l = a, p = n.charCodeAt(l + 1), y && p !== 47 && p !== 32 && p !== 10 && p !== 9 && p !== 13 && p !== 12 && (l += 1), r.push(["word", n.slice(a, l + 1), u, a - o, u, l - o, a]), a = l;
          break;
        case 43:
        case 45:
        case 42:
          l = a + 1, F = n.slice(a + 1, l + 1);
          let T = n.slice(a - 1, a);
          if (p === 45 && F.charCodeAt(0) === 45) {
            l++, r.push(["word", n.slice(a, l), u, a - o, u, l - o, a]), a = l - 1;
            break;
          }
          r.push(["operator", n.slice(a, l), u, a - o, u, l - o, a]), a = l - 1;
          break;
        default:
          if (p === 47 && (n.charCodeAt(a + 1) === 42 || s.loose && !f && n.charCodeAt(a + 1) === 47)) {
            if (n.charCodeAt(a + 1) === 42) l = n.indexOf("*/", a + 2) + 1, l === 0 && Q("comment", "*/");else {
              let C = n.indexOf(`
`, a + 2);
              l = C !== -1 ? C - 1 : i;
            }
            m = n.slice(a, l + 1), x = m.split(`
`), h = x.length - 1, h > 0 ? (b = u + h, w = l - x[h].length) : (b = u, w = o), r.push(["comment", m, u, a - o, b, l - w, a]), o = w, u = b, a = l;
          } else if (p === 35 && !oy.test(n.slice(a + 1, a + 2))) l = a + 1, r.push(["#", n.slice(a, l), u, a - o, u, l - o, a]), a = l - 1;else if ((p === 117 || p === 85) && n.charCodeAt(a + 1) === 43) {
            l = a + 2;
            do l += 1, p = n.charCodeAt(l); while (l < i && ay.test(n.slice(l, l + 1)));
            r.push(["unicoderange", n.slice(a, l), u, a - o, u, l - o, a]), a = l - 1;
          } else if (p === 47) l = a + 1, r.push(["operator", n.slice(a, l), u, a - o, u, l - o, a]), a = l - 1;else {
            let O = iy;
            if (p >= 48 && p <= 57 && (O = Ge), O.lastIndex = a + 1, O.test(n), O.lastIndex === 0 ? l = n.length - 1 : l = O.lastIndex - 2, O === Ge || p === 46) {
              let C = n.charCodeAt(l),
                xe = n.charCodeAt(l + 1),
                tn = n.charCodeAt(l + 2);
              (C === 101 || C === 69) && (xe === 45 || xe === 43) && tn >= 48 && tn <= 57 && (Ge.lastIndex = l + 2, Ge.test(n), Ge.lastIndex === 0 ? l = n.length - 1 : l = Ge.lastIndex - 2);
            }
            r.push(["word", n.slice(a, l + 1), u, a - o, u, l - o, a]), a = l;
          }
          break;
      }
      a++;
    }
    return r;
  };
});
var Zu = g((xb, Ju) => {
  "use strict";

  var Qs = class extends Error {
    constructor(e) {
      super(e), this.name = this.constructor.name, this.message = e || "An error ocurred while parsing.", typeof Error.captureStackTrace == "function" ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error(e).stack;
    }
  };
  Ju.exports = Qs;
});
var sl = g((_b, rl) => {
  "use strict";

  var uy = xu(),
    ly = _u(),
    cy = Su(),
    fy = Ou(),
    py = Au(),
    hy = Pu(),
    dy = qu(),
    my = Du(),
    yy = Bu(),
    el = Fu(),
    gy = Wu(),
    tl = Yu(),
    wy = zu(),
    vy = Xu(),
    xy = Bs(),
    by = Us(),
    _y = Fs(),
    Ey = Zu();
  function ky(t) {
    return t.sort((e, s) => e - s);
  }
  rl.exports = class {
    constructor(e, s) {
      let r = {
        loose: !1
      };
      this.cache = [], this.input = e, this.options = Object.assign({}, r, s), this.position = 0, this.unbalanced = 0, this.root = new uy();
      let n = new ly();
      this.root.append(n), this.current = n, this.tokens = vy(e, this.options);
    }
    parse() {
      return this.loop();
    }
    colon() {
      let e = this.currToken;
      this.newNode(new fy({
        value: e[1],
        source: {
          start: {
            line: e[2],
            column: e[3]
          },
          end: {
            line: e[4],
            column: e[5]
          }
        },
        sourceIndex: e[6]
      })), this.position++;
    }
    comma() {
      let e = this.currToken;
      this.newNode(new py({
        value: e[1],
        source: {
          start: {
            line: e[2],
            column: e[3]
          },
          end: {
            line: e[4],
            column: e[5]
          }
        },
        sourceIndex: e[6]
      })), this.position++;
    }
    comment() {
      let e = !1,
        s = this.currToken[1].replace(/\/\*|\*\//g, ""),
        r;
      this.options.loose && s.startsWith("//") && (s = s.substring(2), e = !0), r = new hy({
        value: s,
        inline: e,
        source: {
          start: {
            line: this.currToken[2],
            column: this.currToken[3]
          },
          end: {
            line: this.currToken[4],
            column: this.currToken[5]
          }
        },
        sourceIndex: this.currToken[6]
      }), this.newNode(r), this.position++;
    }
    error(e, s) {
      throw new Ey(e + ` at line: ${s[2]}, column ${s[3]}`);
    }
    loop() {
      for (; this.position < this.tokens.length;) this.parseTokens();
      return !this.current.last && this.spaces ? this.current.raws.before += this.spaces : this.spaces && (this.current.last.raws.after += this.spaces), this.spaces = "", this.root;
    }
    operator() {
      let e = this.currToken[1],
        s;
      if (e === "+" || e === "-") {
        if (this.options.loose || this.position > 0 && (this.current.type === "func" && this.current.value === "calc" ? this.prevToken[0] !== "space" && this.prevToken[0] !== "(" ? this.error("Syntax Error", this.currToken) : this.nextToken[0] !== "space" && this.nextToken[0] !== "word" ? this.error("Syntax Error", this.currToken) : this.nextToken[0] === "word" && this.current.last.type !== "operator" && this.current.last.value !== "(" && this.error("Syntax Error", this.currToken) : (this.nextToken[0] === "space" || this.nextToken[0] === "operator" || this.prevToken[0] === "operator") && this.error("Syntax Error", this.currToken)), this.options.loose) {
          if ((!this.current.nodes.length || this.current.last && this.current.last.type === "operator") && this.nextToken[0] === "word") return this.word();
        } else if (this.nextToken[0] === "word") return this.word();
      }
      return s = new yy({
        value: this.currToken[1],
        source: {
          start: {
            line: this.currToken[2],
            column: this.currToken[3]
          },
          end: {
            line: this.currToken[2],
            column: this.currToken[3]
          }
        },
        sourceIndex: this.currToken[4]
      }), this.position++, this.newNode(s);
    }
    parseTokens() {
      switch (this.currToken[0]) {
        case "space":
          this.space();
          break;
        case "colon":
          this.colon();
          break;
        case "comma":
          this.comma();
          break;
        case "comment":
          this.comment();
          break;
        case "(":
          this.parenOpen();
          break;
        case ")":
          this.parenClose();
          break;
        case "atword":
        case "word":
          this.word();
          break;
        case "operator":
          this.operator();
          break;
        case "string":
          this.string();
          break;
        case "unicoderange":
          this.unicodeRange();
          break;
        default:
          this.word();
          break;
      }
    }
    parenOpen() {
      let e = 1,
        s = this.position + 1,
        r = this.currToken,
        n;
      for (; s < this.tokens.length && e;) {
        let i = this.tokens[s];
        i[0] === "(" && e++, i[0] === ")" && e--, s++;
      }
      if (e && this.error("Expected closing parenthesis", r), n = this.current.last, n && n.type === "func" && n.unbalanced < 0 && (n.unbalanced = 0, this.current = n), this.current.unbalanced++, this.newNode(new el({
        value: r[1],
        source: {
          start: {
            line: r[2],
            column: r[3]
          },
          end: {
            line: r[4],
            column: r[5]
          }
        },
        sourceIndex: r[6]
      })), this.position++, this.current.type === "func" && this.current.unbalanced && this.current.value === "url" && this.currToken[0] !== "string" && this.currToken[0] !== ")" && !this.options.loose) {
        let i = this.nextToken,
          o = this.currToken[1],
          u = {
            line: this.currToken[2],
            column: this.currToken[3]
          };
        for (; i && i[0] !== ")" && this.current.unbalanced;) this.position++, o += this.currToken[1], i = this.nextToken;
        this.position !== this.tokens.length - 1 && (this.position++, this.newNode(new tl({
          value: o,
          source: {
            start: u,
            end: {
              line: this.currToken[4],
              column: this.currToken[5]
            }
          },
          sourceIndex: this.currToken[6]
        })));
      }
    }
    parenClose() {
      let e = this.currToken;
      this.newNode(new el({
        value: e[1],
        source: {
          start: {
            line: e[2],
            column: e[3]
          },
          end: {
            line: e[4],
            column: e[5]
          }
        },
        sourceIndex: e[6]
      })), this.position++, !(this.position >= this.tokens.length - 1 && !this.current.unbalanced) && (this.current.unbalanced--, this.current.unbalanced < 0 && this.error("Expected opening parenthesis", e), !this.current.unbalanced && this.cache.length && (this.current = this.cache.pop()));
    }
    space() {
      let e = this.currToken;
      this.position === this.tokens.length - 1 || this.nextToken[0] === "," || this.nextToken[0] === ")" ? (this.current.last.raws.after += e[1], this.position++) : (this.spaces = e[1], this.position++);
    }
    unicodeRange() {
      let e = this.currToken;
      this.newNode(new wy({
        value: e[1],
        source: {
          start: {
            line: e[2],
            column: e[3]
          },
          end: {
            line: e[4],
            column: e[5]
          }
        },
        sourceIndex: e[6]
      })), this.position++;
    }
    splitWord() {
      let e = this.nextToken,
        s = this.currToken[1],
        r = /^[\+\-]?((\d+(\.\d*)?)|(\.\d+))([eE][\+\-]?\d+)?/,
        n = /^(?!\#([a-z0-9]+))[\#\{\}]/gi,
        i,
        o;
      if (!n.test(s)) for (; e && e[0] === "word";) {
        this.position++;
        let u = this.currToken[1];
        s += u, e = this.nextToken;
      }
      i = by(s, "@"), o = ky(_y(xy([[0], i]))), o.forEach((u, a) => {
        let c = o[a + 1] || s.length,
          f = s.slice(u, c),
          p;
        if (~i.indexOf(u)) p = new cy({
          value: f.slice(1),
          source: {
            start: {
              line: this.currToken[2],
              column: this.currToken[3] + u
            },
            end: {
              line: this.currToken[4],
              column: this.currToken[3] + (c - 1)
            }
          },
          sourceIndex: this.currToken[6] + o[a]
        });else if (r.test(this.currToken[1])) {
          let l = f.replace(r, "");
          p = new my({
            value: f.replace(l, ""),
            source: {
              start: {
                line: this.currToken[2],
                column: this.currToken[3] + u
              },
              end: {
                line: this.currToken[4],
                column: this.currToken[3] + (c - 1)
              }
            },
            sourceIndex: this.currToken[6] + o[a],
            unit: l
          });
        } else p = new (e && e[0] === "(" ? dy : tl)({
          value: f,
          source: {
            start: {
              line: this.currToken[2],
              column: this.currToken[3] + u
            },
            end: {
              line: this.currToken[4],
              column: this.currToken[3] + (c - 1)
            }
          },
          sourceIndex: this.currToken[6] + o[a]
        }), p.type === "word" ? (p.isHex = /^#(.+)/.test(f), p.isColor = /^#([0-9a-f]{3}|[0-9a-f]{4}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(f)) : this.cache.push(this.current);
        this.newNode(p);
      }), this.position++;
    }
    string() {
      let e = this.currToken,
        s = this.currToken[1],
        r = /^(\"|\')/,
        n = r.test(s),
        i = "",
        o;
      n && (i = s.match(r)[0], s = s.slice(1, s.length - 1)), o = new gy({
        value: s,
        source: {
          start: {
            line: e[2],
            column: e[3]
          },
          end: {
            line: e[4],
            column: e[5]
          }
        },
        sourceIndex: e[6],
        quoted: n
      }), o.raws.quote = i, this.newNode(o), this.position++;
    }
    word() {
      return this.splitWord();
    }
    newNode(e) {
      return this.spaces && (e.raws.before += this.spaces, this.spaces = ""), this.current.append(e);
    }
    get currToken() {
      return this.tokens[this.position];
    }
    get nextToken() {
      return this.tokens[this.position + 1];
    }
    get prevToken() {
      return this.tokens[this.position - 1];
    }
  };
});
var en = {};
rn(en, {
  languages: () => Ei,
  options: () => Si,
  parsers: () => Zs,
  printers: () => Fy
});
var Tl = (t, e, s, r) => {
    if (!(t && e == null)) return e.replaceAll ? e.replaceAll(s, r) : s.global ? e.replace(s, r) : e.split(s).join(r);
  },
  E = Tl;
var _e = "string",
  Ye = "array",
  Ve = "cursor",
  re = "indent",
  Ee = "align",
  ze = "trim",
  se = "group",
  ne = "fill",
  ie = "if-break",
  He = "indent-if-break",
  ke = "line-suffix",
  je = "line-suffix-boundary",
  H = "line",
  Ke = "label",
  Se = "break-parent",
  Tt = new Set([Ve, re, Ee, ze, se, ne, ie, He, ke, je, H, Ke, Se]);
var Ol = (t, e, s) => {
    if (!(t && e == null)) return Array.isArray(e) || typeof e == "string" ? e[s < 0 ? e.length + s : s] : e.at(s);
  },
  $ = Ol;
function Cl(t) {
  if (typeof t == "string") return _e;
  if (Array.isArray(t)) return Ye;
  if (!t) return;
  let {
    type: e
  } = t;
  if (Tt.has(e)) return e;
}
var j = Cl;
var Al = t => new Intl.ListFormat("en-US", {
  type: "disjunction"
}).format(t);
function Nl(t) {
  let e = t === null ? "null" : typeof t;
  if (e !== "string" && e !== "object") return `Unexpected doc '${e}', 
Expected it to be 'string' or 'object'.`;
  if (j(t)) throw new Error("doc is valid.");
  let s = Object.prototype.toString.call(t);
  if (s !== "[object Object]") return `Unexpected doc '${s}'.`;
  let r = Al([...Tt].map(n => `'${n}'`));
  return `Unexpected doc.type '${t.type}'.
Expected it to be ${r}.`;
}
var Gr = class extends Error {
    name = "InvalidDocError";
    constructor(e) {
      super(Nl(e)), this.doc = e;
    }
  },
  Yr = Gr;
function Rl(t, e) {
  if (typeof t == "string") return e(t);
  let s = new Map();
  return r(t);
  function r(i) {
    if (s.has(i)) return s.get(i);
    let o = n(i);
    return s.set(i, o), o;
  }
  function n(i) {
    switch (j(i)) {
      case Ye:
        return e(i.map(r));
      case ne:
        return e({
          ...i,
          parts: i.parts.map(r)
        });
      case ie:
        return e({
          ...i,
          breakContents: r(i.breakContents),
          flatContents: r(i.flatContents)
        });
      case se:
        {
          let {
            expandedStates: o,
            contents: u
          } = i;
          return o ? (o = o.map(r), u = o[0]) : u = r(u), e({
            ...i,
            contents: u,
            expandedStates: o
          });
        }
      case Ee:
      case re:
      case He:
      case Ke:
      case ke:
        return e({
          ...i,
          contents: r(i.contents)
        });
      case _e:
      case Ve:
      case ze:
      case je:
      case H:
      case Se:
        return e(i);
      default:
        throw new Yr(i);
    }
  }
}
function Il(t) {
  return t.type === H && !t.hard ? t.soft ? "" : " " : t.type === ie ? t.flatContents : t;
}
function sn(t) {
  return Rl(t, Il);
}
var Vr = () => {},
  oe = Vr,
  Qe = Vr,
  nn = Vr;
function q(t) {
  return oe(t), {
    type: re,
    contents: t
  };
}
function on(t, e) {
  return oe(e), {
    type: Ee,
    contents: e,
    n: t
  };
}
function L(t, e = {}) {
  return oe(t), Qe(e.expandedStates, !0), {
    type: se,
    id: e.id,
    contents: t,
    break: !!e.shouldBreak,
    expandedStates: e.expandedStates
  };
}
function an(t) {
  return on({
    type: "root"
  }, t);
}
function ae(t) {
  return on(-1, t);
}
function Te(t) {
  return nn(t), {
    type: ne,
    parts: t
  };
}
function Ot(t, e = "", s = {}) {
  return oe(t), e !== "" && oe(e), {
    type: ie,
    breakContents: t,
    flatContents: e,
    groupId: s.groupId
  };
}
function un(t) {
  return oe(t), {
    type: ke,
    contents: t
  };
}
var Xe = {
  type: Se
};
var ql = {
  type: H,
  hard: !0
};
var A = {
    type: H
  },
  D = {
    type: H,
    soft: !0
  },
  S = [ql, Xe];
function G(t, e) {
  oe(t), Qe(e);
  let s = [];
  for (let r = 0; r < e.length; r++) r !== 0 && s.push(t), s.push(e[r]);
  return s;
}
function Ll(t) {
  return Array.isArray(t) && t.length > 0;
}
var ue = Ll;
var ln = new Proxy(() => {}, {
    get: () => ln
  }),
  cn = ln;
var Ct = "'",
  fn = '"';
function Dl(t, e) {
  let s = e === !0 || e === Ct ? Ct : fn,
    r = s === Ct ? fn : Ct,
    n = 0,
    i = 0;
  for (let o of t) o === s ? n++ : o === r && i++;
  return n > i ? r : s;
}
var pn = Dl;
function Ml(t, e, s) {
  let r = e === '"' ? "'" : '"',
    i = E(!1, t, /\\(.)|(["'])/gsu, (o, u, a) => u === r ? u : a === e ? "\\" + a : a || (s && /^[^\n\r"'0-7\\bfnrt-vx\u2028\u2029]$/u.test(u) ? u : "\\" + u));
  return e + i + e;
}
var hn = Ml;
function Bl(t, e) {
  cn.ok(/^(?<quote>["']).*\k<quote>$/su.test(t));
  let s = t.slice(1, -1),
    r = e.parser === "json" || e.parser === "jsonc" || e.parser === "json5" && e.quoteProps === "preserve" && !e.singleQuote ? '"' : e.__isInHtmlAttribute ? "'" : pn(s, e.singleQuote);
  return t.charAt(0) === r ? t : hn(s, r, !1);
}
var At = Bl;
var zr = class extends Error {
    name = "UnexpectedNodeError";
    constructor(e, s, r = "type") {
      super(`Unexpected ${s} node ${r}: ${JSON.stringify(e[r])}.`), this.node = e;
    }
  },
  dn = zr;
function Ul(t) {
  return (t == null ? void 0 : t.type) === "front-matter";
}
var Oe = Ul;
var Fl = new Set(["raw", "raws", "sourceIndex", "source", "before", "after", "trailingComma", "spaces"]);
function mn(t, e, s) {
  if (Oe(t) && t.language === "yaml" && delete e.value, t.type === "css-comment" && s.type === "css-root" && s.nodes.length > 0 && ((s.nodes[0] === t || Oe(s.nodes[0]) && s.nodes[1] === t) && (delete e.text, /^\*\s*@(?:format|prettier)\s*$/u.test(t.text)) || s.type === "css-root" && $(!1, s.nodes, -1) === t)) return null;
  if (t.type === "value-root" && delete e.text, (t.type === "media-query" || t.type === "media-query-list" || t.type === "media-feature-expression") && delete e.value, t.type === "css-rule" && delete e.params, (t.type === "media-feature" || t.type === "media-keyword" || t.type === "media-type" || t.type === "media-unknown" || t.type === "media-url" || t.type === "media-value" || t.type === "selector-attribute" || t.type === "selector-string" || t.type === "selector-class" || t.type === "selector-combinator" || t.type === "value-string") && t.value && (e.value = $l(t.value)), t.type === "selector-combinator" && (e.value = E(!1, e.value, /\s+/gu, " ")), t.type === "media-feature" && (e.value = E(!1, e.value, " ", "")), (t.type === "value-word" && (t.isColor && t.isHex || ["initial", "inherit", "unset", "revert"].includes(t.value.toLowerCase())) || t.type === "media-feature" || t.type === "selector-root-invalid" || t.type === "selector-pseudo") && (e.value = e.value.toLowerCase()), t.type === "css-decl" && (e.prop = t.prop.toLowerCase()), (t.type === "css-atrule" || t.type === "css-import") && (e.name = t.name.toLowerCase()), t.type === "value-number" && (e.unit = t.unit.toLowerCase()), t.type === "value-unknown" && (e.value = E(!1, e.value, /;$/gu, "")), t.type === "selector-attribute" && (e.attribute = t.attribute.trim(), t.namespace && typeof t.namespace == "string" && (e.namespace = t.namespace.trim() || !0), t.value && (e.value = E(!1, e.value.trim(), /^["']|["']$/gu, ""), delete e.quoted)), (t.type === "media-value" || t.type === "media-type" || t.type === "value-number" || t.type === "selector-root-invalid" || t.type === "selector-class" || t.type === "selector-combinator" || t.type === "selector-tag") && t.value && (e.value = E(!1, e.value, /([\d+.e-]+)([a-z]*)/giu, (r, n, i) => {
    let o = Number(n);
    return Number.isNaN(o) ? r : o + i.toLowerCase();
  })), t.type === "selector-tag") {
    let r = e.value.toLowerCase();
    ["from", "to"].includes(r) && (e.value = r);
  }
  if (t.type === "css-atrule" && t.name.toLowerCase() === "supports" && delete e.value, t.type === "selector-unknown" && delete e.value, t.type === "value-comma_group") {
    let r = t.groups.findIndex(n => n.type === "value-number" && n.unit === "...");
    r !== -1 && (e.groups[r].unit = "", e.groups.splice(r + 1, 0, {
      type: "value-word",
      value: "...",
      isColor: !1,
      isHex: !1
    }));
  }
  if (t.type === "value-comma_group" && t.groups.some(r => r.type === "value-atword" && r.value.endsWith("[") || r.type === "value-word" && r.value.startsWith("]"))) return {
    type: "value-atword",
    value: t.groups.map(r => r.value).join(""),
    group: {
      open: null,
      close: null,
      groups: [],
      type: "value-paren_group"
    }
  };
}
mn.ignoredProperties = Fl;
function $l(t) {
  return E(!1, E(!1, t, "'", '"'), /\\([^\da-f])/giu, "$1");
}
var yn = mn;
async function Wl(t, e) {
  if (t.language === "yaml") {
    let s = t.value.trim(),
      r = s ? await e(s, {
        parser: "yaml"
      }) : "";
    return an([t.startDelimiter, t.explicitLanguage, S, r, r ? S : "", t.endDelimiter]);
  }
}
var gn = Wl;
function wn(t) {
  let {
    node: e
  } = t;
  if (e.type === "front-matter") return async s => {
    let r = await gn(e, s);
    return r ? [r, S] : void 0;
  };
}
wn.getVisitorKeys = t => t.type === "css-root" ? ["frontMatter"] : [];
var vn = wn;
var Je = null;
function Ze(t) {
  if (Je !== null && typeof Je.property) {
    let e = Je;
    return Je = Ze.prototype = null, e;
  }
  return Je = Ze.prototype = t ?? Object.create(null), new Ze();
}
var Gl = 10;
for (let t = 0; t <= Gl; t++) Ze();
function Hr(t) {
  return Ze(t);
}
function Yl(t, e = "type") {
  Hr(t);
  function s(r) {
    let n = r[e],
      i = t[n];
    if (!Array.isArray(i)) throw Object.assign(new Error(`Missing visitor keys for '${n}'.`), {
      node: r
    });
    return i;
  }
  return s;
}
var xn = Yl;
var Vl = {
    "front-matter": [],
    "css-root": ["frontMatter", "nodes"],
    "css-comment": [],
    "css-rule": ["selector", "nodes"],
    "css-decl": ["value", "selector", "nodes"],
    "css-atrule": ["selector", "params", "value", "nodes"],
    "media-query-list": ["nodes"],
    "media-query": ["nodes"],
    "media-type": [],
    "media-feature-expression": ["nodes"],
    "media-feature": [],
    "media-colon": [],
    "media-value": [],
    "media-keyword": [],
    "media-url": [],
    "media-unknown": [],
    "selector-root": ["nodes"],
    "selector-selector": ["nodes"],
    "selector-comment": [],
    "selector-string": [],
    "selector-tag": [],
    "selector-id": [],
    "selector-class": [],
    "selector-attribute": [],
    "selector-combinator": ["nodes"],
    "selector-universal": [],
    "selector-pseudo": ["nodes"],
    "selector-nesting": [],
    "selector-unknown": [],
    "value-value": ["group"],
    "value-root": ["group"],
    "value-comment": [],
    "value-comma_group": ["groups"],
    "value-paren_group": ["open", "groups", "close"],
    "value-func": ["group"],
    "value-paren": [],
    "value-number": [],
    "value-operator": [],
    "value-word": [],
    "value-colon": [],
    "value-comma": [],
    "value-string": [],
    "value-atword": [],
    "value-unicode-range": [],
    "value-unknown": []
  },
  bn = Vl;
var zl = xn(bn),
  _n = zl;
function Hl(t, e) {
  let s = 0;
  for (let r = 0; r < t.line - 1; ++r) s = e.indexOf(`
`, s) + 1;
  return s + t.column;
}
var jr = Hl;
function Nt(t) {
  return (e, s, r) => {
    let n = !!(r != null && r.backwards);
    if (s === !1) return !1;
    let {
        length: i
      } = e,
      o = s;
    for (; o >= 0 && o < i;) {
      let u = e.charAt(o);
      if (t instanceof RegExp) {
        if (!t.test(u)) return o;
      } else if (!t.includes(u)) return o;
      n ? o-- : o++;
    }
    return o === -1 || o === i ? o : !1;
  };
}
var Qg = Nt(/\s/u),
  Pt = Nt(" 	"),
  En = Nt(",; 	"),
  Rt = Nt(/[^\n\r]/u);
function kn(t, e) {
  let {
    value: s
  } = t;
  return s === "-" || s === "--" || s.charAt(0) !== "-" ? e : e - (s.charAt(1) === "-" ? 2 : 1);
}
function Sn(t, e) {
  var s, r, n;
  if (typeof ((r = (s = t.source) == null ? void 0 : s.start) == null ? void 0 : r.offset) == "number") return t.source.start.offset;
  if (typeof t.sourceIndex == "number") return t.type === "value-word" ? kn(t, t.sourceIndex) : t.sourceIndex;
  if ((n = t.source) != null && n.start) return jr(t.source.start, e);
  throw Object.assign(new Error("Can not locate node."), {
    node: t
  });
}
function Kr(t, e) {
  var s, r;
  if (t.type === "css-comment" && t.inline) return Rt(e, t.source.startOffset);
  if (typeof ((r = (s = t.source) == null ? void 0 : s.end) == null ? void 0 : r.offset) == "number") return t.source.end.offset;
  if (t.source) {
    if (t.source.end) {
      let n = jr(t.source.end, e);
      return t.type === "value-word" ? kn(t, n) : n;
    }
    if (ue(t.nodes)) return Kr($(!1, t.nodes, -1), e);
  }
  return null;
}
function Qr(t, e) {
  t.source && (t.source.startOffset = Sn(t, e), t.source.endOffset = Kr(t, e));
  for (let s in t) {
    let r = t[s];
    s === "source" || !r || typeof r != "object" || (r.type === "value-root" || r.type === "value-unknown" ? Tn(r, jl(t), r.text || r.value) : Qr(r, e));
  }
}
function Tn(t, e, s) {
  t.source && (t.source.startOffset = Sn(t, s) + e, t.source.endOffset = Kr(t, s) + e);
  for (let r in t) {
    let n = t[r];
    r === "source" || !n || typeof n != "object" || Tn(n, e, s);
  }
}
function jl(t) {
  var s;
  let e = t.source.startOffset;
  return typeof t.prop == "string" && (e += t.prop.length), t.type === "css-atrule" && typeof t.name == "string" && (e += 1 + t.name.length + t.raws.afterName.match(/^\s*:?\s*/u)[0].length), t.type !== "css-atrule" && typeof ((s = t.raws) == null ? void 0 : s.between) == "string" && (e += t.raws.between.length), e;
}
function On(t) {
  let e = "initial",
    s = "initial",
    r,
    n = !1,
    i = [];
  for (let o = 0; o < t.length; o++) {
    let u = t[o];
    switch (e) {
      case "initial":
        if (u === "'") {
          e = "single-quotes";
          continue;
        }
        if (u === '"') {
          e = "double-quotes";
          continue;
        }
        if ((u === "u" || u === "U") && t.slice(o, o + 4).toLowerCase() === "url(") {
          e = "url", o += 3;
          continue;
        }
        if (u === "*" && t[o - 1] === "/") {
          e = "comment-block";
          continue;
        }
        if (u === "/" && t[o - 1] === "/") {
          e = "comment-inline", r = o - 1;
          continue;
        }
        continue;
      case "single-quotes":
        if (u === "'" && t[o - 1] !== "\\" && (e = s, s = "initial"), u === `
` || u === "\r") return t;
        continue;
      case "double-quotes":
        if (u === '"' && t[o - 1] !== "\\" && (e = s, s = "initial"), u === `
` || u === "\r") return t;
        continue;
      case "url":
        if (u === ")" && (e = "initial"), u === `
` || u === "\r") return t;
        if (u === "'") {
          e = "single-quotes", s = "url";
          continue;
        }
        if (u === '"') {
          e = "double-quotes", s = "url";
          continue;
        }
        continue;
      case "comment-block":
        u === "/" && t[o - 1] === "*" && (e = "initial");
        continue;
      case "comment-inline":
        (u === '"' || u === "'" || u === "*") && (n = !0), (u === `
` || u === "\r") && (n && i.push([r, o]), e = "initial", n = !1);
        continue;
    }
  }
  for (let [o, u] of i) t = t.slice(0, o) + E(!1, t.slice(o, u), /["'*]/gu, " ") + t.slice(u);
  return t;
}
function N(t) {
  var e;
  return (e = t.source) == null ? void 0 : e.startOffset;
}
function P(t) {
  var e;
  return (e = t.source) == null ? void 0 : e.endOffset;
}
var Kl = /\*\/$/,
  Ql = /^\/\*\*?/,
  Pn = /^\s*(\/\*\*?(.|\r?\n)*?\*\/)/,
  Xl = /(^|\s+)\/\/([^\n\r]*)/g,
  Cn = /^(\r?\n)+/,
  Jl = /(?:^|\r?\n) *(@[^\n\r]*?) *\r?\n *(?![^\n\r@]*\/\/[^]*)([^\s@][^\n\r@]+?) *\r?\n/g,
  An = /(?:^|\r?\n) *@(\S+) *([^\n\r]*)/g,
  Zl = /(\r?\n|^) *\* ?/g,
  Rn = [];
function In(t) {
  let e = t.match(Pn);
  return e ? e[0].trimStart() : "";
}
function qn(t) {
  let e = t.match(Pn),
    s = e == null ? void 0 : e[0];
  return s == null ? t : t.slice(s.length);
}
function Ln(t) {
  let e = `
`;
  t = E(!1, t.replace(Ql, "").replace(Kl, ""), Zl, "$1");
  let s = "";
  for (; s !== t;) s = t, t = E(!1, t, Jl, `${e}$1 $2${e}`);
  t = t.replace(Cn, "").trimEnd();
  let r = Object.create(null),
    n = E(!1, t, An, "").replace(Cn, "").trimEnd(),
    i;
  for (; i = An.exec(t);) {
    let o = E(!1, i[2], Xl, "");
    if (typeof r[i[1]] == "string" || Array.isArray(r[i[1]])) {
      let u = r[i[1]];
      r[i[1]] = [...Rn, ...(Array.isArray(u) ? u : [u]), o];
    } else r[i[1]] = o;
  }
  return {
    comments: n,
    pragmas: r
  };
}
function Dn({
  comments: t = "",
  pragmas: e = {}
}) {
  let s = `
`,
    r = "/**",
    n = " *",
    i = " */",
    o = Object.keys(e),
    u = o.flatMap(c => Nn(c, e[c])).map(c => `${n} ${c}${s}`).join("");
  if (!t) {
    if (o.length === 0) return "";
    if (o.length === 1 && !Array.isArray(e[o[0]])) {
      let c = e[o[0]];
      return `${r} ${Nn(o[0], c)[0]}${i}`;
    }
  }
  let a = t.split(s).map(c => `${n} ${c}`).join(s) + s;
  return r + s + (t ? a : "") + (t && o.length > 0 ? n + s : "") + u + i;
}
function Nn(t, e) {
  return [...Rn, ...(Array.isArray(e) ? e : [e])].map(s => `@${t} ${s}`.trim());
}
var Mn = ["noformat", "noprettier"],
  Bn = ["format", "prettier"],
  Un = "format";
function ec(t) {
  if (!t.startsWith("#!")) return "";
  let e = t.indexOf(`
`);
  return e === -1 ? t : t.slice(0, e);
}
var Fn = ec;
function Xr(t) {
  let e = Fn(t);
  e && (t = t.slice(e.length + 1));
  let s = In(t),
    {
      pragmas: r,
      comments: n
    } = Ln(s);
  return {
    shebang: e,
    text: t,
    pragmas: r,
    comments: n
  };
}
function $n(t) {
  let {
    pragmas: e
  } = Xr(t);
  return Bn.some(s => Object.prototype.hasOwnProperty.call(e, s));
}
function Wn(t) {
  let {
    pragmas: e
  } = Xr(t);
  return Mn.some(s => Object.prototype.hasOwnProperty.call(e, s));
}
function Gn(t) {
  let {
      shebang: e,
      text: s,
      pragmas: r,
      comments: n
    } = Xr(t),
    i = qn(s),
    o = Dn({
      pragmas: {
        [Un]: "",
        ...r
      },
      comments: n.trimStart()
    });
  return (e ? `${e}
` : "") + o + (i.startsWith(`
`) ? `
` : `

`) + i;
}
var et = 3;
function tc(t) {
  let e = t.slice(0, et);
  if (e !== "---" && e !== "+++") return;
  let s = t.indexOf(`
`, et);
  if (s === -1) return;
  let r = t.slice(et, s).trim(),
    n = t.indexOf(`
${e}`, s),
    i = r;
  if (i || (i = e === "+++" ? "toml" : "yaml"), n === -1 && e === "---" && i === "yaml" && (n = t.indexOf(`
...`, s)), n === -1) return;
  let o = n + 1 + et,
    u = t.charAt(o + 1);
  if (!/\s?/u.test(u)) return;
  let a = t.slice(0, o);
  return {
    type: "front-matter",
    language: i,
    explicitLanguage: r,
    value: t.slice(s + 1, n),
    startDelimiter: e,
    endDelimiter: a.slice(-et),
    raw: a
  };
}
function rc(t) {
  let e = tc(t);
  if (!e) return {
    content: t
  };
  let {
    raw: s
  } = e;
  return {
    frontMatter: e,
    content: E(!1, s, /[^\n]/gu, " ") + t.slice(s.length)
  };
}
var Ce = rc;
function Yn(t) {
  return $n(Ce(t).content);
}
function Vn(t) {
  return Wn(Ce(t).content);
}
function zn(t) {
  let {
    frontMatter: e,
    content: s
  } = Ce(t);
  return (e ? e.raw + `

` : "") + Gn(s);
}
var sc = new Set(["red", "green", "blue", "alpha", "a", "rgb", "hue", "h", "saturation", "s", "lightness", "l", "whiteness", "w", "blackness", "b", "tint", "shade", "blend", "blenda", "contrast", "hsl", "hsla", "hwb", "hwba"]);
function Hn(t) {
  var e, s;
  return (s = (e = t.findAncestor(r => r.type === "css-decl")) == null ? void 0 : e.prop) == null ? void 0 : s.toLowerCase();
}
var nc = new Set(["initial", "inherit", "unset", "revert"]);
function jn(t) {
  return nc.has(t.toLowerCase());
}
function Kn(t, e) {
  var r;
  let s = t.findAncestor(n => n.type === "css-atrule");
  return ((r = s == null ? void 0 : s.name) == null ? void 0 : r.toLowerCase().endsWith("keyframes")) && ["from", "to"].includes(e.toLowerCase());
}
function Ae(t) {
  return t.includes("$") || t.includes("@") || t.includes("#") || t.startsWith("%") || t.startsWith("--") || t.startsWith(":--") || t.includes("(") && t.includes(")") ? t : t.toLowerCase();
}
function Ne(t, e) {
  var r;
  let s = t.findAncestor(n => n.type === "value-func");
  return ((r = s == null ? void 0 : s.value) == null ? void 0 : r.toLowerCase()) === e;
}
function Qn(t) {
  var r;
  let e = t.findAncestor(n => n.type === "css-rule"),
    s = (r = e == null ? void 0 : e.raws) == null ? void 0 : r.selector;
  return s && (s.startsWith(":import") || s.startsWith(":export"));
}
function he(t, e) {
  let s = Array.isArray(e) ? e : [e],
    r = t.findAncestor(n => n.type === "css-atrule");
  return r && s.includes(r.name.toLowerCase());
}
function Xn(t) {
  var s;
  let {
    node: e
  } = t;
  return e.groups[0].value === "url" && e.groups.length === 2 && ((s = t.findAncestor(r => r.type === "css-atrule")) == null ? void 0 : s.name) === "import";
}
function Jn(t) {
  return t.type === "value-func" && t.value.toLowerCase() === "url";
}
function Zn(t) {
  return t.type === "value-func" && t.value.toLowerCase() === "var";
}
function ei(t) {
  let {
    selector: e
  } = t;
  return e ? typeof e == "string" && /^@.+:.*$/u.test(e) || e.value && /^@.+:.*$/u.test(e.value) : !1;
}
function ti(t) {
  return t.type === "value-word" && ["from", "through", "end"].includes(t.value);
}
function ri(t) {
  return t.type === "value-word" && ["and", "or", "not"].includes(t.value);
}
function si(t) {
  return t.type === "value-word" && t.value === "in";
}
function It(t) {
  return t.type === "value-operator" && t.value === "*";
}
function tt(t) {
  return t.type === "value-operator" && t.value === "/";
}
function X(t) {
  return t.type === "value-operator" && t.value === "+";
}
function de(t) {
  return t.type === "value-operator" && t.value === "-";
}
function ic(t) {
  return t.type === "value-operator" && t.value === "%";
}
function qt(t) {
  return It(t) || tt(t) || X(t) || de(t) || ic(t);
}
function ni(t) {
  return t.type === "value-word" && ["==", "!="].includes(t.value);
}
function ii(t) {
  return t.type === "value-word" && ["<", ">", "<=", ">="].includes(t.value);
}
function rt(t, e) {
  return e.parser === "scss" && t.type === "css-atrule" && ["if", "else", "for", "each", "while"].includes(t.name);
}
function Zr(t) {
  var e;
  return ((e = t.raws) == null ? void 0 : e.params) && /^\(\s*\)$/u.test(t.raws.params);
}
function Lt(t) {
  return t.name.startsWith("prettier-placeholder");
}
function oi(t) {
  return t.prop.startsWith("@prettier-placeholder");
}
function ai(t, e) {
  return t.value === "$$" && t.type === "value-func" && (e == null ? void 0 : e.type) === "value-word" && !e.raws.before;
}
function ui(t) {
  var e, s;
  return ((e = t.value) == null ? void 0 : e.type) === "value-root" && ((s = t.value.group) == null ? void 0 : s.type) === "value-value" && t.prop.toLowerCase() === "composes";
}
function li(t) {
  var e, s, r;
  return ((r = (s = (e = t.value) == null ? void 0 : e.group) == null ? void 0 : s.group) == null ? void 0 : r.type) === "value-paren_group" && t.value.group.group.open !== null && t.value.group.group.close !== null;
}
function me(t) {
  var e;
  return ((e = t.raws) == null ? void 0 : e.before) === "";
}
function Dt(t) {
  var e, s;
  return t.type === "value-comma_group" && ((s = (e = t.groups) == null ? void 0 : e[1]) == null ? void 0 : s.type) === "value-colon";
}
function Jr(t) {
  var e;
  return t.type === "value-paren_group" && ((e = t.groups) == null ? void 0 : e[0]) && Dt(t.groups[0]);
}
function es(t, e) {
  var i;
  if (e.parser !== "scss") return !1;
  let {
    node: s
  } = t;
  if (s.groups.length === 0) return !1;
  let r = t.grandparent;
  if (!Jr(s) && !(r && Jr(r))) return !1;
  let n = t.findAncestor(o => o.type === "css-decl");
  return !!((i = n == null ? void 0 : n.prop) != null && i.startsWith("$") || Jr(r) || r.type === "value-func");
}
function Pe(t) {
  return t.type === "value-comment" && t.inline;
}
function Mt(t) {
  return t.type === "value-word" && t.value === "#";
}
function ts(t) {
  return t.type === "value-word" && t.value === "{";
}
function Bt(t) {
  return t.type === "value-word" && t.value === "}";
}
function st(t) {
  return ["value-word", "value-atword"].includes(t.type);
}
function nt(t) {
  return (t == null ? void 0 : t.type) === "value-colon";
}
function ci(t, e) {
  if (!Dt(e)) return !1;
  let {
      groups: s
    } = e,
    r = s.indexOf(t);
  return r === -1 ? !1 : nt(s[r + 1]);
}
function fi(t) {
  return t.value && ["not", "and", "or"].includes(t.value.toLowerCase());
}
function pi(t) {
  return t.type !== "value-func" ? !1 : sc.has(t.value.toLowerCase());
}
function Re(t) {
  return /\/\//u.test(t.split(/[\n\r]/u).pop());
}
function it(t) {
  return (t == null ? void 0 : t.type) === "value-atword" && t.value.startsWith("prettier-placeholder-");
}
function hi(t, e) {
  var s, r;
  if (((s = t.open) == null ? void 0 : s.value) !== "(" || ((r = t.close) == null ? void 0 : r.value) !== ")" || t.groups.some(n => n.type !== "value-comma_group")) return !1;
  if (e.type === "value-comma_group") {
    let n = e.groups.indexOf(t) - 1,
      i = e.groups[n];
    if ((i == null ? void 0 : i.type) === "value-word" && i.value === "with") return !0;
  }
  return !1;
}
function ot(t) {
  var e, s;
  return t.type === "value-paren_group" && ((e = t.open) == null ? void 0 : e.value) === "(" && ((s = t.close) == null ? void 0 : s.value) === ")";
}
function oc(t, e, s) {
  var m;
  let {
      node: r
    } = t,
    n = t.parent,
    i = t.grandparent,
    o = Hn(t),
    u = o && n.type === "value-value" && (o === "grid" || o.startsWith("grid-template")),
    a = t.findAncestor(y => y.type === "css-atrule"),
    c = a && rt(a, e),
    f = r.groups.some(y => Pe(y)),
    p = t.map(s, "groups"),
    l = [""],
    d = Ne(t, "url"),
    x = !1,
    h = !1;
  for (let y = 0; y < r.groups.length; ++y) {
    let b = r.groups[y - 1],
      w = r.groups[y],
      v = r.groups[y + 1],
      R = r.groups[y + 2];
    if (Pe(w) && !v) {
      l.push([l.pop(), un([" ", p[y]])]);
      continue;
    }
    if (l.push([l.pop(), p[y]]), d) {
      (v && X(v) || X(w)) && l.push([l.pop(), " "]);
      continue;
    }
    if (nt(v) && w.type === "value-word" && l.length > 2 && r.groups.slice(0, y).every(C => C.type === "value-comment") && !Pe(b) && (l[l.length - 2] = ae($(!1, l, -2))), he(t, "forward") && w.type === "value-word" && w.value && b !== void 0 && b.type === "value-word" && b.value === "as" && v.type === "value-operator" && v.value === "*" || he(t, "utility") && w.type === "value-word" && v && v.type === "value-operator" && v.value === "*" || !v || w.type === "value-word" && it(v) && P(w) === N(v)) continue;
    if (w.type === "value-string" && w.quoted) {
      let C = w.value.lastIndexOf("#{"),
        xe = w.value.lastIndexOf("}");
      C !== -1 && xe !== -1 ? x = C > xe : C !== -1 ? x = !0 : xe !== -1 && (x = !1);
    }
    if (x || nt(w) || nt(v) || w.type === "value-atword" && (w.value === "" || w.value.endsWith("[")) || v.type === "value-word" && v.value.startsWith("]") || w.value === "~" || w.type !== "value-string" && w.value && w.value.includes("\\") && v && v.type !== "value-comment" || b != null && b.value && b.value.indexOf("\\") === b.value.length - 1 && w.type === "value-operator" && w.value === "/" || w.value === "\\" || ai(w, v) || Mt(w) || ts(w) || Bt(v) || ts(v) && me(v) || Bt(w) && me(v) || w.value === "--" && Mt(v)) continue;
    let F = qt(w),
      Q = qt(v);
    if ((F && Mt(v) || Q && Bt(w)) && me(v) || !b && tt(w) || Ne(t, "calc") && (X(w) || X(v) || de(w) || de(v)) && me(v)) continue;
    let W = (X(w) || de(w)) && y === 0 && (v.type === "value-number" || v.isHex) && i && pi(i) && !me(v),
      T = (R == null ? void 0 : R.type) === "value-func" || R && st(R) || w.type === "value-func" || st(w),
      O = v.type === "value-func" || st(v) || (b == null ? void 0 : b.type) === "value-func" || b && st(b);
    if (e.parser === "scss" && F && w.value === "-" && v.type === "value-func" && P(w) !== N(v)) {
      l.push([l.pop(), " "]);
      continue;
    }
    if (!(!(It(v) || It(w)) && !Ne(t, "calc") && !W && (tt(v) && !T || tt(w) && !O || X(v) && !T || X(w) && !O || de(v) || de(w)) && (me(v) || F && (!b || b && qt(b)))) && !((e.parser === "scss" || e.parser === "less") && F && w.value === "-" && ot(v) && P(w) === N(v.open) && v.open.value === "(")) {
      if (Pe(w)) {
        if (n.type === "value-paren_group") {
          l.push(ae(S), "");
          continue;
        }
        l.push(S, "");
        continue;
      }
      if (c && (ni(v) || ii(v) || ri(v) || si(w) || ti(w))) {
        l.push([l.pop(), " "]);
        continue;
      }
      if (a && a.name.toLowerCase() === "namespace") {
        l.push([l.pop(), " "]);
        continue;
      }
      if (u) {
        w.source && v.source && w.source.start.line !== v.source.start.line ? (l.push(S, ""), h = !0) : l.push([l.pop(), " "]);
        continue;
      }
      if (Q) {
        l.push([l.pop(), " "]);
        continue;
      }
      if ((v == null ? void 0 : v.value) !== "..." && !(it(w) && it(v) && P(w) === N(v))) {
        if (it(w) && ot(v) && P(w) === N(v.open)) {
          l.push(D, "");
          continue;
        }
        if (w.value === "with" && ot(v)) {
          l = [[Te(l), " "]];
          continue;
        }
        (m = w.value) != null && m.endsWith("#") && v.value === "{" && ot(v.group) || Pe(v) && !R || l.push(A, "");
      }
    }
  }
  return f && l.push([l.pop(), Xe]), h && l.unshift("", S), c ? L(q(l)) : Xn(t) ? L(Te(l)) : L(q(Te(l)));
}
var di = oc;
function ac(t) {
  return t.length === 1 ? t : t.toLowerCase().replace(/^([+-]?[\d.]+e)(?:\+|(-))?0*(?=\d)/u, "$1$2").replace(/^([+-]?[\d.]+)e[+-]?0+$/u, "$1").replace(/^([+-])?\./u, "$10.").replace(/(\.\d+?)0+(?=e|$)/u, "$1").replace(/\.(?=e|$)/u, "");
}
var mi = ac;
var Ut = new Map([["em", "em"], ["rem", "rem"], ["ex", "ex"], ["rex", "rex"], ["cap", "cap"], ["rcap", "rcap"], ["ch", "ch"], ["rch", "rch"], ["ic", "ic"], ["ric", "ric"], ["lh", "lh"], ["rlh", "rlh"], ["vw", "vw"], ["svw", "svw"], ["lvw", "lvw"], ["dvw", "dvw"], ["vh", "vh"], ["svh", "svh"], ["lvh", "lvh"], ["dvh", "dvh"], ["vi", "vi"], ["svi", "svi"], ["lvi", "lvi"], ["dvi", "dvi"], ["vb", "vb"], ["svb", "svb"], ["lvb", "lvb"], ["dvb", "dvb"], ["vmin", "vmin"], ["svmin", "svmin"], ["lvmin", "lvmin"], ["dvmin", "dvmin"], ["vmax", "vmax"], ["svmax", "svmax"], ["lvmax", "lvmax"], ["dvmax", "dvmax"], ["cm", "cm"], ["mm", "mm"], ["q", "Q"], ["in", "in"], ["pt", "pt"], ["pc", "pc"], ["px", "px"], ["deg", "deg"], ["grad", "grad"], ["rad", "rad"], ["turn", "turn"], ["s", "s"], ["ms", "ms"], ["hz", "Hz"], ["khz", "kHz"], ["dpi", "dpi"], ["dpcm", "dpcm"], ["dppx", "dppx"], ["x", "x"], ["cqw", "cqw"], ["cqh", "cqh"], ["cqi", "cqi"], ["cqb", "cqb"], ["cqmin", "cqmin"], ["cqmax", "cqmax"], ["fr", "fr"]]);
function rs(t) {
  let e = t.toLowerCase();
  return Ut.has(e) ? Ut.get(e) : t;
}
var yi = /(["'])(?:(?!\1)[^\\]|\\.)*\1/gsu,
  uc = /(?:\d*\.\d+|\d+\.?)(?:e[+-]?\d+)?/giu,
  lc = /[a-z]+/giu,
  cc = /[$@]?[_a-z\u0080-\uFFFF][\w\u0080-\uFFFF-]*/giu,
  fc = new RegExp(yi.source + `|(${cc.source})?(${uc.source})(${lc.source})?`, "giu");
function Y(t, e) {
  return E(!1, t, yi, s => At(s, e));
}
function gi(t, e) {
  let s = e.singleQuote ? "'" : '"';
  return t.includes('"') || t.includes("'") ? t : s + t + s;
}
function ye(t) {
  return E(!1, t, fc, (e, s, r, n, i) => !r && n && (i ?? (i = ""), i = i.toLowerCase(), !i || i === "n" || Ut.has(i)) ? ss(n) + (i ? rs(i) : "") : e);
}
function ss(t) {
  return mi(t).replace(/\.0(?=$|e)/u, "");
}
function wi(t) {
  return t.trailingComma === "es5" || t.trailingComma === "all";
}
function pc(t, e, s) {
  let r = !!(s != null && s.backwards);
  if (e === !1) return !1;
  let n = t.charAt(e);
  if (r) {
    if (t.charAt(e - 1) === "\r" && n === `
`) return e - 2;
    if (n === `
` || n === "\r" || n === "\u2028" || n === "\u2029") return e - 1;
  } else {
    if (n === "\r" && t.charAt(e + 1) === `
`) return e + 2;
    if (n === `
` || n === "\r" || n === "\u2028" || n === "\u2029") return e + 1;
  }
  return e;
}
var Ft = pc;
function hc(t, e, s = {}) {
  let r = Pt(t, s.backwards ? e - 1 : e, s),
    n = Ft(t, r, s);
  return r !== n;
}
var $t = hc;
function dc(t, e) {
  if (e === !1) return !1;
  if (t.charAt(e) === "/" && t.charAt(e + 1) === "*") {
    for (let s = e + 2; s < t.length; ++s) if (t.charAt(s) === "*" && t.charAt(s + 1) === "/") return s + 2;
  }
  return e;
}
var vi = dc;
function mc(t, e) {
  return e === !1 ? !1 : t.charAt(e) === "/" && t.charAt(e + 1) === "/" ? Rt(t, e) : e;
}
var xi = mc;
function yc(t, e) {
  let s = null,
    r = e;
  for (; r !== s;) s = r, r = En(t, r), r = vi(t, r), r = Pt(t, r);
  return r = xi(t, r), r = Ft(t, r), r !== !1 && $t(t, r);
}
var Wt = yc;
function gc({
  node: t,
  parent: e
}, s) {
  return !!(t.source && s.originalText.slice(N(t), N(e.close)).trimEnd().endsWith(","));
}
function wc(t, e) {
  return Zn(t.grandparent) && gc(t, e) ? "," : t.node.type !== "value-comment" && !(t.node.type === "value-comma_group" && t.node.groups.every(s => s.type === "value-comment")) && wi(e) && t.callParent(() => es(t, e)) ? Ot(",") : "";
}
function bi(t, e, s) {
  let {
      node: r,
      parent: n
    } = t,
    i = t.map(({
      node: d
    }) => typeof d == "string" ? d : s(), "groups");
  if (n && Jn(n) && (r.groups.length === 1 || r.groups.length > 0 && r.groups[0].type === "value-comma_group" && r.groups[0].groups.length > 0 && r.groups[0].groups[0].type === "value-word" && r.groups[0].groups[0].value.startsWith("data:"))) return [r.open ? s("open") : "", G(",", i), r.close ? s("close") : ""];
  if (!r.open) {
    let d = ns(t);
    Qe(i);
    let x = xc(G(",", i), 2),
      h = G(d ? S : A, x);
    return q(d ? [S, h] : L([vc(t) ? D : "", Te(h)]));
  }
  let o = t.map(({
      node: d,
      isLast: x,
      index: h
    }) => {
      var b;
      let m = i[h];
      Dt(d) && d.type === "value-comma_group" && d.groups && d.groups[0].type !== "value-paren_group" && ((b = d.groups[2]) == null ? void 0 : b.type) === "value-paren_group" && j(m) === se && j(m.contents) === re && j(m.contents.contents) === ne && (m = L(ae(m)));
      let y = [m, x ? wc(t, e) : ","];
      if (!x && d.type === "value-comma_group" && ue(d.groups)) {
        let w = $(!1, d.groups, -1);
        !w.source && w.close && (w = w.close), w.source && Wt(e.originalText, P(w)) && y.push(S);
      }
      return y;
    }, "groups"),
    u = ci(r, n),
    a = hi(r, n),
    c = es(t, e),
    f = a || c && !u,
    p = a || u,
    l = L([r.open ? s("open") : "", q([D, G(A, o)]), D, r.close ? s("close") : ""], {
      shouldBreak: f
    });
  return p ? ae(l) : l;
}
function ns(t) {
  return t.match(e => e.type === "value-paren_group" && !e.open && e.groups.some(s => s.type === "value-comma_group"), (e, s) => s === "group" && e.type === "value-value", (e, s) => s === "group" && e.type === "value-root", (e, s) => s === "value" && (e.type === "css-decl" && !e.prop.startsWith("--") || e.type === "css-atrule" && e.variable));
}
function vc(t) {
  return t.match(e => e.type === "value-paren_group" && !e.open, (e, s) => s === "group" && e.type === "value-value", (e, s) => s === "group" && e.type === "value-root", (e, s) => s === "value" && e.type === "css-decl");
}
function xc(t, e) {
  let s = [];
  for (let r = 0; r < t.length; r += e) s.push(t.slice(r, r + e));
  return s;
}
function bc(t, e, s) {
  let r = [];
  return t.each(() => {
    let {
      node: n,
      previous: i
    } = t;
    if ((i == null ? void 0 : i.type) === "css-comment" && i.text.trim() === "prettier-ignore" ? r.push(e.originalText.slice(N(n), P(n))) : r.push(s()), t.isLast) return;
    let {
      next: o
    } = t;
    o.type === "css-comment" && !$t(e.originalText, N(o), {
      backwards: !0
    }) && !Oe(n) || o.type === "css-atrule" && o.name === "else" && n.type !== "css-comment" ? r.push(" ") : (r.push(e.__isHTMLStyleAttribute ? A : S), Wt(e.originalText, P(n)) && !Oe(n) && r.push(S));
  }, "nodes"), r;
}
var Ie = bc;
function _c(t, e, s) {
  var n, i, o, u, a, c;
  let {
    node: r
  } = t;
  switch (r.type) {
    case "front-matter":
      return [r.raw, S];
    case "css-root":
      {
        let f = Ie(t, e, s),
          p = r.raws.after.trim();
        return p.startsWith(";") && (p = p.slice(1).trim()), [r.frontMatter ? [s("frontMatter"), S] : "", f, p ? ` ${p}` : "", r.nodes.length > 0 ? S : ""];
      }
    case "css-comment":
      {
        let f = r.inline || r.raws.inline,
          p = e.originalText.slice(N(r), P(r));
        return f ? p.trimEnd() : p;
      }
    case "css-rule":
      return [s("selector"), r.important ? " !important" : "", r.nodes ? [((n = r.selector) == null ? void 0 : n.type) === "selector-unknown" && Re(r.selector.value) ? A : r.selector ? " " : "", "{", r.nodes.length > 0 ? q([S, Ie(t, e, s)]) : "", S, "}", ei(r) ? ";" : ""] : ";"];
    case "css-decl":
      {
        let f = t.parent,
          {
            between: p
          } = r.raws,
          l = p.trim(),
          d = l === ":",
          x = typeof r.value == "string" && /^ *$/u.test(r.value),
          h = typeof r.value == "string" ? r.value : s("value");
        return h = ui(r) ? sn(h) : h, !d && Re(l) && !((o = (i = r.value) == null ? void 0 : i.group) != null && o.group && t.call(() => ns(t), "value", "group", "group")) && (h = q([S, ae(h)])), [E(!1, r.raws.before, /[\s;]/gu, ""), f.type === "css-atrule" && f.variable || Qn(t) ? r.prop : Ae(r.prop), l.startsWith("//") ? " " : "", l, r.extend || x ? "" : " ", e.parser === "less" && r.extend && r.selector ? ["extend(", s("selector"), ")"] : "", h, r.raws.important ? r.raws.important.replace(/\s*!\s*important/iu, " !important") : r.important ? " !important" : "", r.raws.scssDefault ? r.raws.scssDefault.replace(/\s*!default/iu, " !default") : r.scssDefault ? " !default" : "", r.raws.scssGlobal ? r.raws.scssGlobal.replace(/\s*!global/iu, " !global") : r.scssGlobal ? " !global" : "", r.nodes ? [" {", q([D, Ie(t, e, s)]), D, "}"] : oi(r) && !f.raws.semicolon && e.originalText[P(r) - 1] !== ";" ? "" : e.__isHTMLStyleAttribute && t.isLast ? Ot(";") : ";"];
      }
    case "css-atrule":
      {
        let f = t.parent,
          p = Lt(r) && !f.raws.semicolon && e.originalText[P(r) - 1] !== ";";
        if (e.parser === "less") {
          if (r.mixin) return [s("selector"), r.important ? " !important" : "", p ? "" : ";"];
          if (r.function) return [r.name, typeof r.params == "string" ? r.params : s("params"), p ? "" : ";"];
          if (r.variable) return ["@", r.name, ": ", r.value ? s("value") : "", r.raws.between.trim() ? r.raws.between.trim() + " " : "", r.nodes ? ["{", q([r.nodes.length > 0 ? D : "", Ie(t, e, s)]), D, "}"] : "", p ? "" : ";"];
        }
        let l = r.name === "import" && ((u = r.params) == null ? void 0 : u.type) === "value-unknown" && r.params.value.endsWith(";");
        return ["@", Zr(r) || r.name.endsWith(":") || Lt(r) ? r.name : Ae(r.name), r.params ? [Zr(r) ? "" : Lt(r) ? r.raws.afterName === "" ? "" : r.name.endsWith(":") ? " " : /^\s*\n\s*\n/u.test(r.raws.afterName) ? [S, S] : /^\s*\n/u.test(r.raws.afterName) ? S : " " : " ", typeof r.params == "string" ? r.params : s("params")] : "", r.selector ? q([" ", s("selector")]) : "", r.value ? L([" ", s("value"), rt(r, e) ? li(r) ? " " : A : ""]) : r.name === "else" ? " " : "", r.nodes ? [rt(r, e) ? "" : r.selector && !r.selector.nodes && typeof r.selector.value == "string" && Re(r.selector.value) || !r.selector && typeof r.params == "string" && Re(r.params) ? A : " ", "{", q([r.nodes.length > 0 ? D : "", Ie(t, e, s)]), D, "}"] : p || l ? "" : ";"];
      }
    case "media-query-list":
      {
        let f = [];
        return t.each(({
          node: p
        }) => {
          p.type === "media-query" && p.value === "" || f.push(s());
        }, "nodes"), L(q(G(A, f)));
      }
    case "media-query":
      return [G(" ", t.map(s, "nodes")), t.isLast ? "" : ","];
    case "media-type":
      return ye(Y(r.value, e));
    case "media-feature-expression":
      return r.nodes ? ["(", ...t.map(s, "nodes"), ")"] : r.value;
    case "media-feature":
      return Ae(Y(E(!1, r.value, / +/gu, " "), e));
    case "media-colon":
      return [r.value, " "];
    case "media-value":
      return ye(Y(r.value, e));
    case "media-keyword":
      return Y(r.value, e);
    case "media-url":
      return Y(E(!1, E(!1, r.value, /^url\(\s+/giu, "url("), /\s+\)$/gu, ")"), e);
    case "media-unknown":
      return r.value;
    case "selector-root":
      return L([he(t, "custom-selector") ? [t.findAncestor(f => f.type === "css-atrule").customSelector, A] : "", G([",", he(t, ["extend", "custom-selector", "nest"]) ? A : S], t.map(s, "nodes"))]);
    case "selector-selector":
      {
        let f = r.nodes.length > 2;
        return L((f ? q : p => p)(t.map(s, "nodes")));
      }
    case "selector-comment":
      return r.value;
    case "selector-string":
      return Y(r.value, e);
    case "selector-tag":
      return [r.namespace ? [r.namespace === !0 ? "" : r.namespace.trim(), "|"] : "", ((a = t.previous) == null ? void 0 : a.type) === "selector-nesting" ? r.value : ye(Kn(t, r.value) ? r.value.toLowerCase() : r.value)];
    case "selector-id":
      return ["#", r.value];
    case "selector-class":
      return [".", ye(Y(r.value, e))];
    case "selector-attribute":
      return ["[", r.namespace ? [r.namespace === !0 ? "" : r.namespace.trim(), "|"] : "", r.attribute.trim(), r.operator ?? "", r.value ? gi(Y(r.value.trim(), e), e) : "", r.insensitive ? " i" : "", "]"];
    case "selector-combinator":
      {
        if (r.value === "+" || r.value === ">" || r.value === "~" || r.value === ">>>") {
          let l = t.parent;
          return [l.type === "selector-selector" && l.nodes[0] === r ? "" : A, r.value, t.isLast ? "" : " "];
        }
        let f = r.value.trim().startsWith("(") ? A : "",
          p = ye(Y(r.value.trim(), e)) || A;
        return [f, p];
      }
    case "selector-universal":
      return [r.namespace ? [r.namespace === !0 ? "" : r.namespace.trim(), "|"] : "", r.value];
    case "selector-pseudo":
      return [Ae(r.value), ue(r.nodes) ? L(["(", q([D, G([",", A], t.map(s, "nodes"))]), D, ")"]) : ""];
    case "selector-nesting":
      return r.value;
    case "selector-unknown":
      {
        let f = t.findAncestor(d => d.type === "css-rule");
        if (f != null && f.isSCSSNesterProperty) return ye(Y(Ae(r.value), e));
        let p = t.parent;
        if ((c = p.raws) != null && c.selector) {
          let d = N(p),
            x = d + p.raws.selector.length;
          return e.originalText.slice(d, x).trim();
        }
        let l = t.grandparent;
        if (p.type === "value-paren_group" && (l == null ? void 0 : l.type) === "value-func" && l.value === "selector") {
          let d = P(p.open) + 1,
            x = N(p.close),
            h = e.originalText.slice(d, x).trim();
          return Re(h) ? [Xe, h] : h;
        }
        return r.value;
      }
    case "value-value":
    case "value-root":
      return s("group");
    case "value-comment":
      return e.originalText.slice(N(r), P(r));
    case "value-comma_group":
      return di(t, e, s);
    case "value-paren_group":
      return bi(t, e, s);
    case "value-func":
      return [r.value, he(t, "supports") && fi(r) ? " " : "", s("group")];
    case "value-paren":
      return r.value;
    case "value-number":
      return [ss(r.value), rs(r.unit)];
    case "value-operator":
      return r.value;
    case "value-word":
      return r.isColor && r.isHex || jn(r.value) ? r.value.toLowerCase() : r.value;
    case "value-colon":
      {
        let {
          previous: f
        } = t;
        return L([r.value, typeof (f == null ? void 0 : f.value) == "string" && f.value.endsWith("\\") || Ne(t, "url") ? "" : A]);
      }
    case "value-string":
      return At(r.raws.quote + r.value + r.raws.quote, e);
    case "value-atword":
      return ["@", r.value];
    case "value-unicode-range":
      return r.value;
    case "value-unknown":
      return r.value;
    case "value-comma":
    default:
      throw new dn(r, "PostCSS");
  }
}
var Ec = {
    print: _c,
    embed: vn,
    insertPragma: zn,
    massageAstNode: yn,
    getVisitorKeys: _n
  },
  _i = Ec;
var Ei = [{
  name: "CSS",
  type: "markup",
  extensions: [".css", ".wxss"],
  tmScope: "source.css",
  aceMode: "css",
  codemirrorMode: "css",
  codemirrorMimeType: "text/css",
  parsers: ["css"],
  vscodeLanguageIds: ["css"],
  linguistLanguageId: 50
}, {
  name: "PostCSS",
  type: "markup",
  extensions: [".pcss", ".postcss"],
  tmScope: "source.postcss",
  aceMode: "text",
  group: "CSS",
  parsers: ["css"],
  vscodeLanguageIds: ["postcss"],
  linguistLanguageId: 262764437
}, {
  name: "Less",
  type: "markup",
  extensions: [".less"],
  tmScope: "source.css.less",
  aceMode: "less",
  aliases: ["less-css"],
  codemirrorMode: "css",
  codemirrorMimeType: "text/css",
  parsers: ["less"],
  vscodeLanguageIds: ["less"],
  linguistLanguageId: 198
}, {
  name: "SCSS",
  type: "markup",
  extensions: [".scss"],
  tmScope: "source.css.scss",
  aceMode: "scss",
  codemirrorMode: "css",
  codemirrorMimeType: "text/x-scss",
  parsers: ["scss"],
  vscodeLanguageIds: ["scss"],
  linguistLanguageId: 329
}];
var ki = {
  bracketSpacing: {
    category: "Common",
    type: "boolean",
    default: !0,
    description: "Print spaces between brackets.",
    oppositeDescription: "Do not print spaces between brackets."
  },
  objectWrap: {
    category: "Common",
    type: "choice",
    default: "preserve",
    description: "How to wrap object literals.",
    choices: [{
      value: "preserve",
      description: "Keep as multi-line, if there is a newline between the opening brace and first property."
    }, {
      value: "collapse",
      description: "Fit to a single line when possible."
    }]
  },
  singleQuote: {
    category: "Common",
    type: "boolean",
    default: !1,
    description: "Use single quotes instead of double quotes."
  },
  proseWrap: {
    category: "Common",
    type: "choice",
    default: "preserve",
    description: "How to wrap prose.",
    choices: [{
      value: "always",
      description: "Wrap prose if it exceeds the print width."
    }, {
      value: "never",
      description: "Do not wrap prose."
    }, {
      value: "preserve",
      description: "Wrap prose as-is."
    }]
  },
  bracketSameLine: {
    category: "Common",
    type: "boolean",
    default: !1,
    description: "Put > of opening tags on the last line instead of on a new line."
  },
  singleAttributePerLine: {
    category: "Common",
    type: "boolean",
    default: !1,
    description: "Enforce single attribute per line in HTML, Vue and JSX."
  }
};
var kc = {
    singleQuote: ki.singleQuote
  },
  Si = kc;
var Zs = {};
rn(Zs, {
  css: () => My,
  less: () => By,
  scss: () => Uy
});
var hl = be(gt(), 1),
  dl = be(Io(), 1),
  ml = be(ha(), 1);
function cp(t, e) {
  let s = new SyntaxError(t + " (" + e.loc.start.line + ":" + e.loc.start.column + ")");
  return Object.assign(s, e);
}
var da = cp;
var ba = be(xa(), 1);
function Z(t, e, s) {
  if (t && typeof t == "object") {
    delete t.parent;
    for (let r in t) Z(t[r], e, s), r === "type" && typeof t[r] == "string" && !t[r].startsWith(e) && (!s || !s.test(t[r])) && (t[r] = e + t[r]);
  }
  return t;
}
function Ms(t) {
  if (t && typeof t == "object") {
    delete t.parent;
    for (let e in t) Ms(t[e]);
    !Array.isArray(t) && t.value && !t.type && (t.type = "unknown");
  }
  return t;
}
var _p = ba.default.default;
function Ep(t) {
  let e;
  try {
    e = _p(t);
  } catch {
    return {
      type: "selector-unknown",
      value: t
    };
  }
  return Z(Ms(e), "media-");
}
var _a = Ep;
var yu = be(mu(), 1);
function Mm(t) {
  if (/\/\/|\/\*/u.test(t)) return {
    type: "selector-unknown",
    value: t.trim()
  };
  let e;
  try {
    new yu.default(s => {
      e = s;
    }).process(t);
  } catch {
    return {
      type: "selector-unknown",
      value: t
    };
  }
  return Z(e, "selector-");
}
var te = Mm;
var ll = be(sl(), 1);
var Sy = t => {
    for (; t.parent;) t = t.parent;
    return t;
  },
  Fr = Sy;
function Ty(t) {
  return Fr(t).text.slice(t.group.open.sourceIndex + 1, t.group.close.sourceIndex).trim();
}
var nl = Ty;
function Oy(t) {
  if (ue(t)) {
    for (let e = t.length - 1; e > 0; e--) if (t[e].type === "word" && t[e].value === "{" && t[e - 1].type === "word" && t[e - 1].value.endsWith("#")) return !0;
  }
  return !1;
}
var il = Oy;
function Cy(t) {
  return t.some(e => e.type === "string" || e.type === "func" && !e.value.endsWith("\\"));
}
var ol = Cy;
function Ay(t, e) {
  return !!(e.parser === "scss" && (t == null ? void 0 : t.type) === "word" && t.value.startsWith("$"));
}
var al = Ay;
var ul = t => t.type === "paren" && t.value === ")";
function Ny(t, e) {
  var a;
  let {
      nodes: s
    } = t,
    r = {
      open: null,
      close: null,
      groups: [],
      type: "paren_group"
    },
    n = [r],
    i = r,
    o = {
      groups: [],
      type: "comma_group"
    },
    u = [o];
  for (let c = 0; c < s.length; ++c) {
    let f = s[c];
    if (e.parser === "scss" && f.type === "number" && f.unit === ".." && f.value.endsWith(".") && (f.value = f.value.slice(0, -1), f.unit = "..."), f.type === "func" && f.value === "selector" && (f.group.groups = [te(Fr(t).text.slice(f.group.open.sourceIndex + 1, f.group.close.sourceIndex))]), f.type === "func" && f.value === "url") {
      let p = ((a = f.group) == null ? void 0 : a.groups) ?? [],
        l = [];
      for (let d = 0; d < p.length; d++) {
        let x = p[d];
        x.type === "comma_group" ? l = [...l, ...x.groups] : l.push(x);
      }
      (il(l) || !ol(l) && !al(l[0], e)) && (f.group.groups = [nl(f)]);
    }
    if (f.type === "paren" && f.value === "(") r = {
      open: f,
      close: null,
      groups: [],
      type: "paren_group"
    }, n.push(r), o = {
      groups: [],
      type: "comma_group"
    }, u.push(o);else if (ul(f)) {
      if (o.groups.length > 0 && r.groups.push(o), r.close = f, u.length === 1) throw new Error("Unbalanced parenthesis");
      u.pop(), o = $(!1, u, -1), o.groups.push(r), n.pop(), r = $(!1, n, -1);
    } else if (f.type === "comma") {
      if (c === s.length - 3 && s[c + 1].type === "comment" && ul(s[c + 2])) continue;
      r.groups.push(o), o = {
        groups: [],
        type: "comma_group"
      }, u[u.length - 1] = o;
    } else o.groups.push(f);
  }
  return o.groups.length > 0 && r.groups.push(o), i;
}
function $r(t) {
  return t.type === "paren_group" && !t.open && !t.close && t.groups.length === 1 || t.type === "comma_group" && t.groups.length === 1 ? $r(t.groups[0]) : t.type === "paren_group" || t.type === "comma_group" ? {
    ...t,
    groups: t.groups.map($r)
  } : t;
}
function cl(t, e) {
  if (t && typeof t == "object") for (let s in t) s !== "parent" && (cl(t[s], e), s === "nodes" && (t.group = $r(Ny(t, e)), delete t[s]));
  return t;
}
function Py(t, e) {
  if (e.parser === "less" && t.startsWith("~`")) return {
    type: "value-unknown",
    value: t
  };
  let s = null;
  try {
    s = new ll.default(t, {
      loose: !0
    }).parse();
  } catch {
    return {
      type: "value-unknown",
      value: t
    };
  }
  s.text = t;
  let r = cl(s, e);
  return Z(r, "value-", /^selector-/u);
}
var pe = Py;
var Ry = new Set(["import", "use", "forward"]);
function Iy(t) {
  return Ry.has(t);
}
var fl = Iy;
function qy(t, e) {
  return e.parser !== "scss" || !t.selector ? !1 : t.selector.replace(/\/\*.*?\*\//u, "").replace(/\/\/.*\n/u, "").trim().endsWith(":");
}
var pl = qy;
var Ly = /(\s*)(!default).*$/u,
  Dy = /(\s*)(!global).*$/u;
function yl(t, e) {
  var s, r;
  if (t && typeof t == "object") {
    delete t.parent;
    for (let u in t) yl(t[u], e);
    if (!t.type) return t;
    if (t.raws ?? (t.raws = {}), t.type === "css-decl" && typeof t.prop == "string" && t.prop.startsWith("--") && typeof t.value == "string" && t.value.startsWith("{")) {
      let u;
      if (t.value.trimEnd().endsWith("}")) {
        let a = e.originalText.slice(0, t.source.start.offset),
          c = "a".repeat(t.prop.length) + e.originalText.slice(t.source.start.offset + t.prop.length, t.source.end.offset),
          f = E(!1, a, /[^\n]/gu, " ") + c,
          p;
        e.parser === "scss" ? p = vl : e.parser === "less" ? p = wl : p = gl;
        let l;
        try {
          l = p(f, {
            ...e
          });
        } catch {}
        ((s = l == null ? void 0 : l.nodes) == null ? void 0 : s.length) === 1 && l.nodes[0].type === "css-rule" && (u = l.nodes[0].nodes);
      }
      return u ? t.value = {
        type: "css-rule",
        nodes: u
      } : t.value = {
        type: "value-unknown",
        value: t.raws.value.raw
      }, t;
    }
    let n = "";
    typeof t.selector == "string" && (n = t.raws.selector ? t.raws.selector.scss ?? t.raws.selector.raw : t.selector, t.raws.between && t.raws.between.trim().length > 0 && (n += t.raws.between), t.raws.selector = n);
    let i = "";
    typeof t.value == "string" && (i = t.raws.value ? t.raws.value.scss ?? t.raws.value.raw : t.value, t.raws.value = i.trim());
    let o = "";
    if (typeof t.params == "string" && (o = t.raws.params ? t.raws.params.scss ?? t.raws.params.raw : t.params, t.raws.afterName && t.raws.afterName.trim().length > 0 && (o = t.raws.afterName + o), t.raws.between && t.raws.between.trim().length > 0 && (o = o + t.raws.between), o = o.trim(), t.raws.params = o), n.trim().length > 0) return n.startsWith("@") && n.endsWith(":") ? t : t.mixin ? (t.selector = pe(n, e), t) : (pl(t, e) && (t.isSCSSNesterProperty = !0), t.selector = te(n), t);
    if (i.trim().length > 0) {
      let u = i.match(Ly);
      u && (i = i.slice(0, u.index), t.scssDefault = !0, u[0].trim() !== "!default" && (t.raws.scssDefault = u[0]));
      let a = i.match(Dy);
      if (a && (i = i.slice(0, a.index), t.scssGlobal = !0, a[0].trim() !== "!global" && (t.raws.scssGlobal = a[0])), i.startsWith("progid:")) return {
        type: "value-unknown",
        value: i
      };
      t.value = pe(i, e);
    }
    if (e.parser === "less" && t.type === "css-decl" && i.startsWith("extend(") && (t.extend || (t.extend = t.raws.between === ":"), t.extend && !t.selector && (delete t.value, t.selector = te(i.slice(7, -1)))), t.type === "css-atrule") {
      if (e.parser === "less") {
        if (t.mixin) {
          let u = t.raws.identifier + t.name + t.raws.afterName + t.raws.params;
          return t.selector = te(u), delete t.params, t;
        }
        if (t.function) return t;
      }
      if (e.parser === "css" && t.name === "custom-selector") {
        let u = t.params.match(/:--\S+\s+/u)[0].trim();
        return t.customSelector = u, t.selector = te(t.params.slice(u.length).trim()), delete t.params, t;
      }
      if (e.parser === "less") {
        if (t.name.includes(":") && !t.params) {
          t.variable = !0;
          let u = t.name.split(":");
          t.name = u[0], t.value = pe(u.slice(1).join(":"), e);
        }
        if (!["page", "nest", "keyframes"].includes(t.name) && ((r = t.params) == null ? void 0 : r[0]) === ":") {
          t.variable = !0;
          let u = t.params.slice(1);
          u && (t.value = pe(u, e)), t.raws.afterName += ":";
        }
        if (t.variable) return delete t.params, t.value || delete t.value, t;
      }
    }
    if (t.type === "css-atrule" && o.length > 0) {
      let {
          name: u
        } = t,
        a = t.name.toLowerCase();
      return u === "warn" || u === "error" ? (t.params = {
        type: "media-unknown",
        value: o
      }, t) : u === "extend" || u === "nest" ? (t.selector = te(o), delete t.params, t) : u === "at-root" ? (/^\(\s*(?:without|with)\s*:.+\)$/su.test(o) ? t.params = pe(o, e) : (t.selector = te(o), delete t.params), t) : fl(a) ? (t.import = !0, delete t.filename, t.params = pe(o, e), t) : ["namespace", "supports", "if", "else", "for", "each", "while", "debug", "mixin", "include", "function", "return", "define-mixin", "add-mixin"].includes(u) ? (o = o.replace(/(\$\S+?)(\s+)?\.{3}/u, "$1...$2"), o = o.replace(/^(?!if)(\S+)(\s+)\(/u, "$1($2"), t.value = pe(o, e), delete t.params, t) : ["media", "custom-media"].includes(a) ? o.includes("#{") ? {
        type: "media-unknown",
        value: o
      } : (t.params = _a(o), t) : (t.params = o, t);
    }
  }
  return t;
}
function Xs(t, e, s) {
  let r = Ce(e),
    {
      frontMatter: n
    } = r;
  e = r.content;
  let i;
  try {
    i = t(e, {
      map: !1
    });
  } catch (o) {
    let {
      name: u,
      reason: a,
      line: c,
      column: f
    } = o;
    throw typeof c != "number" ? o : da(`${u}: ${a}`, {
      loc: {
        start: {
          line: c,
          column: f
        }
      },
      cause: o
    });
  }
  return s.originalText = e, i = yl(Z(i, "css-"), s), Qr(i, e), n && (n.source = {
    startOffset: 0,
    endOffset: n.raw.length
  }, i.frontMatter = n), i;
}
function gl(t, e = {}) {
  return Xs(hl.default.default, t, e);
}
function wl(t, e = {}) {
  return Xs(s => dl.default.parse(On(s)), t, e);
}
function vl(t, e = {}) {
  return Xs(ml.default, t, e);
}
var Js = {
    astFormat: "postcss",
    hasPragma: Yn,
    hasIgnorePragma: Vn,
    locStart: N,
    locEnd: P
  },
  My = {
    ...Js,
    parse: gl
  },
  By = {
    ...Js,
    parse: wl
  },
  Uy = {
    ...Js,
    parse: vl
  };
var Fy = {
  postcss: _i
};
var s_ = en;
export { s_ as default, Ei as languages, Si as options, Zs as parsers, Fy as printers };